import React, { useEffect, useState } from "react";
import {
  assessmentfileupload,
  assessmentgraphsports,
  attendancedelete,
  blocked,
  deletefileinprofile,
  eventsmasterlist,
  gettokenfromapi,
  mergerornotplayer,
  paymentdetailadmin,
  personaltimingdelete,
  phychologydelete,
  physicalhealthdelete,
  playermappedintotour,
  reasonlist,
  sendpaymentlink,
  similarmergeplayer,
  similarplayerlist,
  similarunmergeplayer,
  sportsactivelist,
  sportsprofiledetaildelete,
  tourparticipatedplayerlist,
  unblocked,
  viewpersonaltimingapi,
  viewprofile,
  viewprofilepassword,
} from "../../../../services/superadmin";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Col, Form, Modal, Row, Table } from "react-bootstrap";
import { schoolviewplayer } from "../../../../services/schoolhead";
import {
  citymergerornotplayer,
  cityplayerview,
  citysendpaymentlink,
  citysimilarmergeplayer,
  citysimilarunmergeplayer,
  crmsportslist,
  schooldetailcityreg,
} from "../../../../services/cityregionaladmin";
import moment, { max } from "moment";
import { AgGridReact } from "ag-grid-react";
import { useMemo } from "react";
import Swal from "sweetalert2";
import dotracking from "../../../trackinglogs";
import trackobj from "../../../trackingpages.json";
import { coachplayerview, coachsportslist } from "../../../../services/coach";
import { funderplayerdetail } from "../../../../services/funder";
import {
  playerotherachievementlist,
  Playerprofiledetails,
} from "../../../../services/player";
import { sahassessmentdatelist } from "../../../../services/sahapi";
import {
  playerformlist,
  playersportcatelist,
  profileyeargraph,
} from "../../../../services/common";
import { Bar, Line, Radar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from 'chart.js';
import {
  sportslist,
  sportwisetypeparameterlist,
} from "../../../../services/master";
import Select from "react-select";
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(ChartDataLabels);

// Register Chart.js components
ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

// Custom plugin for individual axis scales
const customAxisScalesPlugin = {
  id: 'customAxisScales',
  afterDraw: function (chart) {
    if (!chart.config.options.customAxisScales) return;

    const ctx = chart.ctx;
    const chartArea = chart.chartArea;
    const centerX = (chartArea.left + chartArea.right) / 2;
    const centerY = (chartArea.top + chartArea.bottom) / 2;
    const radius = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top) / 2 - 50;

    const axisScales = chart.config.options.customAxisScales.axisScales;
    const axisLabels = chart.config.options.customAxisScales.axisLabels;
    const globalMax = chart.config.options.customAxisScales.globalMax;

    ctx.save();
    ctx.font = '10px Arial';
    ctx.textAlign = 'center';
    ctx.fillStyle = '#666';

    // Draw scale values for each axis based on actual positioning
    axisLabels.forEach((label, axisIndex) => {
      const angle = (axisIndex * 2 * Math.PI) / axisLabels.length - Math.PI / 2;
      const scale = axisScales[axisIndex];

      // Draw scale markers that align with actual data positioning
      const numTicks = 4;
      for (let i = 1; i <= numTicks; i++) {
        // Use the padded maximum that's actually used for normalization
        const scaleValue = (scale.max * i) / numTicks;

        const tickRadius = (radius * i) / numTicks;

        // Calculate position for scale label
        const offsetDistance = 12;
        const labelX = centerX + Math.cos(angle) * (tickRadius + offsetDistance);
        const labelY = centerY + Math.sin(angle) * (tickRadius + offsetDistance);

        // Format scale value based on axis type
        // Check if axis label contains 'sec' or 'time' for decimal formatting
        const isTimeAxis = label.toLowerCase().includes('sec') || label.toLowerCase().includes('time');
        const valueText = isTimeAxis ? scaleValue.toFixed(1) : Math.round(scaleValue).toString();

        // Draw scale value with background for better visibility
        ctx.fillStyle = 'rgba(255, 255, 255, 0.9)';
        const textWidth = ctx.measureText(valueText).width;
        ctx.fillRect(labelX - textWidth / 2 - 2, labelY - 6, textWidth + 4, 12);

        // Draw the scale value text
        ctx.fillStyle = '#666';
        ctx.fillText(valueText, labelX, labelY + 2);
      }
    });

    ctx.restore();
  }
};

// Register the custom plugin
ChartJS.register(customAxisScalesPlugin);

export const Viewathlete = () => {
  const { id, eid } = useParams();
  const navigate = useNavigate();
  const [fname, setFName] = useState("");
  const [lname, setLName] = useState("");
  const [dob, setDOB] = useState("");
  const [gender, setGender] = useState("");
  const [email, setEmail] = useState("");
  const [father, setFather] = useState("");
  const [mobno, setMobNo] = useState("");
  const [uname, setUser] = useState("");
  const [pass, setPass] = useState("");
  const [afile, setAFile] = useState("");

  const [status, setStatus] = useState("");
  const [school, setSchool] = useState("");
  const [schid, setSchoolId] = useState("");

  const [clsname, setClass] = useState("");
  const [secname, setSection] = useState("");

  const [pstatus, setPStatus] = useState("");
  const [doj, setDOJ] = useState("");

  const [regdate, setRegDate] = useState("");

  const [realist, setReaList] = useState([]);
  const [rreason, setRReason] = useState("");
  const [rremark, setRemarks] = useState("");

  const [urlhead, setUrl] = useState("");

  const [maplist, setMapList] = useState([]);
  const [simlist, setSimList] = useState([]);
  const [filterProduct, setFilterProduct] = useState([]);

  const [fitList, setFitList] = useState([]);
  const [skillList, setSkillList] = useState([]);
  const [assdate, setAssDate] = useState("");
  const [skildate, setSkillDate] = useState("");

  const [gdata, setGData] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState("");
  const currentYear = new Date().getFullYear();
  const [tyear, setTYear] = useState(currentYear);
  const lastYear = currentYear - 1;
  // const pdata = {
  //   labels: ["2020", "2021", "2022", "2023", "2024"],
  //   datasets: [
  //     {
  //       label: "Medals",
  //       data: [90, 126, 144, 235, 45],
  //       backgroundColor: "#f74dc1",
  //       // backgroundColor: "rgba(247, 77, 193, 0.2)",  // Transparent background (20% opacity)
  //       // borderColor: "#f74dc1",                       // Border color (solid pink)
  //       // borderWidth: 2,                               // Border width
  //       // pointBackgroundColor: "#f74dc1",              // Point color (solid pink)
  //       // pointBorderColor: "#ffffff",                  // Point border color
  //       // pointRadius: 5,                               // Point size
  //     },
  //     {
  //       label: "Participation",
  //       data: [39, 26, 75, 208, 80],
  //       backgroundColor: "#2977ff",
  //     },
  //   ],
  // };

  // labels: {
  //   generateLabels: function(chart) {
  //     const labels = chart.data.datasets.map((dataset, index) => {
  //       return {
  //         text: dataset.label,
  //         fillStyle: dataset.backgroundColor,
  //         hidden: dataset.hidden,
  //         index: index,
  //       };
  //     });
  //     return Array.from(new Set(labels.map(label => label.text)))
  //       .map(text => labels.find(label => label.text === text));
  //   }
  // }

  const RadarData = {
    labels: ["Football", "Volleyball", "Athletics", "Archery", "Cricket"],
    datasets: [
      {
        label: "Football",
        backgroundColor: "rgba(34, 202, 236, .2)",
        fill: true,
        borderColor: "rgba(34, 202, 236, 1)",
        hoverBorderColor: "blue",
        pointBackgroundColor: "rgba(34, 202, 236, 1)",
        poingBorderColor: "#fff",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "rgba(34, 202, 236, 1)",
        data: [13, 15, 12, 6, 10],
      },
      {
        label: "Volleyball",
        backgroundColor: "rgba(54, 162, 235, 0.2)",
        fill: true,
        backgroundColor: "rgba(255, 99, 132, 0.2)",
        borderColor: "rgb(255, 99, 132)",
        pointBackgroundColor: "rgb(255, 99, 132)",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "rgb(255, 99, 132)",
        data: [8, 7, 16, 12, 15],
      },
    ],
  };

  const sorting = useMemo(() => {
    return ["asc", "desc"];
  }, []);
  const columnDefs = [
    {
      headerName: "Actions",
      width: 150,
      field: "link",
      resizable: true,
      filter: false,
      cellRenderer: function (params) {
        if (localStorage.getItem("Role") === "4") {
          if (params.value === "Link") {
            return (
              <div className="text-center">
                <a className="text-success">-</a>
              </div>
            );
          } else if (params.value !== "") {
            return (
              <div className="text-center">
                <a className="text-danger">{params.value}</a>
              </div>
            );
          }
        } else if (localStorage.getItem("Role") === "5") {
          if (params.value === "Link") {
            return (
              <div className="text-center">
                <a className="text-success">-</a>
              </div>
            );
          } else if (params.value !== "") {
            return (
              <div className="text-center">
                <a className="text-danger">{params.value}</a>
              </div>
            );
          }
        } else {
          if (params.value === "Link") {
            return (
              <div className="text-center">
                <a
                  className="btn-sm btn-success"
                  onClick={() => sendpayment(params)}
                >
                  Send Payment Link
                </a>
              </div>
            );
          } else if (params.value !== "") {
            return (
              <div className="text-center">
                <a className="text-danger">{params.value}</a>
              </div>
            );
          }
        }
      },
    },
    {
      headerName: "Tournament Name",
      width: 300,
      field: "meet_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Code",
      width: 150,
      field: "meet_code",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Level",
      width: 150,
      field: "meet_level",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Location",
      width: 170,
      field: "location",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Start Date",
      width: 150,
      field: "start_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        if (params.value !== null && params.value !== "") {
          return moment(params.value).format("DD-MM-yyyy");
        }
      },
    },
    {
      headerName: "End Date",
      width: 150,
      field: "end_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        if (params.value !== null && params.value !== "") {
          return moment(params.value).format("DD-MM-yyyy");
        }
      },
    },
    {
      headerName: "Entry Open",
      width: 150,
      field: "entry_open",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        if (params.value !== null && params.value !== "") {
          return moment(params.value).format("DD-MM-yyyy");
        }
      },
    },
    {
      headerName: "Deadline Date",
      width: 150,
      field: "entry_deadline_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        if (params.value !== null && params.value !== "") {
          return moment(params.value).format("DD-MM-yyyy");
        }
      },
    },

    {
      headerName: "Sports",
      width: 150,
      field: "sports_type",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },

    {
      headerName: "School",
      width: 170,
      field: "school_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },

    {
      headerName: "Payment",
      width: 150,
      field: "pay_status",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Payment ID",
      width: 150,
      field: "payment_id",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Order ID",
      width: 150,
      field: "order_id",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Payment Date",
      width: 190,
      field: "payment_date_time",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        if (params.value !== null && params.value !== "") {
          return moment(params.value).format("DD-MM-yyyy h:mm:ss A");
        }
      },
    },
  ];

  const columnPDefs = [
    {
      headerName: "Tournament",
      field: "meet_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Level",
      field: "level",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Tournament Date",
      field: "start_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        if (params.value !== null) {
          return moment(params.value).format("DD-MM-yyyy");
        }
      },
    },
    {
      headerName: "Sports",
      field: "sports_type",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Event",
      field: "event",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Age Group",
      field: "category_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },

    {
      headerName: "Position",
      field: "position",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  const columnADefs = [
    {
      headerName: "Action",
      field: "date",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              title="Assessment Detail"
              className="btn-sm btn-secondary"
              onClick={() => viewasslist(params.value)}
            >
              <i className="fa fa-eye fa-lg"></i>
            </a>
          </div>
        );
      },
    },
    {
      headerName: "Assessment Date",
      field: "date",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        if (params.value !== null) {
          let origString = params.value;
          let stringToAdd = "-";
          let indexPosition = 2;
          let newString1 =
            origString.slice(0, indexPosition) +
            stringToAdd +
            origString.slice(indexPosition);
          let indexPosition1 = 5;
          let newString =
            newString1.slice(0, indexPosition1) +
            stringToAdd +
            newString1.slice(indexPosition1);
          return newString;
        }
      },
    },
    {
      headerName: "School",
      field: "school_name",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Class",
      field: "std",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Section",
      field: "section",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Height (Cms)",
      field: "height",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Weight (Kg)",
      field: "weight",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Grade",
      field: "overall_grade",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
    },
  ];

  const columnAtDefs = [
    ...(localStorage.getItem("Role") === "1"
      ? [
        {
          headerName: "Action",
          field: "id",
          width: 100,
          sortable: true,
          resizable: true,
          filter: false,
          floatingFilter: false,
          cellStyle: { textAlign: "left" },
          cellRenderer: function (params) {
            return (
              <div className="text-center">
                <a
                  title="Personal Timings Delete"
                  className="btn btn-sm btn-danger"
                  onClick={() => deleteattendance(params.value, params.data)}
                >
                  <i className="fa fa-trash fa-lg"></i>
                </a>
              </div>
            );
          },
        },
      ]
      : []),
    {
      headerName: "Date",
      field: "attendance_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        if (params.value !== null) {
          return moment(params.value).format("DD-MM-yyyy");
        }
      },
    },
    {
      headerName: "Present / Absent",
      field: "present_or_absent",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  const columnPtDefs = [
    ...(localStorage.getItem("Role") === "1"
      ? [
        {
          headerName: "Action",
          field: "id",
          width: 80,
          sortable: true,
          resizable: true,
          filter: false,
          floatingFilter: false,
          cellStyle: { textAlign: "left" },
          cellRenderer: function (params) {
            return (
              <div className="text-center">
                <a
                  title="Personal Timings Delete"
                  className="btn btn-sm btn-danger"
                  onClick={() => deletetiming(params.value, params.data)}
                >
                  <i className="fa fa-trash fa-lg"></i>
                </a>
              </div>
            );
          },
        },
      ]
      : []),
    {
      headerName: "Sports",
      field: "sports_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Event",
      field: "event_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Timing With Timestamp",
      field: "timing_timestamp",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Record Date",
      field: "record_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Remarks",
      field: "assessment_remarks",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Event Type",
      field: "competition_training",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Target",
      field: "target",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  const columnPhDefs = [
    ...(localStorage.getItem("Role") === "1"
      ? [
        {
          headerName: "Action",
          field: "id",
          width: 80,
          sortable: true,
          resizable: true,
          filter: false,
          floatingFilter: false,
          cellStyle: { textAlign: "left" },
          cellRenderer: function (params) {
            return (
              <div className="text-center">
                <a
                  title="Physical Health Delete"
                  className="btn btn-sm btn-danger"
                  onClick={() => deletehealth(params.value, params.data)}
                >
                  <i className="fa fa-trash fa-lg"></i>
                </a>
              </div>
            );
          },
        },
      ]
      : []),
    {
      headerName: "Height (Cms)",
      field: "height",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Weight (Kgs)",
      field: "weight",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Body Mass Index",
      field: "body_mass_index",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Past injuries",
      field: "past_injuries",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Diet Chart with Dietary Preferences/Restrictions",
      field: "diet_chart",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Known health conditions",
      field: "known_health",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Record Date",
      field: "record_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  function sendpayment(datas) {
    Swal.fire({
      title: "Are you sure want to send a payment link to respective email?",
      showCancelButton: true,
      confirmButtonColor: "#d71635",
      confirmButtonText: "Ok",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        if (localStorage.getItem("Role") === "1") {
          dotracking(
            "send payment link in view player for tournament " +
            datas.data.id +
            " in player " +
            fname +
            " (" +
            uname +
            " - " +
            datas.data.user_id +
            ") $$ " +
            trackobj.playerdetheading
          );
          sendpaymentlink(datas.data.id, datas.data.user_id).then(
            (response) => {
              if (response.status === true) {
                toast.success(response.message);
              }
            }
          );
        } else if (localStorage.getItem("Role") === "3") {
          dotracking(
            "send payment link in view player for tournament " +
            datas.data.id +
            " in player " +
            datas.data.first_name +
            " (" +
            datas.data.username +
            " - " +
            datas.data.user_id +
            ") $$ " +
            trackobj.playerdetheading
          );
          citysendpaymentlink(datas.data.id, datas.data.user_id).then(
            (response) => {
              if (response.status === true) {
                toast.success(response.message);
              }
            }
          );
        }
      }
    });
  }
  const [sishow, setSiShow] = useState("");

  const [tname, setTName] = useState("");
  const [ordid, setOrdID] = useState("");
  const [payid, setPayID] = useState("");
  const [paydate, setPayDate] = useState("");
  const [payst, setPayst] = useState("");
  const [payamt, setPayAmt] = useState(0);

  const [assList, setAssList] = useState([]);

  const [flist, setFList] = useState([]);
  const [fpath, setFPath] = useState("");

  const [spclist, setSCList] = useState([]);

  const [slist, setSList] = useState([]);
  const [usport, setUSport] = useState("");
  const [grdata, setGRData] = useState(null);
  useEffect(() => {
    const url = window.location.href;
    const head = url.split("/#/");
    const link = head[1].split("/");

    setUrl(link[1]);
    if (link[1] === "paymentdetail") {
      paymentdetailadmin(id).then((response) => {
        if (response.status === true) {
          setFName(response.data.first_name);
          setLName(response.data.last_name);
          if (response.data.date_of_birth !== null) {
            setDOB(moment(response.data.date_of_birth).format("DD-MM-yyyy"));
          }
          setPStatus(response.data.playerlist.active_or_passive);
          if (response.data.playerlist.date_of_join !== null) {
            setDOJ(
              moment(response.data.playerlist.date_of_join).format("DD-MM-yyyy")
            );
          }
          setGender(response.data.gender);
          setEmail(response.data.email_id);
          setFather(response.data.father_name);
          setMobNo(response.data.mobile_no);
          setUser(response.data.username);
          setStatus(response.data.status);
          setSchool(response.data.school_name);
          setSchoolId(response.data.school_id);
          setClass(response.data.class_name);
          setSection(response.data.section);

          setTName(response.data.meet_name);
          setOrdID(response.data.order_id);
          setPayID(response.data.payment_id);
          if (response.data.payment_date_time !== null) {
            setPayDate(
              moment(response.data.payment_date_time).format(
                "DD-MM-yyyy h:mm:ss A"
              )
            );
          }
          setPayst(response.data.pay_status);
          setPayAmt(response.data.registration_fees);
        }
      });

      viewprofile(id, currentYear).then((response) => {
        // if (response.data.playerlist.photograph !== null) {
        //   setPhoto(
        //     response.data.photo_path + response.data.playerlist.photograph
        //   );
        // }
      });
    } else {
      if (localStorage.getItem("Role") === "1") {
        reasonlist().then((res) => {
          if (res.status === true) {
            setReaList(res.data);
          }
        });
        mergerornotplayer(id).then((response) => {
          if (response.status === false) {
            setSiShow(response.data.msg);
          }
        });
        sportsactivelist().then((response) => {
          if (response.status === true) {
            setSList(response.data);
          }
        });
      } else if (localStorage.getItem("Role") === "3") {
        citymergerornotplayer(id).then((response) => {
          if (response.status === false) {
            setSiShow(response.data.msg);
          }
        });
        crmsportslist().then((response) => {
          if (response.status === true) {
            setSList(response.data);
          }
        });
      } else if (localStorage.getItem("Role") === "7") {
        coachsportslist().then((response) => {
          if (response.status === true) {
            setSList(response.data);
          }
        });
      } else {
        sportslist().then((response) => {
          if (response.status === true) {
            setSList(response.data);
          }
        });
      }
      listsimilar(currentYear);
      if (localStorage.getItem("Role") !== "8") {
        tourparticipatedplayerlist(id).then((response) => {
          if (response.status === true) {
            let arr = [];
            if (response.data.details.length !== 0) {
              for (let i = 0; i < response.data.details.length; i++) {
                var lnk = "";
                if (response.data.details[i].payment_status === "1") {
                  lnk = "Paid";
                }
                if (response.data.details[i].payment_status === "0") {
                  if (
                    moment(new Date()).format("yyyy-MM-DD") <=
                    response.data.details[i].entry_deadline_date
                  ) {
                    lnk = "Link";
                  } else {
                    lnk = "Entry Closed";
                  }
                }

                arr.push({
                  meet_name: response.data.details[i].meet_name,
                  meet_level: response.data.details[i].meet_level,
                  age_group: "",
                  meet_code: response.data.details[i].meet_code,
                  location: response.data.details[i].location,
                  start_date: response.data.details[i].start_date,
                  end_date: response.data.details[i].end_date,
                  entry_open: response.data.details[i].entry_open,
                  entry_deadline_date:
                    response.data.details[i].entry_deadline_date,
                  sports_type: response.data.details[i].sports_type,
                  school_name: response.data.details[i].school_name,
                  pay_status: response.data.details[i].pay_status,
                  payment_id: response.data.details[i].payment_id,
                  order_id: response.data.details[i].order_id,
                  payment_date_time: response.data.details[i].payment_date_time,
                  id: response.data.details[i].id,
                  user_id: response.data.details[i].user_id,
                  link: lnk,
                });
              }
            }

            if (response.data.achievement_tournaments.length !== 0) {
              for (
                let i = 0;
                i < response.data.achievement_tournaments.length;
                i++
              ) {
                arr.push({
                  meet_name: response.data.achievement_tournaments[i].meet_name,
                  meet_level:
                    response.data.achievement_tournaments[i].meet_level,
                  age_group: response.data.achievement_tournaments[i].age_group,
                  meet_code: "",
                  location: "",
                  start_date:
                    response.data.achievement_tournaments[i].meet_date,
                  end_date: "",
                  entry_open: "",
                  entry_deadline_date: "",
                  sports_type:
                    response.data.achievement_tournaments[i].sports_type,
                  school_name: "",
                  pay_status: "",
                  payment_id: "",
                  order_id: "",
                  payment_date_time: "",
                  id: "",
                  user_id: "",
                  link: "",
                });
              }
            }

            setFilterProduct(arr);
          }
        });

        playermappedintotour(id).then((response) => {
          if (response.status === true) {
            setMapList(response.data);
          }
        });
      }
    }

    playerformlist(id).then((res) => {
      if (res.status === true) {
        setFList(res.data.form_images);
        setFPath(res.data.form_path);
      }
    });

    playersportcatelist(id).then((res) => {
      if (res.status === true) {
        setSCList(res.data.form_images);
      }
    });
  }, []);
  const [ropts, setROptn] = useState(null);
  const [glist, setGList] = useState([]);

  const getRandomColor = () => {
    const r = Math.floor(Math.random() * 255);
    const g = Math.floor(Math.random() * 255);
    const b = Math.floor(Math.random() * 255);
    return {
      // backgroundColor: `rgba(${r}, ${g}, ${b}, 0.4)`,
      // borderColor: `rgba(${r}, ${g}, ${b}, 1)`,
      // pointBackgroundColor: `rgba(${r}, ${g}, ${b}, 1)`,
      backgroundColor: `rgba(${r}, ${g}, ${b}, 0.2)`, // semi-transparent fill
      borderColor: `rgba(${r}, ${g}, ${b}, 0.9)`, // strong line color
      pointBackgroundColor: `rgba(${r}, ${g}, ${b}, 1)`, // point fill
      pointBorderColor: `rgba(${r}, ${g}, ${b}, 1)`, // point border
      pointHoverBackgroundColor: `rgba(${r}, ${g}, ${b}, 1)`,
      pointHoverBorderColor: `rgba(${r}, ${g}, ${b}, 1)`,
    };
  };
  const [asstype, setAssType] = useState("");
  const [tlist, setTList] = useState([]);
  const [currentParamIndex, setCurrentParamIndex] = useState(0);
  const [allParameterData, setAllParameterData] = useState([]);

  function loadsport(e) {
    setUSport(e.target.value);
    setAssType("");
    setTList([]);
    setCurrentParamIndex(0);
    setAllParameterData([]);

    if (e.target.value !== null) {
      sportwisetypeparameterlist(e.target.value).then((response) => {
        if (response.status === true) {
          setTList(response.data.sportsParameters);
          if (response.data.sportsParameters.length == 0) {
            loadgraph(e.target.value, "");
          } else if ((localStorage.getItem("Role") === "4" || localStorage.getItem("Role") === "7" || localStorage.getItem("Role") === "8") && response.data.sportsParameters.length > 0) {
            // For roles 4, 7, and 8, set to "All" and load all parameter types
            setAssType("all");
            loadAllParameterTypes(e.target.value, response.data.sportsParameters);
          }
        }
      });
    }
  }

  // Function to load all parameter types for roles 4, 7, and 8
  async function loadAllParameterTypes(sportId, parameters) {
    const allData = [];

    for (let i = 0; i < parameters.length; i++) {
      const temp = new FormData();
      temp.append("sports_id", sportId);
      temp.append("user_id", id);
      temp.append("assessment_type_id", parameters[i].id);

      try {
        const res = await assessmentgraphsports(temp);
        if (res.status === true) {
          allData.push({
            parameterType: parameters[i],
            data: res.data
          });
        }
      } catch (error) {
        console.error("Error loading parameter type:", parameters[i].parameter_type, error);
      }
    }

    setAllParameterData(allData);
  }

  // Handle parameter type change for roles 4, 7, and 8
  function handleParameterTypeChange(e) {
    const value = e.target.value;
    setAssType(value);

    if (value === "all") {
      // Load all parameter types
      if (allParameterData.length === 0) {
        loadAllParameterTypes(usport, tlist);
      }
    } else {
      // Load single parameter type
      loadgraph(usport, e);
    }
  }

  const [paramList, setParamList] = useState([]);

  // Helper function to process single parameter type data for role 4
  function processParameterData(paramData) {
    const res = { status: true, data: paramData.data };

    if (!res.data || !res.data.physical_assessment || res.data.physical_assessment.length === 0) {
      return null;
    }

    if (!res.data.physical_assessment[0]?.assessments || res.data.physical_assessment[0].assessments.length === 0) {
      return null;
    }

    const parameterInfo = res.data?.physical_assessment[0]?.assessments.map(
      (assessment) => ({
        name: assessment.parameter_name,
        desc: assessment.parameter_type_description?.replace(/\r\n/g, '<br/>')
      })
    );

    const axisLabels = res.data?.physical_assessment[0]?.assessments.map(
      (assessment) => assessment.parameter_name
    );

    const datasets = res.data.physical_assessment.map(
      (assessmentData, dateIndex) => {
        const date = assessmentData.record_date;
        const data = assessmentData.assessments.map((assessment, paramIndex) => {
          let value = parseFloat(assessment.parameter_value) || 0;

          if (dateIndex > 0) {
            const previousValue =
              parseFloat(
                res.data.physical_assessment[dateIndex - 1]?.assessments?.[paramIndex]
                  ?.parameter_value
              ) || 0;

            if (value === previousValue) {
              value += dateIndex * 0.05;
            }
          }

          return value;
        });

        const color = getRandomColor();
        return {
          label: moment(date).format("DD-MM-YYYY"),
          data: data,
          backgroundColor: color.backgroundColor,
          borderColor: color.borderColor,
          pointBackgroundColor: color.pointBackgroundColor,
          pointBorderColor: color.borderColor,
          pointHoverBackgroundColor: color.pointHoverBackgroundColor,
          pointHoverBorderColor: color.pointHoverBorderColor,
          pointRadius: 5,
          pointHoverRadius: 7,
          borderWidth: 2,
          fill: false,
          borderDash: dateIndex % 2 === 0 ? [5, 5] : [],
        };
      }
    );

    const axisScales = axisLabels.map((label, axisIndex) => {
      const axisValues = datasets.flatMap(dataset => dataset.data[axisIndex] || 0);
      const maxVal = Math.max(...axisValues);
      const paddedMax = Math.ceil(maxVal * 1.1);

      return {
        min: 0,
        max: paddedMax,
        actualMax: maxVal,
        stepSize: Math.ceil(paddedMax / 5)
      };
    });

    const globalMax = Math.max(...axisScales.map(scale => scale.max));
    const globalStepSize = Math.ceil(globalMax / 5);

    const originalDataAndScales = {
      datasets: datasets,
      axisScales: axisScales,
      axisLabels: axisLabels
    };

    const normalizedDatasets = datasets.map(dataset => {
      const normalizedData = dataset.data.map((value, axisIndex) => {
        const scale = axisScales[axisIndex];
        return (value / scale.max) * globalMax;
      });

      return {
        ...dataset,
        data: normalizedData
      };
    });

    const RadarOptions = {
      responsive: true,
      maintainAspectRatio: false,
      customAxisScales: {
        axisScales: axisScales,
        axisLabels: axisLabels,
        globalMax: globalMax
      },
      scales: {
        r: {
          beginAtZero: true,
          suggestedMin: 0,
          suggestedMax: globalMax,
          ticks: {
            display: false,
            stepSize: globalStepSize,
            color: '#444',
            backdropColor: 'transparent',
            z: 1,
            showLabelBackdrop: false,
            callback: function (value, index, values) {
              return value;
            }
          },
          pointLabels: {
            display: true,
            color: '#222',
            callback: function (label, index) {
              const scale = axisScales[index];
              return `${label}`;
            }
          },
          grid: {
            circular: false,
            color: '#ccc',
          },
          angleLines: {
            display: true,
            color: '#bbb',
          },
        },
      },
      plugins: {
        tooltip: {
          position: 'nearest',
          yAlign: 'top',
          xAlign: 'center',
          caretPadding: 10,
          displayColors: false,
          callbacks: {
            title: () => '',
            label: function (tooltipItem) {
              const datasetIndex = tooltipItem.datasetIndex;
              const axisIndex = tooltipItem.dataIndex;
              const axisLabel = originalDataAndScales.axisLabels[axisIndex];
              const originalValue = originalDataAndScales.datasets[datasetIndex]?.data[axisIndex];
              const isTimeAxis = axisLabel.toLowerCase().includes('sec') || axisLabel.toLowerCase().includes('time');
              const formattedValue = isTimeAxis ? originalValue.toFixed(1) : Math.round(originalValue).toString();
              return `${axisLabel}: ${formattedValue}`;
            },
          },
        },
        legend: {
          display: true,
          position: 'top',
          labels: {
            filter: function (item, chart) {
              return item.text !== undefined;
            }
          }
        },
        title: {
          display: true,
          position: 'bottom',
          font: {
            size: 10
          },
          color: '#666'
        },
        datalabels: {
          display: (context) => {
            return true;
          },
          color: (context) => {
            return context.dataset.borderColor || 'black';
          },
          align: (context) => {
            const datasetIndex = context.datasetIndex;
            const alignments = ['end', 'start', 'right', 'left'];
            return alignments[datasetIndex % alignments.length];
          },
          anchor: 'center',
          offset: (context) => {
            return 8 + (context.datasetIndex * 12);
          },
          font: {
            weight: 'bold',
            size: 8,
          },
          backgroundColor: (context) => {
            return 'rgba(255, 255, 255, 0.7)';
          },
          borderRadius: 3,
          padding: 2,
          formatter: function (value, context) {
            const datasetIndex = context.datasetIndex;
            const axisIndex = context.dataIndex;
            const originalValue = originalDataAndScales.datasets[datasetIndex]?.data[axisIndex];

            if (originalValue === undefined || originalValue === null) {
              return '';
            }

            const axisLabel = originalDataAndScales.axisLabels[axisIndex];
            const isTimeAxis = axisLabel.toLowerCase().includes('sec') || axisLabel.toLowerCase().includes('time');

            if (isTimeAxis) {
              return originalValue.toFixed(2);
            }
            return Number.isInteger(originalValue) ? originalValue : originalValue.toFixed(2);
          }
        }
      },
    };

    const normalizedRadarData = {
      labels: axisLabels,
      datasets: normalizedDatasets,
    };

    return {
      radarData: normalizedRadarData,
      radarOptions: RadarOptions,
      parameterInfo: parameterInfo,
      physicalAssessment: res.data.physical_assessment
    };
  }

  // Extracted function to process graph data
  function loadGraphData(res) {
    if (!res.data || !res.data.physical_assessment || res.data.physical_assessment.length === 0) {
      // Handle invalid response - set empty data
      setGRData({ labels: [], datasets: [] });
      setROptn(null);
      return;
    }

    // Check if assessments exist
    if (!res.data.physical_assessment[0]?.assessments || res.data.physical_assessment[0].assessments.length === 0) {
      setGRData({ labels: [], datasets: [] });
      setROptn(null);
      return;
    }

    setGList(res.data.physical_assessment);
    const parameterInfo = res.data?.physical_assessment[0]?.assessments.map(
      (assessment) => ({
        name: assessment.parameter_name,
        desc: assessment.parameter_type_description?.replace(/\r\n/g, '<br/>')
      })
    );
    setParamList(parameterInfo);
    const axisLabels = res.data?.physical_assessment[0]?.assessments.map(
      (assessment) => assessment.parameter_name
    );

    // Generate the datasets for the radar chart
    const datasets = res.data.physical_assessment.map(
      (assessmentData, dateIndex) => {
        const date = assessmentData.record_date;
        const data = assessmentData.assessments.map((assessment, paramIndex) => {
          let value = parseFloat(assessment.parameter_value) || 0;

          if (dateIndex > 0) {
            const previousValue =
              parseFloat(
                res.data.physical_assessment[dateIndex - 1]?.assessments?.[paramIndex]
                  ?.parameter_value
              ) || 0;

            if (value === previousValue) {
              value += dateIndex * 0.05; // Small offset
            }
          }

          return value;
        });

        const color = getRandomColor(); // Get a random color for the dataset
        return {
          label: moment(date).format("DD-MM-YYYY"),
          data: data,
          backgroundColor: color.backgroundColor,
          borderColor: color.borderColor,
          pointBackgroundColor: color.pointBackgroundColor,
          pointBorderColor: color.borderColor,
          pointHoverBackgroundColor: color.pointHoverBackgroundColor,
          pointHoverBorderColor: color.pointHoverBorderColor,
          pointRadius: 5, // <-- Make points visible
          pointHoverRadius: 7,
          borderWidth: 2,
          fill: false,
          borderDash: dateIndex % 2 === 0 ? [5, 5] : [],
        };
      }
    );

    // Prepare the radar data structure
    const radarData = {
      labels: axisLabels, // Use parameter names as axis labels
      datasets: datasets,
    };

    // Calculate individual scale values for each axis
    const axisScales = axisLabels.map((label, axisIndex) => {
      // Get all values for this specific axis across all datasets
      const axisValues = datasets.flatMap(dataset => dataset.data[axisIndex] || 0);
      const minVal = Math.min(...axisValues);
      const maxVal = Math.max(...axisValues);

      // Use a more conservative approach to avoid misalignment
      // Round up to a nice number to ensure data fits properly
      const paddedMax = Math.ceil(maxVal * 1.1); // 10% padding, rounded up

      return {
        min: 0,
        max: paddedMax,
        actualMax: maxVal, // Store the actual maximum data value
        stepSize: Math.ceil(paddedMax / 5)
      };
    });

    // For radar charts, we need to normalize data to a common scale since Chart.js uses single radial scale
    // We'll use the maximum scale across all axes and normalize the data
    const globalMax = Math.max(...axisScales.map(scale => scale.max));
    const globalStepSize = Math.ceil(globalMax / 5);

    // Store original data and scales for tooltip purposes
    const originalDataAndScales = {
      datasets: datasets,
      axisScales: axisScales,
      axisLabels: axisLabels
    };

    // Normalize datasets based on individual axis scales
    const normalizedDatasets = datasets.map(dataset => {
      const normalizedData = dataset.data.map((value, axisIndex) => {
        const scale = axisScales[axisIndex];
        return (value / scale.max) * globalMax;
      });

      return {
        ...dataset,
        data: normalizedData
      };
    });

    const RadarOptions = {
      responsive: true,
      maintainAspectRatio: false,
      // Pass custom data to the plugin
      customAxisScales: {
        axisScales: axisScales,
        axisLabels: axisLabels,
        globalMax: globalMax
      },
      scales: {
        r: {
          beginAtZero: true,
          suggestedMin: 0,
          suggestedMax: globalMax,
          ticks: {
            display: false, // Hide default ticks to avoid duplication with custom plugin
            stepSize: globalStepSize,
            color: '#444',
            backdropColor: 'transparent',
            z: 1,
            showLabelBackdrop: false,
            callback: function (value, index, values) {
              return value;
            }
          },
          pointLabels: {
            display: true,

            color: '#222',
            callback: function (label, index) {
              const scale = axisScales[index];
              return `${label}`;
            }
          },
          grid: {
            circular: false,
            color: '#ccc',
          },
          angleLines: {
            display: true,
            color: '#bbb',
          },
        },
      },
      plugins: {
        tooltip: {
          position: 'nearest',
          yAlign: 'top',
          xAlign: 'center',
          caretPadding: 10,
          displayColors: false,
          callbacks: {
            title: () => '',
            label: function (tooltipItem) {
              const datasetIndex = tooltipItem.datasetIndex;
              const axisIndex = tooltipItem.dataIndex;
              const axisLabel = originalDataAndScales.axisLabels[axisIndex];

              const originalValue = originalDataAndScales.datasets[datasetIndex]?.data[axisIndex];
              const axisScale = originalDataAndScales.axisScales[axisIndex];

              // Format values based on axis type
              const isTimeAxis = axisLabel.toLowerCase().includes('sec') || axisLabel.toLowerCase().includes('time');
              const formattedValue = isTimeAxis ? originalValue.toFixed(1) : Math.round(originalValue).toString();
              const formattedMax = isTimeAxis ? axisScale.max.toFixed(1) : Math.round(axisScale.max).toString();

              return `${axisLabel}: ${formattedValue}`; // (Max: ${axisScale.actualMax}, Scale: 0-${formattedMax})
            },
          },
        },
        legend: {
          display: true,
          position: 'top',
          labels: {
            filter: function (item, chart) {
              return item.text !== undefined;
            }
          }
        },
        title: {
          display: true,
          position: 'bottom',
          font: {
            size: 10
          },
          color: '#666'
        },
        datalabels: {
          display: (context) => {
            // Only show label for the first dataset to reduce clutter
            // Or show all but position them differently
            return true;
          },
          color: (context) => {
            // Match the dataset color for clarity
            return context.dataset.borderColor || 'black';
          },
          align: (context) => {
            // Alternate alignment based on dataset index to avoid overlap
            const datasetIndex = context.datasetIndex;
            const alignments = ['end', 'start', 'right', 'left'];
            return alignments[datasetIndex % alignments.length];
          },
          anchor: 'center',
          offset: (context) => {
            // Increase offset for subsequent datasets
            return 8 + (context.datasetIndex * 12);
          },
          font: {
            weight: 'bold',
            size: 8,
          },
          backgroundColor: (context) => {
            return 'rgba(255, 255, 255, 0.7)';
          },
          borderRadius: 3,
          padding: 2,
          formatter: function (value, context) {
            // Get original (non-normalized) value
            const datasetIndex = context.datasetIndex;
            const axisIndex = context.dataIndex;
            const originalValue = originalDataAndScales.datasets[datasetIndex]?.data[axisIndex];

            if (originalValue === undefined || originalValue === null) {
              return '';
            }

            // Format to reasonable decimal places
            const axisLabel = originalDataAndScales.axisLabels[axisIndex];
            const isTimeAxis = axisLabel.toLowerCase().includes('sec') || axisLabel.toLowerCase().includes('time');

            if (isTimeAxis) {
              return originalValue.toFixed(2);
            }
            return Number.isInteger(originalValue) ? originalValue : originalValue.toFixed(2);
          }
        }
      },
    };

    // Update the radar data with normalized datasets
    const normalizedRadarData = {
      labels: axisLabels,
      datasets: normalizedDatasets,
    };

    setGRData(normalizedRadarData);
    setROptn(RadarOptions);
  }

  function loadgraph(sprt, e) {
    if (e !== null && e !== "") {
      setAssType(e.target.value);
    }
    const temp = new FormData();
    temp.append("sports_id", sprt);
    temp.append("user_id", id);
    temp.append("assessment_type_id", e ? e.target.value : "");

    assessmentgraphsports(temp).then((res) => {
      if (res.status === true) {
        loadGraphData(res);
      }
    });
  }

  const [opts, setOptn] = useState("");
  useEffect(() => {
    // if (selectedFilter) {
    listgraph(schid);
    // }
  }, [selectedFilter]);
  function listgraph(lid) {
    profileyeargraph(lid, id).then((res) => {
      if (res.status === true) {
        // if (res.data.year_array.length !== 0) {
        //   const labels = res.data.year_array.map((item) =>
        //     item.year.toString()
        //   );

        //   const internationalMedals = res.data.year_array.map(
        //     (item) => item.International_Medals || 0
        //   );
        //   const nationalMedals = res.data.year_array.map(
        //     (item) => item.National_Medals || 0
        //   );
        //   const stateMedals = res.data.year_array.map(
        //     (item) => item.State_Medals || 0
        //   );
        //   const zonalMedals = res.data.year_array.map(
        //     (item) => item.Zonal_Medals || 0
        //   );
        //   const districtMedals = res.data.year_array.map(
        //     (item) => item.District_Medals || 0
        //   );
        //   const interSchoolMedals = res.data.year_array.map(
        //     (item) => item.Inter_School_Medals || 0
        //   );
        //   const intraSchoolMedals = res.data.year_array.map(
        //     (item) => item.Intra_school_Medals || 0
        //   );

        //   const internationalParticipation = res.data.year_array.map(
        //     (item) => item.International_Participation || 0
        //   );
        //   const nationalParticipation = res.data.year_array.map(
        //     (item) => item.National_Participation || 0
        //   );
        //   const stateParticipation = res.data.year_array.map(
        //     (item) => item.State_Participation || 0
        //   );
        //   const zonalParticipation = res.data.year_array.map(
        //     (item) => item.Zonal_Participation || 0
        //   );
        //   const districtParticipation = res.data.year_array.map(
        //     (item) => item.District_Participation || 0
        //   );
        //   const interSchoolParticipation = res.data.year_array.map(
        //     (item) => item.Inter_School_Participation || 0
        //   );
        //   const intraSchoolParticipation = res.data.year_array.map(
        //     (item) => item.Intra_school_Participation || 0
        //   );

        //   const pdata = {
        //     labels: labels,
        //     datasets: [
        //       {
        //         label: "International Medals",
        //         data: internationalMedals,
        //         backgroundColor: "#007fff",
        //         stack: "medals",
        //       },
        //       {
        //         label: "National",
        //         data: nationalMedals,
        //         backgroundColor: "#01ffff",
        //         stack: "medals",
        //       },
        //       {
        //         label: "State Medals",
        //         data: stateMedals,
        //         backgroundColor: "#23297a",
        //         stack: "medals",
        //       },
        //       {
        //         label: "Zonal Medals",
        //         data: zonalMedals,
        //         backgroundColor: "#5C516D",
        //         stack: "medals",
        //       },
        //       {
        //         label: "District Medals",
        //         data: districtMedals,
        //         backgroundColor: "#81D8D0",
        //         stack: "medals",
        //       },
        //       {
        //         label: "Inter-School Medals",
        //         data: interSchoolMedals,
        //         backgroundColor: "#008080",
        //         stack: "medals",
        //       },
        //       {
        //         label: "Intra-School Medals",
        //         data: intraSchoolMedals,
        //         backgroundColor: "#0000FF",
        //         stack: "medals",
        //       },

        //       {
        //         label: "International Participation",
        //         data: internationalParticipation,
        //         backgroundColor: "#ff0090",
        //         stack: "participation",
        //       },
        //       {
        //         label: "National Participation",
        //         data: nationalParticipation,
        //         backgroundColor: "#fa8070",
        //         stack: "participation",
        //       },
        //       {
        //         label: "State Participation",
        //         data: stateParticipation,
        //         backgroundColor: "#ff00ff",
        //         stack: "participation",
        //       },
        //       {
        //         label: "Zonal Participation",
        //         data: zonalParticipation,
        //         backgroundColor: "#de3161",
        //         stack: "participation",
        //       },
        //       {
        //         label: "District Participation",
        //         data: districtParticipation,
        //         backgroundColor: "#fa86c5",
        //         stack: "participation",
        //       },
        //       {
        //         label: "Inter-School Participation",
        //         data: interSchoolParticipation,
        //         backgroundColor: "#FE019A",
        //         stack: "participation",
        //       },
        //       {
        //         label: "Intra-School Participation",
        //         data: intraSchoolParticipation,
        //         backgroundColor: "#c08081",
        //         stack: "participation",
        //       },
        //     ],
        //   };

        //   setGData(pdata);
        // }

        const data = res.data;
        const years = data.year_array.map((item) => item.year);
        const medalField = selectedFilter
          ? `${selectedFilter}_Medals`
          : "medals_count";
        const participationField = selectedFilter
          ? `${selectedFilter}_Participation`
          : "participation_count";

        const medalData = data.year_array.map((item) => item[medalField] || 0);

        const participationData = data.year_array.map(
          (item) => item[participationField] || 0 // If no selectedFilter, use Participation_count
        );

        const pdata = {
          labels: years,
          datasets: [
            {
              label: `${selectedFilter} Medals`,
              data: medalData,
              backgroundColor: "#0000FF", // Color for medals
            },
            {
              label: `${selectedFilter} Participation`,
              data: participationData,
              backgroundColor: "#FE019A", // Color for participation
            },
          ],
        };

        setGData(pdata);
      }
    });

    // if (window.innerWidth < 768) {
    //   const odata = {
    //     responsive: true,
    //     maintainAspectRatio: false,
    //     plugins: {
    //       title: {
    //         display: true,
    //         text: "Medals and Participation Over Years",
    //       },
    //       tooltip: {
    //         mode: "point",
    //         intersect: false,
    //         position: "nearest",
    //         callbacks: {
    //           label: function (tooltipItem) {
    //             const datasetLabel = tooltipItem.dataset.label || "";
    //             const value = tooltipItem.raw;
    //             return `${datasetLabel}: ${value}`;
    //           },
    //           title: function (tooltipItems) {
    //             return `Year: ${tooltipItems[0].label}`;
    //           },
    //         },
    //       },
    //       legend: {
    //         position: "",
    //         display: false,
    //       },
    //     },
    //     stacked: true,
    //     scales: {
    //       x: {
    //         stacked: true,
    //       },
    //       y: {
    //         stacked: true,
    //       },
    //     },
    //   };
    //   setOptn(odata);
    // } else {
    //   const odata = {
    //     responsive: true,
    //     maintainAspectRatio: true,
    //     plugins: {
    //       title: {
    //         display: true,
    //         text: "Medals and Participation Over Years",
    //       },
    //       tooltip: {
    //         mode: "point",
    //         intersect: false,
    //         position: "nearest",
    //         callbacks: {
    //           label: function (tooltipItem) {
    //             const datasetLabel = tooltipItem.dataset.label || "";
    //             const value = tooltipItem.raw;
    //             return `${datasetLabel}: ${value}`;
    //           },
    //           title: function (tooltipItems) {
    //             return `Year: ${tooltipItems[0].label}`;
    //           },
    //         },
    //       },
    //       legend: {
    //         position: "",
    //         display: false,
    //       },
    //     },
    //     stacked: true,
    //     scales: {
    //       x: {
    //         stacked: true,
    //       },
    //       y: {
    //         stacked: true,
    //       },
    //     },
    //   };
    //   setOptn(odata);
    // }
    if (window.innerWidth < 768) {
      const odata = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: "top",
          },
          title: {
            display: true,
            //   text: 'ABC',
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              text: "",
            },
          },
          y: {
            title: {
              display: true,
              text: "",
            },
          },
        },
      };
      setOptn(odata);
    } else {
      const odata = {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            position: "top",
          },
          title: {
            display: true,
            //   text: 'ABC',
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              text: "",
            },
          },
          y: {
            title: {
              display: true,
              text: "",
            },
          },
        },
      };
      setOptn(odata);
    }
  }

  function listskills(sid) {
    if (sid !== null) {
      Playerprofiledetails(sid).then(
        (res2) => {
          if (res2.status === true) {
            if (res2.data.athletelist !== null) {
              if (res2.data.athletelist.old_user_id !== null) {
                const pltemp = new FormData();
                pltemp.append(
                  "data_req",
                  "asmnt_data" + res2.data.athletelist.old_user_id
                );
                gettokenfromapi(pltemp).then((res) => {
                  if (res.status === true) {
                    sahassessmentdatelist(
                      "asmnt_data&esid=" +
                      res2.data.athletelist.old_user_id,
                      res.data
                    ).then((response) => {
                      if (response.assmts.length !== 0) {
                        if (response.assmts[0].esid !== undefined) {
                          if (response.assmts[0].chId !== null) {
                            setAssList(response.assmts);
                          }
                        } else {
                          if (response.assmts[0].length !== 0) {
                            setAssList(response.assmts[0]);
                          }
                        }
                      }

                      if (response.assmts[0].esid === undefined) {
                        if (response.assmts[0].length !== 0) {
                          if (response.assmts[0][0].assmts.length !== 0) {
                            const fdata = response.assmts[0][0].assmts.filter(
                              (data) => {
                                return data.type === "fitness";
                              }
                            );
                            setFitList(fdata);
                            let origString = response.assmts[0][0].date;
                            let stringToAdd = "-";
                            let indexPosition = 2;
                            let newString1 =
                              origString.slice(0, indexPosition) +
                              stringToAdd +
                              origString.slice(indexPosition);
                            let indexPosition1 = 5;
                            let newString =
                              newString1.slice(0, indexPosition1) +
                              stringToAdd +
                              newString1.slice(indexPosition1);
                            setAssDate(newString);
                            setSkillDate(newString);
                            const sdata = response.assmts[0][0].assmts.filter(
                              (data) => {
                                return data.type === "skill";
                              }
                            );
                            setSkillList(sdata);
                          }
                        }
                      }
                    });
                  }
                });
              }
            }
          }
        }
      );
    }
  }
  const [attdet, setAttDet] = useState([]);
  const [gattdet, setGAttDet] = useState("");
  const [aopts, setAOpts] = useState({});

  const [ptdet, setPtDet] = useState([]);
  const [phdet, setPhDet] = useState([]);
  const [pbdet, setPbDet] = useState([]);
  const [pslist, setPSList] = useState([]);
  const [hlist, setHList] = useState([]);

  const [aclist, setACList] = useState([]);
  const [clist, setCList] = useState([]);
  const [mclist, setMCList] = useState([]);
  const [plist, setPList] = useState([]);
  const [vlist, setVList] = useState([]);
  const [oflist, setOFList] = useState([]);

  const [upath, setUPath] = useState("");

  const [page, setPAge] = useState("");
  const [pemer, setPEmer] = useState("");
  const [bgroup, setBGroup] = useState("");
  const [paddr, setPAddr] = useState("");
  const [pesid, setPESID] = useState("");
  const [pcoach, setPCoach] = useState("");
  const [ppastcoach, setPPastCoach] = useState("");

  const [ksize, setKSize] = useState("");
  const [ssize, setSSize] = useState("");
  const [sdccenter, setSDCCenter] = useState("");

  function listsimilar(cyear) {
    setTYear(cyear);
    if (localStorage.getItem("Role") === "1") {
      viewprofile(id, cyear).then((response) => {
        if (response.status === true) {
          setFName(response.data.playerlist.first_name);
          setLName(response.data.playerlist.last_name);
          if (response.data.playerlist.date_of_birth !== null) {
            setDOB(
              moment(response.data.playerlist.date_of_birth).format(
                "DD-MM-yyyy"
              )
            );
          }

          setPStatus(response.data.playerlist.active_or_passive);
          if (response.data.playerlist.date_of_join !== null) {
            setDOJ(
              moment(response.data.playerlist.date_of_join).format("DD-MM-yyyy")
            );
          }
          if (response.data.playerlist.registerdate !== null) {
            setRegDate(
              moment(response.data.playerlist.registerdate).format("DD-MM-yyyy")
            );
          }
          setGender(response.data.playerlist.gender);
          setEmail(response.data.playerlist.email_id);
          setFather(response.data.playerlist.father_name);
          setMobNo(response.data.playerlist.mobile_no);
          setUser(response.data.playerlist.username);

          viewprofilepassword(id).then((response) => {
            if (response.status === true) {
              setPass(response.data);
            }
          });
          setStatus(response.data.playerlist.status);
          setSchool(response.data.playerlist.school_name);
          setSchoolId(response.data.playerlist.school_id);

          setClass(response.data.playerlist.classname);
          setSection(response.data.playerlist.section);
          if (response.data.playerlist.photograph !== null) {
            setPhoto(
              response.data.photo_path + response.data.playerlist.photograph
            );
          }
          if (response.data.playerlist.aadhar_image !== null) {
            setAFile(
              response.data.aadhar_path + response.data.playerlist.aadhar_image
            );
          }
          if (response.data.playerlist.age !== null) {
            setPAge(response.data.playerlist.age);
          }
          if (response.data.playerlist.emergency_contact_no !== null) {
            setPEmer(response.data.playerlist.emergency_contact_no);
          }
          if (response.data.playerlist.blood_group !== null) {
            setBGroup(response.data.playerlist.blood_group);
          }
          if (response.data.playerlist.permenant_address_one !== null) {
            setPAddr(response.data.playerlist.permenant_address_one);
          }
          if (response.data.playerlist.ESID !== null) {
            setPESID(response.data.playerlist.ESID);
          }
          if (response.data.playerlist.current_coach_name !== null) {
            setPCoach(response.data.playerlist.current_coach_name);
          }
          if (response.data.playerlist.past_coach_or_mentor !== null) {
            setPPastCoach(response.data.playerlist.past_coach_or_mentor);
          }

          if (response.data.playerlist.kit_size !== null) {
            setKSize(response.data.playerlist.kit_size);
          }
          if (response.data.playerlist.shoe_size !== null) {
            setSSize(response.data.playerlist.shoe_size);
          }
          if (response.data.playerlist.sdc_center !== null) {
            setSDCCenter(response.data.playerlist.sdc_center);
          }
          setAttDet(response.data.attendace_report);
          if (response.data.personal_timings.length != 0) {
            const formattedData = response.data.personal_timings.map(
              (item) => ({
                ...item,
                record_date:
                  item.record_date !== null
                    ? moment(item.record_date).format("DD-MM-YYYY")
                    : "",
              })
            );
            setPtDet(formattedData);
          }

          if (response.data.physical_health_data.length != 0) {
            const formattedData = response.data.physical_health_data.map(
              (item) => ({
                ...item,
                record_date:
                  item.record_date !== null
                    ? moment(item.record_date).format("DD-MM-YYYY")
                    : "",
              })
            );
            setPhDet(formattedData);
          }

          setPbDet(response.data.phychological_behavioral);
          setPSList(response.data.personal_details_sports);
          // let arr1 = [];
          // if (
          //   response.data.highest_level != "-" &&
          //   response.data.highest_level_event != "-" &&
          //   response.data.highest_level_sports != "-"
          // ) {
          //   arr1.push({
          //     highest_level: response.data.highest_level,
          //     highest_level_sports: response.data.highest_level_sports,
          //     highest_level_event: response.data.highest_level_event,
          //   });
          // }
          setHList(response.data.highest_level_achievements);
          setUPath(response.data.player_files_path);
          setACList(response.data.athlete_contract_files);
          setCList(response.data.certificate_files);
          setMCList(response.data.media_coverage_files);
          setPList(response.data.photos_files);
          setVList(response.data.videos_files);
          setOFList(response.data.other_files_files);

          let sim = [];
          sim.push({
            user_id: id,
            username: response.data.playerlist.username,
            first_name: response.data.playerlist.first_name,
            gender: response.data.playerlist.gender,
            date_of_birth: response.data.playerlist.date_of_birth,
            mobile_no: response.data.playerlist.mobile_no,
            email_id: response.data.playerlist.email_id,
            school_id: response.data.playerlist.school_id,
            school_name: response.data.playerlist.school_name,
            class_id: response.data.playerlist.class,
            class_name: response.data.playerlist.class_name,
            section: response.data.playerlist.section,
            registerdate: response.data.playerlist.registerdate,
            mergedornot: "",
            merged_main_username: "",
            merged_main_userid: "",
            check: true,
          });
          setSimList([...sim]);

          similarplayerlist(id).then((res) => {
            if (res.status === true) {
              if (res.data.duplicatedetails.length !== 0) {
                for (let i = 0; i < res.data.duplicatedetails.length; i++) {
                  sim.push({
                    user_id: res.data.duplicatedetails[i].user_id,
                    username: res.data.duplicatedetails[i].username,
                    first_name: res.data.duplicatedetails[i].first_name,
                    gender: res.data.duplicatedetails[i].gender,
                    date_of_birth: res.data.duplicatedetails[i].date_of_birth,
                    mobile_no: res.data.duplicatedetails[i].mobile_no,
                    email_id: res.data.duplicatedetails[i].email_id,
                    school_id: res.data.duplicatedetails[i].school_id,
                    school_name: res.data.duplicatedetails[i].school_name,
                    class_id: res.data.duplicatedetails[i].class,
                    class_name: res.data.duplicatedetails[i].class_name,
                    section: res.data.duplicatedetails[i].section,
                    registerdate: res.data.duplicatedetails[i].registerdate,
                    mergedornot: res.data.duplicatedetails[i].mergedornot,
                    merged_main_username:
                      res.data.duplicatedetails[i].merged_main_username,

                    merged_main_userid:
                      res.data.duplicatedetails[i].merged_main_userid,
                    check: false,
                    radiouser: false,
                    radioname: false,
                    radiogender: false,
                    radiodob: false,
                    radiomob: false,
                    radioemail: false,
                    radiosch: false,
                  });
                }
              }
              setSimList([...sim]);
            }
          });
          if (response.data.attendance_graph.length != 0) {
            const years = response.data.attendance_graph.map((item) => {
              const attendancePercentage = parseFloat(
                item.attendance_percentage
              );

              if (isNaN(attendancePercentage)) {
                return item.month_name + " (0%)";
              }

              const formattedPercentage =
                attendancePercentage % 1 === 0
                  ? attendancePercentage.toFixed(0)
                  : attendancePercentage.toFixed(2);

              return item.month_name + " (" + formattedPercentage + "%)";
            });
            const maleCounts = response.data.attendance_graph.map(
              (item) => item.total_present
            );
            const femaleCounts = response.data.attendance_graph.map(
              (item) => item.total_sessions_conducted
            );
            const pdata = {
              labels: years,
              datasets: [
                {
                  label: "Present",
                  data: maleCounts,
                  backgroundColor: "#25e3da",
                },
                {
                  label: "Session Conducted",
                  data: femaleCounts,
                  backgroundColor: "#f74dc1",
                },
              ],
            };
            setGAttDet(pdata);
          }
          listskills(response.data.playerlist.username)
          listgraph(response.data.playerlist.school_id);
        }
      });
    } else if (localStorage.getItem("Role") === "3") {
      cityplayerview(id, cyear).then((response) => {
        if (response.status === true) {
          setFName(response.data.playerlist.first_name);
          setLName(response.data.playerlist.last_name);
          setDOB(
            moment(response.data.playerlist.date_of_birth).format("DD-MM-yyyy")
          );
          setPStatus(response.data.playerlist.active_or_passive);
          if (response.data.playerlist.date_of_join !== null) {
            setDOJ(
              moment(response.data.playerlist.date_of_join).format("DD-MM-yyyy")
            );
          }
          setGender(response.data.playerlist.gender);
          setEmail(response.data.playerlist.email_id);
          setFather(response.data.playerlist.father_name);
          setMobNo(response.data.playerlist.mobile_no);
          setUser(response.data.playerlist.username);
          setStatus(response.data.playerlist.status);
          setSchool(response.data.playerlist.school_name);
          schooldetailcityreg(response.data.playerlist.school_id).then(
            (res) => {
              if (res.status === true) {
                if (localStorage.getItem("list") === "2") {
                  setSchoolId(res.data.details.funder_id);
                } else {
                  setSchoolId(res.data.details.id);
                }
              }
            }
          );

          setClass(response.data.playerlist.classname);
          setSection(response.data.playerlist.section);
          if (response.data.playerlist.photograph !== null) {
            setPhoto(
              response.data.photo_path + response.data.playerlist.photograph
            );
          }
          if (response.data.playerlist.aadhar_image !== null) {
            setAFile(
              response.data.aadhar_path + response.data.playerlist.aadhar_image
            );
          }
          if (response.data.playerlist.registerdate !== null) {
            setRegDate(
              moment(response.data.playerlist.registerdate).format("DD-MM-yyyy")
            );
          }

          if (response.data.playerlist.age !== null) {
            setPAge(response.data.playerlist.age);
          }
          if (response.data.playerlist.emergency_contact_no !== null) {
            setPEmer(response.data.playerlist.emergency_contact_no);
          }
          if (response.data.playerlist.blood_group !== null) {
            setBGroup(response.data.playerlist.blood_group);
          }
          if (response.data.playerlist.permenant_address_one !== null) {
            setPAddr(response.data.playerlist.permenant_address_one);
          }
          if (response.data.playerlist.ESID !== null) {
            setPESID(response.data.playerlist.ESID);
          }
          if (response.data.playerlist.current_coach_name !== null) {
            setPCoach(response.data.playerlist.current_coach_name);
          }
          if (response.data.playerlist.past_coach_or_mentor !== null) {
            setPPastCoach(response.data.playerlist.past_coach_or_mentor);
          }
          if (response.data.playerlist.kit_size !== null) {
            setKSize(response.data.playerlist.kit_size);
          }
          if (response.data.playerlist.shoe_size !== null) {
            setSSize(response.data.playerlist.shoe_size);
          }
          if (response.data.playerlist.sdc_center !== null) {
            setSDCCenter(response.data.playerlist.sdc_center);
          }
          setAttDet(response.data.attendace_report);
          if (response.data.personal_timings.length != 0) {
            const formattedData = response.data.personal_timings.map(
              (item) => ({
                ...item,
                record_date:
                  item.record_date !== null
                    ? moment(item.record_date).format("DD-MM-YYYY")
                    : "",
              })
            );
            setPtDet(formattedData);
          }
          if (response.data.physical_health_data.length != 0) {
            const formattedData = response.data.physical_health_data.map(
              (item) => ({
                ...item,
                record_date:
                  item.record_date !== null
                    ? moment(item.record_date).format("DD-MM-YYYY")
                    : "",
              })
            );
            setPhDet(formattedData);
          }
          setPbDet(response.data.phychological_behavioral);
          setPSList(response.data.personal_details_sports);
          // let arr1 = [];
          // if (
          //   response.data.highest_level != "-" &&
          //   response.data.highest_level_event != "-" &&
          //   response.data.highest_level_sports != "-"
          // ) {
          //   arr1.push({
          //     highest_level: response.data.highest_level,
          //     highest_level_sports: response.data.highest_level_sports,
          //     highest_level_event: response.data.highest_level_event,
          //   });
          // }
          // setHList(arr1);
          setHList(response.data.highest_level_achievements);
          setUPath(response.data.player_files_path);
          setACList(response.data.athlete_contract_files);
          setCList(response.data.certificate_files);
          setMCList(response.data.media_coverage_files);
          setPList(response.data.photos_files);
          setVList(response.data.videos_files);
          setOFList(response.data.other_files_files);

          let sim = [];
          sim.push({
            user_id: id,
            username: response.data.playerlist.username,
            first_name: response.data.playerlist.first_name,
            gender: response.data.playerlist.gender,
            date_of_birth: response.data.playerlist.date_of_birth,
            mobile_no: response.data.playerlist.mobile_no,
            email_id: response.data.playerlist.email_id,
            school_id: response.data.playerlist.school_id,
            school_name: response.data.playerlist.school_name,
            class_id: response.data.playerlist.class,
            class_name: response.data.playerlist.class_name,
            section: response.data.playerlist.section,
            registerdate: response.data.playerlist.registerdate,
            mergedornot: "",
            merged_main_username: "",
            merged_main_userid: "",
            check: true,
          });
          setSimList([...sim]);

          similarplayerlist(id).then((res) => {
            if (res.status === true) {
              if (res.data.duplicatedetails.length !== 0) {
                for (let i = 0; i < res.data.duplicatedetails.length; i++) {
                  sim.push({
                    user_id: res.data.duplicatedetails[i].user_id,
                    username: res.data.duplicatedetails[i].username,
                    first_name: res.data.duplicatedetails[i].first_name,
                    gender: res.data.duplicatedetails[i].gender,
                    date_of_birth: res.data.duplicatedetails[i].date_of_birth,
                    mobile_no: res.data.duplicatedetails[i].mobile_no,
                    email_id: res.data.duplicatedetails[i].email_id,
                    school_id: res.data.duplicatedetails[i].school_id,
                    school_name: res.data.duplicatedetails[i].school_name,
                    class_id: res.data.duplicatedetails[i].class,
                    class_name: res.data.duplicatedetails[i].class_name,
                    section: res.data.duplicatedetails[i].section,
                    registerdate: res.data.duplicatedetails[i].registerdate,
                    mergedornot: res.data.duplicatedetails[i].mergedornot,
                    merged_main_username:
                      res.data.duplicatedetails[i].merged_main_username,

                    merged_main_userid:
                      res.data.duplicatedetails[i].merged_main_userid,
                    check: false,
                    radiouser: false,
                    radioname: false,
                    radiogender: false,
                    radiodob: false,
                    radiomob: false,
                    radioemail: false,
                    radiosch: false,
                  });
                }
              }
              setSimList([...sim]);
            }
          });
          if (response.data.attendance_graph.length != 0) {
            const years = response.data.attendance_graph.map((item) => {
              const attendancePercentage = parseFloat(
                item.attendance_percentage
              );

              if (isNaN(attendancePercentage)) {
                return item.month_name + " (0%)";
              }

              const formattedPercentage =
                attendancePercentage % 1 === 0
                  ? attendancePercentage.toFixed(0)
                  : attendancePercentage.toFixed(2);

              return item.month_name + " (" + formattedPercentage + "%)";
            });
            const maleCounts = response.data.attendance_graph.map(
              (item) => item.total_present
            );
            const femaleCounts = response.data.attendance_graph.map(
              (item) => item.total_sessions_conducted
            );
            const pdata = {
              labels: years,
              datasets: [
                {
                  label: "Present",
                  data: maleCounts,
                  backgroundColor: "#25e3da",
                },
                {
                  label: "Session Conducted",
                  data: femaleCounts,
                  backgroundColor: "#f74dc1",
                },
              ],
            };
            setGAttDet(pdata);
          }
          listskills(response.data.playerlist.username)

          listgraph(response.data.playerlist.school_id);
        }
      });
    } else if (localStorage.getItem("Role") === "4") {
      schoolviewplayer(id, cyear).then((response) => {
        if (response.status === true) {
          setFName(response.data.playerlist.first_name);
          setLName(response.data.playerlist.last_name);

          if (response.data.playerlist.date_of_birth !== null) {
            setDOB(
              moment(response.data.playerlist.date_of_birth).format(
                "DD-MM-yyyy"
              )
            );
          }
          setPStatus(response.data.playerlist.active_or_passive);
          if (response.data.playerlist.date_of_join !== null) {
            setDOJ(
              moment(response.data.playerlist.date_of_join).format("DD-MM-yyyy")
            );
          }
          if (response.data.playerlist.registerdate !== null) {
            setRegDate(
              moment(response.data.playerlist.registerdate).format("DD-MM-yyyy")
            );
          }
          setGender(response.data.playerlist.gender);
          setEmail(response.data.playerlist.email_id);
          setFather(response.data.playerlist.father_name);
          setMobNo(response.data.playerlist.mobile_no);
          setUser(response.data.playerlist.username);
          setStatus(response.data.playerlist.status);
          setSchool(response.data.playerlist.school_name);
          setSchoolId(response.data.playerlist.school_id);

          setClass(response.data.playerlist.classname);
          setSection(response.data.playerlist.section);
          if (response.data.playerlist.photograph !== null) {
            setPhoto(
              response.data.photo_path + response.data.playerlist.photograph
            );
          }
          if (response.data.playerlist.aadhar_image !== null) {
            setAFile(
              response.data.aadhar_path + response.data.playerlist.aadhar_image
            );
          }
          if (response.data.playerlist.age !== null) {
            setPAge(response.data.playerlist.age);
          }
          if (response.data.playerlist.emergency_contact_no !== null) {
            setPEmer(response.data.playerlist.emergency_contact_no);
          }
          if (response.data.playerlist.blood_group !== null) {
            setBGroup(response.data.playerlist.blood_group);
          }
          if (response.data.playerlist.permenant_address_one !== null) {
            setPAddr(response.data.playerlist.permenant_address_one);
          }
          if (response.data.playerlist.ESID !== null) {
            setPESID(response.data.playerlist.ESID);
          }
          if (response.data.playerlist.current_coach_name !== null) {
            setPCoach(response.data.playerlist.current_coach_name);
          }
          if (response.data.playerlist.past_coach_or_mentor !== null) {
            setPPastCoach(response.data.playerlist.past_coach_or_mentor);
          }
          if (response.data.playerlist.kit_size !== null) {
            setKSize(response.data.playerlist.kit_size);
          }
          if (response.data.playerlist.shoe_size !== null) {
            setSSize(response.data.playerlist.shoe_size);
          }
          if (response.data.playerlist.sdc_center !== null) {
            setSDCCenter(response.data.playerlist.sdc_center);
          }
          setAttDet(response.data.attendace_report);
          if (response.data.personal_timings.length != 0) {
            const formattedData = response.data.personal_timings.map(
              (item) => ({
                ...item,
                record_date:
                  item.record_date !== null
                    ? moment(item.record_date).format("DD-MM-YYYY")
                    : "",
              })
            );
            setPtDet(formattedData);
          }
          if (response.data.physical_health_data.length != 0) {
            const formattedData = response.data.physical_health_data.map(
              (item) => ({
                ...item,
                record_date:
                  item.record_date !== null
                    ? moment(item.record_date).format("DD-MM-YYYY")
                    : "",
              })
            );
            setPhDet(formattedData);
          }
          setPbDet(response.data.phychological_behavioral);
          setPSList(response.data.personal_details_sports);
          // let arr1 = [];
          // if (
          //   response.data.highest_level != "-" &&
          //   response.data.highest_level_event != "-" &&
          //   response.data.highest_level_sports != "-"
          // ) {
          //   arr1.push({
          //     highest_level: response.data.highest_level,
          //     highest_level_sports: response.data.highest_level_sports,
          //     highest_level_event: response.data.highest_level_event,
          //   });
          // }
          // setHList(arr1);
          setHList(response.data.highest_level_achievements);
          setUPath(response.data.player_files_path);
          setACList(response.data.athlete_contract_files);
          setCList(response.data.certificate_files);
          setMCList(response.data.media_coverage_files);
          setPList(response.data.photos_files);
          setVList(response.data.videos_files);
          setOFList(response.data.other_files_files);

          let sim = [];
          sim.push({
            user_id: id,
            username: response.data.playerlist.username,
            first_name: response.data.playerlist.first_name,
            gender: response.data.playerlist.gender,
            date_of_birth: response.data.playerlist.date_of_birth,
            mobile_no: response.data.playerlist.mobile_no,
            email_id: response.data.playerlist.email_id,
            school_id: response.data.playerlist.school_id,
            school_name: response.data.playerlist.school_name,
            class_id: response.data.playerlist.class,
            class_name: response.data.playerlist.class_name,
            section: response.data.playerlist.section,
            registerdate: response.data.playerlist.registerdate,
            mergedornot: "",
            merged_main_username: "",
            merged_main_userid: "",
            check: true,
          });
          setSimList([...sim]);

          similarplayerlist(id).then((res) => {
            if (res.status === true) {
              if (res.data.duplicatedetails.length !== 0) {
                for (let i = 0; i < res.data.duplicatedetails.length; i++) {
                  sim.push({
                    user_id: res.data.duplicatedetails[i].user_id,
                    username: res.data.duplicatedetails[i].username,
                    first_name: res.data.duplicatedetails[i].first_name,
                    gender: res.data.duplicatedetails[i].gender,
                    date_of_birth: res.data.duplicatedetails[i].date_of_birth,
                    mobile_no: res.data.duplicatedetails[i].mobile_no,
                    email_id: res.data.duplicatedetails[i].email_id,
                    school_id: res.data.duplicatedetails[i].school_id,
                    school_name: res.data.duplicatedetails[i].school_name,
                    class_id: res.data.duplicatedetails[i].class,
                    class_name: res.data.duplicatedetails[i].class_name,
                    section: res.data.duplicatedetails[i].section,
                    registerdate: res.data.duplicatedetails[i].registerdate,
                    mergedornot: res.data.duplicatedetails[i].mergedornot,
                    merged_main_username:
                      res.data.duplicatedetails[i].merged_main_username,

                    merged_main_userid:
                      res.data.duplicatedetails[i].merged_main_userid,
                    check: false,
                    radiouser: false,
                    radioname: false,
                    radiogender: false,
                    radiodob: false,
                    radiomob: false,
                    radioemail: false,
                    radiosch: false,
                  });
                }
              }
              setSimList([...sim]);
            }
          });
          if (response.data.attendance_graph.length != 0) {
            const years = response.data.attendance_graph.map((item) => {
              const attendancePercentage = parseFloat(
                item.attendance_percentage
              );

              if (isNaN(attendancePercentage)) {
                return item.month_name + " (0%)";
              }

              const formattedPercentage =
                attendancePercentage % 1 === 0
                  ? attendancePercentage.toFixed(0)
                  : attendancePercentage.toFixed(2);

              return item.month_name + " (" + formattedPercentage + "%)";
            });
            const maleCounts = response.data.attendance_graph.map(
              (item) => item.total_present
            );
            const femaleCounts = response.data.attendance_graph.map(
              (item) => item.total_sessions_conducted
            );
            const pdata = {
              labels: years,
              datasets: [
                {
                  label: "Present",
                  data: maleCounts,
                  backgroundColor: "#25e3da",
                },
                {
                  label: "Session Conducted",
                  data: femaleCounts,
                  backgroundColor: "#f74dc1",
                },
              ],
            };
            setGAttDet(pdata);
          }
          listskills(response.data.playerlist.username)

          listgraph(response.data.playerlist.school_id);
        }
      });

      viewprofilepassword(id).then((response) => {
        if (response.status === true) {
          setPass(response.data);
        }
      });
    } else if (localStorage.getItem("Role") === "7") {
      coachplayerview(id, cyear).then((response) => {
        if (response.status === true) {
          setFName(response.data.playerlist.first_name);
          setLName(response.data.playerlist.last_name);
          setDOB(
            moment(response.data.playerlist.date_of_birth).format("DD-MM-yyyy")
          );
          setPStatus(response.data.playerlist.active_or_passive);
          if (response.data.playerlist.date_of_join !== null) {
            setDOJ(
              moment(response.data.playerlist.date_of_join).format("DD-MM-yyyy")
            );
          }
          setGender(response.data.playerlist.gender);
          setEmail(response.data.playerlist.email_id);
          setFather(response.data.playerlist.father_name);
          setMobNo(response.data.playerlist.mobile_no);
          setUser(response.data.playerlist.username);
          setStatus(response.data.playerlist.status);
          setSchool(response.data.playerlist.school_name);
          setSchoolId(response.data.playerlist.school_id);

          setClass(response.data.playerlist.classname);
          setSection(response.data.playerlist.section);
          if (response.data.playerlist.photograph !== null) {
            setPhoto(
              response.data.photo_path + response.data.playerlist.photograph
            );
          }
          if (response.data.playerlist.aadhar_image !== null) {
            setAFile(
              response.data.aadhar_path + response.data.playerlist.aadhar_image
            );
          }
          if (response.data.playerlist.registerdate !== null) {
            setRegDate(
              moment(response.data.playerlist.registerdate).format("DD-MM-yyyy")
            );
          }

          if (response.data.playerlist.age !== null) {
            setPAge(response.data.playerlist.age);
          }
          if (response.data.playerlist.emergency_contact_no !== null) {
            setPEmer(response.data.playerlist.emergency_contact_no);
          }
          if (response.data.playerlist.blood_group !== null) {
            setBGroup(response.data.playerlist.blood_group);
          }
          if (response.data.playerlist.permenant_address_one !== null) {
            setPAddr(response.data.playerlist.permenant_address_one);
          }
          if (response.data.playerlist.ESID !== null) {
            setPESID(response.data.playerlist.ESID);
          }
          if (response.data.playerlist.current_coach_name !== null) {
            setPCoach(response.data.playerlist.current_coach_name);
          }
          if (response.data.playerlist.past_coach_or_mentor !== null) {
            setPPastCoach(response.data.playerlist.past_coach_or_mentor);
          }
          if (response.data.playerlist.kit_size !== null) {
            setKSize(response.data.playerlist.kit_size);
          }
          if (response.data.playerlist.shoe_size !== null) {
            setSSize(response.data.playerlist.shoe_size);
          }
          if (response.data.playerlist.sdc_center !== null) {
            setSDCCenter(response.data.playerlist.sdc_center);
          }
          setAttDet(response.data.attendace_report);
          if (response.data.personal_timings.length != 0) {
            const formattedData = response.data.personal_timings.map(
              (item) => ({
                ...item,
                record_date:
                  item.record_date !== null
                    ? moment(item.record_date).format("DD-MM-YYYY")
                    : "",
              })
            );
            setPtDet(formattedData);
          }
          if (response.data.physical_health_data.length != 0) {
            const formattedData = response.data.physical_health_data.map(
              (item) => ({
                ...item,
                record_date:
                  item.record_date !== null
                    ? moment(item.record_date).format("DD-MM-YYYY")
                    : "",
              })
            );
            setPhDet(formattedData);
          }
          setPbDet(response.data.phychological_behavioral);
          setPSList(response.data.personal_details_sports);
          // let arr1 = [];
          // if (
          //   response.data.highest_level != "-" &&
          //   response.data.highest_level_event != "-" &&
          //   response.data.highest_level_sports != "-"
          // ) {
          //   arr1.push({
          //     highest_level: response.data.highest_level,
          //     highest_level_sports: response.data.highest_level_sports,
          //     highest_level_event: response.data.highest_level_event,
          //   });
          // }
          // setHList(arr1);
          setHList(response.data.highest_level_achievements);
          setUPath(response.data.player_files_path);
          setACList(response.data.athlete_contract_files);
          setCList(response.data.certificate_files);
          setMCList(response.data.media_coverage_files);
          setPList(response.data.photos_files);
          setVList(response.data.videos_files);
          setOFList(response.data.other_files_files);

          let sim = [];
          sim.push({
            user_id: id,
            username: response.data.playerlist.username,
            first_name: response.data.playerlist.first_name,
            gender: response.data.playerlist.gender,
            date_of_birth: response.data.playerlist.date_of_birth,
            mobile_no: response.data.playerlist.mobile_no,
            email_id: response.data.playerlist.email_id,
            school_id: response.data.playerlist.school_id,
            school_name: response.data.playerlist.school_name,
            class_id: response.data.playerlist.class,
            class_name: response.data.playerlist.class_name,
            section: response.data.playerlist.section,
            registerdate: response.data.playerlist.registerdate,
            mergedornot: "",
            merged_main_username: "",
            merged_main_userid: "",
            check: true,
          });
          setSimList([...sim]);

          similarplayerlist(id).then((res) => {
            if (res.status === true) {
              if (res.data.duplicatedetails.length !== 0) {
                for (let i = 0; i < res.data.duplicatedetails.length; i++) {
                  sim.push({
                    user_id: res.data.duplicatedetails[i].user_id,
                    username: res.data.duplicatedetails[i].username,
                    first_name: res.data.duplicatedetails[i].first_name,
                    gender: res.data.duplicatedetails[i].gender,
                    date_of_birth: res.data.duplicatedetails[i].date_of_birth,
                    mobile_no: res.data.duplicatedetails[i].mobile_no,
                    email_id: res.data.duplicatedetails[i].email_id,
                    school_id: res.data.duplicatedetails[i].school_id,
                    school_name: res.data.duplicatedetails[i].school_name,
                    class_id: res.data.duplicatedetails[i].class,
                    class_name: res.data.duplicatedetails[i].class_name,
                    section: res.data.duplicatedetails[i].section,
                    registerdate: res.data.duplicatedetails[i].registerdate,
                    mergedornot: res.data.duplicatedetails[i].mergedornot,
                    merged_main_username:
                      res.data.duplicatedetails[i].merged_main_username,

                    merged_main_userid:
                      res.data.duplicatedetails[i].merged_main_userid,
                    check: false,
                    radiouser: false,
                    radioname: false,
                    radiogender: false,
                    radiodob: false,
                    radiomob: false,
                    radioemail: false,
                    radiosch: false,
                  });
                }
              }
              setSimList([...sim]);
            }
          });
          if (response.data.attendance_graph.length != 0) {
            const years = response.data.attendance_graph.map((item) => {
              const attendancePercentage = parseFloat(
                item.attendance_percentage
              );

              if (isNaN(attendancePercentage)) {
                return item.month_name + " (0%)";
              }

              const formattedPercentage =
                attendancePercentage % 1 === 0
                  ? attendancePercentage.toFixed(0)
                  : attendancePercentage.toFixed(2);

              return item.month_name + " (" + formattedPercentage + "%)";
            });
            const maleCounts = response.data.attendance_graph.map(
              (item) => item.total_present
            );
            const femaleCounts = response.data.attendance_graph.map(
              (item) => item.total_sessions_conducted
            );
            const pdata = {
              labels: years,
              datasets: [
                {
                  label: "Present",
                  data: maleCounts,
                  backgroundColor: "#25e3da",
                },
                {
                  label: "Session Conducted",
                  data: femaleCounts,
                  backgroundColor: "#f74dc1",
                },
              ],
            };
            setGAttDet(pdata);
          }
          listskills(response.data.playerlist.username)

          listgraph(response.data.playerlist.school_id);
        }
      });
    } else if (localStorage.getItem("Role") === "8") {
      funderplayerdetail(id, cyear).then((response) => {
        if (response.status === true) {
          setFName(response.data.playerlist.first_name);
          setLName(response.data.playerlist.last_name);
          setDOB(
            moment(response.data.playerlist.date_of_birth).format("DD-MM-yyyy")
          );
          setPStatus(response.data.playerlist.active_or_passive);
          if (response.data.playerlist.date_of_join !== null) {
            setDOJ(
              moment(response.data.playerlist.date_of_join).format("DD-MM-yyyy")
            );
          }
          setGender(response.data.playerlist.gender);
          setEmail(response.data.playerlist.email_id);
          setFather(response.data.playerlist.father_name);
          setMobNo(response.data.playerlist.mobile_no);
          setUser(response.data.playerlist.username);
          setStatus(response.data.playerlist.status);
          setSchool(response.data.playerlist.school_name);
          setSchoolId(response.data.playerlist.school_id);

          setClass(response.data.playerlist.classname);
          setSection(response.data.playerlist.section);
          if (response.data.playerlist.photograph !== null) {
            setPhoto(
              response.data.photo_path + response.data.playerlist.photograph
            );
          }
          if (response.data.playerlist.aadhar_image !== null) {
            setAFile(
              response.data.aadhar_path + response.data.playerlist.aadhar_image
            );
          }
          if (response.data.playerlist.registerdate !== null) {
            setRegDate(
              moment(response.data.playerlist.registerdate).format("DD-MM-yyyy")
            );
          }
          if (response.data.playerlist.username !== null) {
            Playerprofiledetails(response.data.playerlist.username).then(
              (res2) => {
                if (res2.status === true) {
                  if (res2.data.athletelist !== null) {
                    if (res2.data.athletelist.old_user_id !== null) {
                      const pltemp = new FormData();
                      pltemp.append(
                        "data_req",
                        "asmnt_data" + res2.data.athletelist.old_user_id
                      );
                      gettokenfromapi(pltemp).then((res) => {
                        if (res.status === true) {
                          sahassessmentdatelist(
                            "asmnt_data&esid=" +
                            res2.data.athletelist.old_user_id,
                            res.data
                          ).then((response) => {
                            if (response.assmts.length !== 0) {
                              if (response.assmts[0].esid !== undefined) {
                                if (response.assmts[0].chId !== null) {
                                  setAssList(response.assmts);
                                }
                              } else {
                                if (response.assmts[0].length !== 0) {
                                  setAssList(response.assmts[0]);
                                }
                              }
                            }

                            if (response.assmts[0].esid === undefined) {
                              if (response.assmts[0].length !== 0) {
                                if (response.assmts[0][0].assmts.length !== 0) {
                                  const fdata = response.assmts[0][0].assmts.filter(
                                    (data) => {
                                      return data.type === "fitness";
                                    }
                                  );
                                  setFitList(fdata);
                                  let origString = response.assmts[0][0].date;
                                  let stringToAdd = "-";
                                  let indexPosition = 2;
                                  let newString1 =
                                    origString.slice(0, indexPosition) +
                                    stringToAdd +
                                    origString.slice(indexPosition);
                                  let indexPosition1 = 5;
                                  let newString =
                                    newString1.slice(0, indexPosition1) +
                                    stringToAdd +
                                    newString1.slice(indexPosition1);
                                  setAssDate(newString);
                                  setSkillDate(newString);
                                  const sdata = response.assmts[0][0].assmts.filter(
                                    (data) => {
                                      return data.type === "skill";
                                    }
                                  );
                                  setSkillList(sdata);
                                }
                              }
                            }
                          });
                        }
                      });
                    }
                  }
                }
              }
            );
          }

          if (response.data.playerlist.age !== null) {
            setPAge(response.data.playerlist.age);
          }
          if (response.data.playerlist.emergency_contact_no !== null) {
            setPEmer(response.data.playerlist.emergency_contact_no);
          }
          if (response.data.playerlist.blood_group !== null) {
            setBGroup(response.data.playerlist.blood_group);
          }
          if (response.data.playerlist.permenant_address_one !== null) {
            setPAddr(response.data.playerlist.permenant_address_one);
          }
          if (response.data.playerlist.ESID !== null) {
            setPESID(response.data.playerlist.ESID);
          }
          if (response.data.playerlist.current_coach_name !== null) {
            setPCoach(response.data.playerlist.current_coach_name);
          }
          if (response.data.playerlist.past_coach_or_mentor !== null) {
            setPPastCoach(response.data.playerlist.past_coach_or_mentor);
          }
          if (response.data.playerlist.kit_size !== null) {
            setKSize(response.data.playerlist.kit_size);
          }
          if (response.data.playerlist.shoe_size !== null) {
            setSSize(response.data.playerlist.shoe_size);
          }
          if (response.data.playerlist.sdc_center !== null) {
            setSDCCenter(response.data.playerlist.sdc_center);
          }
          setAttDet(response.data.attendace_report);
          if (response.data.personal_timings.length != 0) {
            const formattedData = response.data.personal_timings.map(
              (item) => ({
                ...item,
                record_date:
                  item.record_date !== null
                    ? moment(item.record_date).format("DD-MM-YYYY")
                    : "",
              })
            );
            setPtDet(formattedData);
          }
          if (response.data.physical_health_data.length != 0) {
            const formattedData = response.data.physical_health_data.map(
              (item) => ({
                ...item,
                record_date:
                  item.record_date !== null
                    ? moment(item.record_date).format("DD-MM-YYYY")
                    : "",
              })
            );
            setPhDet(formattedData);
          }
          setPbDet(response.data.phychological_behavioral);
          setPSList(response.data.personal_details_sports);
          // let arr1 = [];
          // if (
          //   response.data.highest_level != "-" &&
          //   response.data.highest_level_event != "-" &&
          //   response.data.highest_level_sports != "-"
          // ) {
          //   arr1.push({
          //     highest_level: response.data.highest_level,
          //     highest_level_sports: response.data.highest_level_sports,
          //     highest_level_event: response.data.highest_level_event,
          //   });
          // }
          // setHList(arr1);
          setHList(response.data.highest_level_achievements);
          setUPath(response.data.player_files_path);
          setACList(response.data.athlete_contract_files);
          setCList(response.data.certificate_files);
          setMCList(response.data.media_coverage_files);
          setPList(response.data.photos_files);
          setVList(response.data.videos_files);
          setOFList(response.data.other_files_files);
          if (response.data.attendance_graph.length != 0) {
            const years = response.data.attendance_graph.map((item) => {
              const attendancePercentage = parseFloat(
                item.attendance_percentage
              );

              if (isNaN(attendancePercentage)) {
                return item.month_name + " (0%)";
              }

              const formattedPercentage =
                attendancePercentage % 1 === 0
                  ? attendancePercentage.toFixed(0)
                  : attendancePercentage.toFixed(2);

              return item.month_name + " (" + formattedPercentage + "%)";
            });
            const maleCounts = response.data.attendance_graph.map(
              (item) => item.total_present
            );
            const femaleCounts = response.data.attendance_graph.map(
              (item) => item.total_sessions_conducted
            );
            const pdata = {
              labels: years,
              datasets: [
                {
                  label: "Present",
                  data: maleCounts,
                  backgroundColor: "#25e3da",
                },
                {
                  label: "Session Conducted",
                  data: femaleCounts,
                  backgroundColor: "#f74dc1",
                },
              ],
            };
            setGAttDet(pdata);
          }
          listgraph(response.data.playerlist.school_id);
        }
      });
    }

    playerotherachievementlist(id).then((response) => {
      if (response.status === true) {
        let arr = [];
        let arr1 = [];
        if (response.data.length !== 0) {
          if (response.data.our_achievements.length !== 0) {
            arr = response.data.our_achievements;
          }
          if (response.data.other_achivements.length !== 0) {
            arr1 = response.data.other_achivements;
          }
          let arr2 = arr.concat(arr1);
          setFilterProduct(arr2);
        }
      }
    });

    if (window.innerWidth < 768) {
      const odata = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: "top",
          },
          title: {
            display: true,
            //   text: 'ABC',
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              text: "",
            },
          },
          y: {
            title: {
              display: true,
              text: "",
            },
          },
        },
      };
      setAOpts(odata);
    } else {
      const odata = {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            position: "top",
          },
          title: {
            display: true,
            //   text: 'ABC',
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              text: "",
            },
          },
          y: {
            title: {
              display: true,
              text: "",
            },
          },
        },
      };
      setAOpts(odata);
    }
  }
  function mergecheck(e, index) {
    if (simlist.length !== 0) {
      for (let i = 0; i < simlist.length; i++) {
        if (simlist[i].user_id !== id) {
          if (i === index) {
            simlist[i].check = e.target.checked;
            setSimList([...simlist]);
          } else {
            simlist[i].check = false;
            setSimList([...simlist]);
          }
        } else {
          simlist[i].check = true;
          setSimList([...simlist]);
        }
      }
    }
  }

  function unmergerplayer(eid, euser, ename) {
    if (eid !== "") {
      Swal.fire({
        title: "Are you sure want to delete the merge player?",
        showCancelButton: true,
        confirmButtonColor: "#d71635",
        confirmButtonText: "Ok",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          dotracking(
            "delete button in view player for " +
            ename +
            " (" +
            euser +
            " - " +
            eid +
            ") in " +
            fname +
            " (" +
            uname +
            " - " +
            id +
            ") $$ " +
            trackobj.playerdetheading
          );

          if (localStorage.getItem("Role") === "1") {
            similarunmergeplayer(id, eid).then((response) => {
              if (response.status === true) {
                toast.success(response.message);
                listsimilar(currentYear);
              } else {
                toast.error(response.message);
              }
            });
          } else if (localStorage.getItem("Role") === "3") {
            citysimilarunmergeplayer(id, eid).then((response) => {
              if (response.status === true) {
                toast.success(response.message);
                listsimilar(currentYear);
              } else {
                toast.error(response.message);
              }
            });
          }
        }
      });
    }
  }
  const [mshow, setMShow] = useState(false);
  function mergedata() {
    if (simlist.length !== 0) {
      var cnt = 0;

      for (let i = 0; i < simlist.length; i++) {
        if (simlist[i].user_id !== id) {
          if (simlist[i].check === true) {
            cnt = cnt + 1;
          }
        }

        simlist[i].radiouser = false;
        simlist[i].radioname = false;
        simlist[i].radiogender = false;
        simlist[i].radiodob = false;
        simlist[i].radioemail = false;
        simlist[i].radiomob = false;
        simlist[i].radiosch = false;
        simlist[i].radiocls = false;
        simlist[i].radiosec = false;
      }
      if (cnt === 0) {
        toast.error("Please Select the checkbox to merger the player details");
      } else {
        setMShow(true);
        // Swal.fire({
        //   title: "Are you sure want to merge the players?",
        //   showCancelButton: true,
        //   confirmButtonColor: "#d71635",
        //   confirmButtonText: "Ok",
        //   allowOutsideClick: false,
        // }).then((result) => {
        //   if (result.isConfirmed) {
        //     const temp = new FormData();
        //     temp.append("main_user_id", id);
        //     temp.append("duplicate_user_ids", muid);
        //     if (localStorage.getItem("Role") === "1") {
        //       similarmergeplayer(temp).then((response) => {
        //         if (response.status === true) {
        //           toast.success(response.message);
        //           listsimilar();
        //         } else {
        //           toast.error(response.message);
        //         }
        //       });
        //     } else if (localStorage.getItem("Role") === "3") {
        //       citysimilarmergeplayer(temp).then((response) => {
        //         if (response.status === true) {
        //           toast.success(response.message);
        //           listsimilar();
        //         } else {
        //           toast.error(response.message);
        //         }
        //       });
        //     }
        //   }
        // });
      }
    }
  }

  function mergeClose() {
    setMShow(false);
    setErrorMsg("");
    setMUName("");
    setMGender("");
    setMDOB("");
    setMMob("");
    setMEmail("");
    setMSch("");
    setMClass("");
    setMClassName("");
    setMSection("");
    setMUID("");
    setMDUID("");
  }
  const [muname, setMUName] = useState("");
  const [muid, setMUID] = useState("");
  const [mduid, setMDUID] = useState("");
  function mradiouser(index, ume) {
    if (simlist.length !== 0) {
      for (let i = 0; i < simlist.length; i++) {
        if (i === index) {
          setMUName(ume);
          setMUID(simlist[i].user_id);
          setMFName(simlist[i].first_name);
          setMGender(simlist[i].gender);
          setMDOB(simlist[i].date_of_birth);
          setMMob(simlist[i].mobile_no);
          setMEmail(simlist[i].email_id);
          setMSch(simlist[i].school_id);
          setMClass(simlist[i].class_id);
          setMClassName(simlist[i].class_name);
          setMSection(simlist[i].section);

          simlist[i].radiouser = true;
          setSimList([...simlist]);
        } else {
          if (simlist[i].check === true) {
            setMDUID(simlist[i].user_id);
          }
          simlist[i].radiouser = false;
          simlist[i].radioname = false;
          simlist[i].radiogender = false;
          simlist[i].radiodob = false;
          simlist[i].radiomob = false;
          simlist[i].radioemail = false;
          simlist[i].radiocls = false;
          simlist[i].radiosch = false;
          simlist[i].radiosec = false;

          setSimList([...simlist]);
        }
      }
    }
  }

  const [mfname, setMFName] = useState("");

  function mradioname(index, ume) {
    if (muname !== "") {
      simlist[index].radioname = !ume;
      setSimList([...simlist]);
      if (simlist[index].radioname === true) {
        setMFName(simlist[index].first_name);
      } else {
        for (let i = 0; i < simlist.length; i++) {
          if (simlist[i].check === true) {
            if (i !== index) {
              simlist[i].radioname = true;
              setSimList([...simlist]);
              setMFName(simlist[i].first_name);
            }
          }
        }
      }
    } else {
      setErrorMsg("Please select Username (UID) of Main Player");
    }
  }

  const [mgender, setMGender] = useState("");
  function mradiogender(index, ume) {
    if (muname !== "") {
      simlist[index].radiogender = !ume;
      setSimList([...simlist]);
      if (simlist[index].radiogender === true) {
        setMGender(simlist[index].gender);
      } else {
        for (let i = 0; i < simlist.length; i++) {
          if (simlist[i].check === true) {
            if (i !== index) {
              simlist[i].radiogender = true;
              setSimList([...simlist]);
              setMGender(simlist[i].gender);
            }
          }
        }
      }
    } else {
      setErrorMsg("Please select Username (UID) of Main Player");
    }
  }

  const [mdob, setMDOB] = useState("");
  function mradiodob(index, ume) {
    if (muname !== "") {
      simlist[index].radiodob = !ume;
      setSimList([...simlist]);
      if (simlist[index].radiodob === true) {
        setMDOB(simlist[index].date_of_birth);
      } else {
        for (let i = 0; i < simlist.length; i++) {
          if (simlist[i].check === true) {
            if (i !== index) {
              simlist[i].radiodob = true;
              setSimList([...simlist]);
              setMDOB(simlist[i].date_of_birth);
            }
          }
        }
      }
    } else {
      setErrorMsg("Please select Username (UID) of Main Player");
    }
  }

  const [mmob, setMMob] = useState("");
  function mradiomob(index, ume) {
    if (muname !== "") {
      simlist[index].radiomob = !ume;
      setSimList([...simlist]);
      if (simlist[index].radiomob === true) {
        setMMob(simlist[index].mobile_no);
      } else {
        for (let i = 0; i < simlist.length; i++) {
          if (simlist[i].check === true) {
            if (i !== index) {
              simlist[i].radiomob = true;
              setSimList([...simlist]);
              setMMob(simlist[i].mobile_no);
            }
          }
        }
      }
    } else {
      setErrorMsg("Please select Username (UID) of Main Player");
    }
  }

  const [memail, setMEmail] = useState("");
  function mradioemail(index, ume) {
    if (muname !== "") {
      simlist[index].radioemail = !ume;
      setSimList([...simlist]);
      if (simlist[index].radioemail === true) {
        setMEmail(simlist[index].email_id);
      } else {
        for (let i = 0; i < simlist.length; i++) {
          if (simlist[i].check === true) {
            if (i !== index) {
              simlist[i].radioemail = true;
              setSimList([...simlist]);
              setMEmail(simlist[i].email_id);
            }
          }
        }
      }
    } else {
      setErrorMsg("Please select Username (UID) of Main Player");
    }
  }

  const [msch, setMSch] = useState("");
  function mradiosch(index, ume) {
    if (muname !== "") {
      simlist[index].radiosch = !ume;
      setSimList([...simlist]);
      if (simlist[index].radiosch === true) {
        setMSch(simlist[index].school_id);
      } else {
        for (let i = 0; i < simlist.length; i++) {
          if (simlist[i].check === true) {
            if (i !== index) {
              simlist[i].radiosch = true;
              setSimList([...simlist]);
              setMSch(simlist[i].school_id);
            }
          }
        }
      }
    } else {
      setErrorMsg("Please select Username (UID) of Main Player");
    }
  }

  const [mcls, setMClass] = useState("");
  const [mclsname, setMClassName] = useState("");

  function mradioclass(index, ume) {
    if (muname !== "") {
      simlist[index].radiocls = !ume;
      setSimList([...simlist]);
      if (simlist[index].radiocls === true) {
        setMClass(simlist[index].class_id);
        setMClassName(simlist[index].class_name);
      } else {
        for (let i = 0; i < simlist.length; i++) {
          if (simlist[i].check === true) {
            if (i !== index) {
              simlist[i].radiocls = true;
              setSimList([...simlist]);
              setMClass(simlist[i].class_id);
              setMClassName(simlist[index].class_name);
            }
          }
        }
      }
    } else {
      setErrorMsg("Please select Username (UID) of Main Player");
    }
  }

  const [msec, setMSection] = useState("");
  function mradiosection(index, ume) {
    if (muname !== "") {
      simlist[index].radiosec = !ume;
      setSimList([...simlist]);
      if (simlist[index].radiosec === true) {
        setMSection(simlist[index].section);
      } else {
        for (let i = 0; i < simlist.length; i++) {
          if (simlist[i].check === true) {
            if (i !== index) {
              simlist[i].radiosec = true;
              setSimList([...simlist]);
              setMSection(simlist[i].section);
            }
          }
        }
      }
    } else {
      setErrorMsg("Please select Username (UID) of Main Player");
    }
  }

  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [fshow, setFShow] = useState(false);

  function mPClose() {
    setFShow(false);
  }
  function mergeplayer(e) {
    e.preventDefault();
    setFShow(true);
  }

  function mergedprofiles(e) {
    e.preventDefault();
    setErrorMsg([]);

    if (muname !== "") {
      setLoading(true);
      const temp = new FormData();
      temp.append("main_user_id", muid);
      temp.append("duplicate_user_ids", mduid);
      temp.append("email_id", memail);
      temp.append("mobile_no", mmob);
      temp.append("first_name", mfname);
      temp.append("date_of_birth", mdob);
      temp.append("gender", mgender);
      temp.append("class", mcls);
      temp.append("section", msec);
      temp.append("username", muname);
      dotracking(
        "merge button in view player for " +
        fname +
        " (" +
        uname +
        " - " +
        id +
        ") $$ " +
        trackobj.playerdetheading
      );

      similarmergeplayer(temp).then((response) => {
        if (response.status === true) {
          setLoading(false);
          mPClose();
          mergeClose();
          toast.success(response.message);
          listsimilar(currentYear);
        } else {
          setLoading(false);
          toast.error(response.message);
        }
      });
    } else {
      setErrorMsg("Please select Username (UID) of Main Player");
    }
  }
  const [bshow, setBShow] = useState(false);
  function blockShow() {
    setRReason("");
    setRemarks("");
    setBShow(true);
  }

  function blockClose() {
    setRReason("");
    setRemarks("");
    setBShow(false);
  }

  function blockathlete() {
    dotracking(
      "block button in view player for " +
      fname +
      " (" +
      uname +
      " - " +
      id +
      ") $$ " +
      trackobj.playerdetheading
    );
    blocked(id, rreason, rremark).then((response) => {
      if (response.status === true) {
        setBShow(false);
        navigate("/superadmin/blockedplayers");
        toast.success(response.message);
      }
    });
  }

  const [ubshow, setUBShow] = useState(false);
  function unblockShow() {
    setRReason("");
    setRemarks("");
    setUBShow(true);
  }

  function unblockClose() {
    setRReason("");
    setRemarks("");
    setUBShow(true);
  }

  function unblockathlete() {
    dotracking(
      "unblock button in view player for " +
      fname +
      " (" +
      uname +
      " - " +
      id +
      ") $$ " +
      trackobj.playerdetheading
    );
    unblocked(id, rreason, rremark).then((response) => {
      if (response.status === true) {
        setUBShow(false);
        navigate("/superadmin/allplayers");
        toast.success(response.message);
      }
    });
  }

  function editlist(lid) {
    dotracking(
      "edit button in view player for " +
      fname +
      " (" +
      uname +
      " - " +
      id +
      ") $$ " +
      trackobj.editplayerheading
    );

    if (localStorage.getItem("Role") === "1") {
      if (lid == 2) {
        localStorage.setItem("PEdit", 2);
      }
      navigate("/superadmin/editplayer/" + id);
    } else if (localStorage.getItem("Role") === "3") {
      navigate("/cityregional/editplayer/" + id);
    } else if (localStorage.getItem("Role") === "4") {
      navigate("/schoolhead/editplayer/" + id);
    } else if (localStorage.getItem("Role") === "7") {
      navigate("/coach/editplayer/" + id);
    }
  }

  function perflist() {
    dotracking(
      "overall performance button in view player for " +
      fname +
      " (" +
      uname +
      " - " +
      id +
      ") $$ " +
      trackobj.overperfheading
    );
    if (urlhead === "viewplayer") {
      localStorage.setItem("PID", "1");
    } else if (urlhead === "tournamentplayer") {
      localStorage.setItem("PID", "2");
    }
    if (localStorage.getItem("Role") === "1") {
      navigate("/superadmin/overallperformanceplayer/" + id);
    } else if (localStorage.getItem("Role") === "3") {
      navigate("/cityregional/overallperformanceplayer/" + id);
    } else if (localStorage.getItem("Role") === "4") {
      navigate("/schoolhead/overallperformanceplayer/" + id);
    } else if (localStorage.getItem("Role") === "7") {
      navigate("/coach/overallperformanceplayer/" + id);
    }
  }

  function perftourlist() {
    dotracking(
      "tournament wise performance button in view player for " +
      fname +
      " (" +
      uname +
      " - " +
      id +
      ") $$ " +
      trackobj.tourperfheading
    );
    if (urlhead === "viewplayer") {
      localStorage.setItem("PID", "1");
    } else if (urlhead === "tournamentplayer") {
      localStorage.setItem("PID", "2");
    }
    if (localStorage.getItem("Role") === "1") {
      navigate("/superadmin/viewperformanceplayer/" + id);
    } else if (localStorage.getItem("Role") === "3") {
      navigate("/cityregional/viewperformanceplayer/" + id);
    } else if (localStorage.getItem("Role") === "4") {
      navigate("/schoolhead/viewperformanceplayer/" + id);
    } else if (localStorage.getItem("Role") === "7") {
      navigate("/coach/viewperformanceplayer/" + id);
    }
  }

  function backlist() {
    if (urlhead === "tournamentplayer") {
      dotracking(
        "back button in tournament player detail for player " +
        fname +
        " (" +
        uname +
        " - " +
        id +
        ") $$ " +
        trackobj.tourplayerlistheading
      );
      navigate(-1);
    } else if (urlhead === "funderviewplayer") {
      dotracking(
        "back button in funder player detail for player " +
        fname +
        " (" +
        uname +
        " - " +
        id +
        ") $$ " +
        trackobj.playerlistheading
      );
      navigate("/superadmin/funderplayerlist/" + eid);
    } else if (urlhead === "paymentdetail") {
      dotracking(
        "back button in payment detail for player " +
        fname +
        " (" +
        uname +
        " - " +
        id +
        ") $$ " +
        trackobj.paylistheading
      );
      navigate("/superadmin/payment");
    } else {
      if (localStorage.getItem("Role") === "1") {
        if (status === 1) {
          dotracking(
            "back button in view player for " +
            fname +
            " (" +
            uname +
            " - " +
            id +
            ") $$ " +
            trackobj.playerlistheading
          );
          navigate("/superadmin/allplayers");
        } else if (status === 3) {
          dotracking(
            "back button in view player for " +
            fname +
            " (" +
            uname +
            " - " +
            id +
            ") $$ " +
            trackobj.blockedplalistheading
          );
          navigate("/superadmin/blockedplayers");
        }
      } else if (localStorage.getItem("Role") === "3") {
        if (localStorage.getItem("list") === "1") {
          dotracking(
            "back button in view player for " +
            fname +
            " (" +
            uname +
            " - " +
            id +
            ") $$ " +
            trackobj.playerlistheading
          );
          navigate("/cityregional/listplayers/" + schid);
        } else if (localStorage.getItem("list") === "2") {
          dotracking(
            "back button in view player for " +
            fname +
            " (" +
            uname +
            " - " +
            id +
            ") $$ " +
            trackobj.playerlistheading
          );
          navigate("/cityregional/funderlistplayers/" + schid);
        }
      } else if (localStorage.getItem("Role") === "4") {
        dotracking(
          "back button in view player for " +
          fname +
          " (" +
          uname +
          " - " +
          id +
          ") $$ " +
          trackobj.playerlistheading
        );
        navigate("/schoolhead/allplayers");
      } else if (localStorage.getItem("Role") === "7") {
        dotracking(
          "back button in view player for " +
          fname +
          " (" +
          uname +
          " - " +
          id +
          ") $$ " +
          trackobj.playerlistheading
        );
        navigate("/coach/allplayers");
      } else if (localStorage.getItem("Role") === "8") {
        if (localStorage.getItem("Cat") === "1") {
          dotracking(
            "back button in view player for " +
            fname +
            " (" +
            uname +
            " - " +
            id +
            ") $$ " +
            trackobj.achievelistheading
          );
          navigate("/funder/achievementlist");
        } else {
          dotracking(
            "back button in view player for " +
            fname +
            " (" +
            uname +
            " - " +
            id +
            ") $$ " +
            trackobj.benelistheading
          );
          navigate("/funder/beneficiarylist");
        }
      }
    }
  }

  function viewasslist(vid) {
    dotracking(
      "view icon in assessment list for (" +
      vid +
      ") " +
      fname +
      " (" +
      uname +
      ") $$ " +
      trackobj.assdetheading
    );
    navigate("/funder/assessmentdetail/" + vid + "/" + id);
  }

  function viewlist(vid, vname, vuser) {
    dotracking(
      "view icon in similar profile list of view player for player " +
      fname +
      " (" +
      uname +
      " - " +
      id +
      "), redirect to the player " +
      vname +
      " (" +
      vuser +
      " - " +
      vid +
      ") $$ " +
      trackobj.playerlistheading
    );
    const url = window.location.href;
    const head = url.split("/#/");
    if (localStorage.getItem("Role") === "1") {
      window.open(`${head[0]}/#/superadmin/viewplayer/` + vid, "_blank");
    } else if (localStorage.getItem("Role") === "3") {
      window.open(`${head[0]}/#/cityregional/viewplayer/` + vid, "_blank");
    } else if (localStorage.getItem("Role") === "4") {
      window.open(`${head[0]}/#/schoolhead/viewplayer/` + vid, "_blank");
    } else if (localStorage.getItem("Role") === "7") {
      window.open(`${head[0]}/#/coach/viewplayer/` + vid, "_blank");
    }
  }

  const [photo, setPhoto] = useState("");

  function errorhandle(ev) {
    ev.target.src = require("../../../../assets/images/users.png");
    ev.target.onerror = null;
  }

  const [rname, setRName] = useState("");
  const [rdesc, setRDesc] = useState("");
  const [rfile, setRFile] = useState("");
  const [show, setShow] = useState(false);

  function handlepop(fname, fdesc, ffile) {
    setRName(fname);
    setRDesc(fdesc);
    setRFile(fpath + ffile);
    setShow(true);
  }

  function imageclose() {
    setShow(false);
    setRName("");
    setRDesc("");
    setRFile("");
  }

  const [imagetype, setImageType] = useState("");
  const [fushow, setFUShow] = useState(false);
  const [filetype, setFileType] = useState("");

  function handleupload(htype) {
    setImageType(htype);
    setFileType("");
    setUPhoto([]);
    setPErrorMsg([]);
    setFError("");
    setLinks([{ link: "", timage: "", timageerr: "" }]);
    setFUShow(true);
  }

  function uploadclose() {
    setImageType("");
    setFileType("");
    setFError("");
    setUPhoto([]);
    setPErrorMsg([]);
    setLinks([{ link: "", timage: "", timageerr: "" }]);
    setFUShow(false);
  }

  let arr = [];
  let arr1 = [];
  const [uphoto, setUPhoto] = useState([]);
  const [perrorMsg, setPErrorMsg] = useState([]);

  function photofile(event) {
    for (let i = 0; i < event.target.files.length; i++) {
      if (event.target.files.length !== 0) {
        if (event.target.files[i].name.match(/\.(jpg|jpeg|png|pdf)$/i)) {
          var size = event.target.files[i].size / 1024 / 1024;
          if (size > 5) {
            arr1.push(
              event.target.files[i].name + " size should be less than 5MB"
            );
            setPErrorMsg([...arr1]);
          } else {
            arr.push(event.target.files[i]);
          }
        } else {
          arr1.push(
            event.target.files[i].name +
            " should be jpg or jpeg or png or pdf format"
          );
        }
      }
    }
    setUPhoto(arr);
    setUPhoto([...uphoto, ...arr]);
    setPErrorMsg(arr1);
    setPErrorMsg([...perrorMsg, ...arr1]);
  }

  const [links, setLinks] = useState([{ link: "", timage: "", timageerr: "" }]);

  const handleAddLink = () => {
    setLinks([...links, { link: "", timage: "", timageerr: "" }]);
  };

  const handleDeleteLink = (index) => {
    const updatedLinks = links.filter((_, i) => i !== index);
    setLinks(updatedLinks);
  };

  const handleLinkChange = (index, field, value) => {
    const updatedLinks = links.map((link, i) =>
      i === index ? { ...link, [field]: value } : link
    );
    setLinks(updatedLinks);
  };

  function thumbfile(event, index) {
    const updatedLinks = [...links];
    updatedLinks[index].timageerr = "";
    updatedLinks[index].timage = "";
    setLinks(updatedLinks);
    if (event.target.files.length !== 0) {
      if (event.target.files[0].name.match(/\.(mp4|mp3|wav|mkv)$/i)) {
        updatedLinks[index].timage = event.target.files[0];
        setLinks(updatedLinks);
      } else {
        updatedLinks[index].timageerr =
          "Video should be mp4, mp3, wav or mkv format";
        setLinks(updatedLinks);
      }
      var size = event.target.files[0].size / 1024 / 1024;
      if (size > 10) {
        updatedLinks[index].timageerr = "Video size should be less than 10MB";
        setLinks(updatedLinks);
      }
    }
  }

  const [ferror, setFError] = useState("");
  function submitfiles(e) {
    e.preventDefault();
    setFError("");
    if (imagetype !== "Videos") {
      if (uphoto.length !== 0) {
        const temp = new FormData();
        temp.append("admin_id", localStorage.getItem("UID"));
        temp.append("user_id", id);
        temp.append("file_count", uphoto.length);
        temp.append("file_upload_type", imagetype);
        if (uphoto.length != 0) {
          for (let i = 0; i < uphoto.length; i++) {
            if (uphoto[i] !== "") {
              const lastThree = uphoto[i].name.slice(-3);
              if (lastThree !== "pdf") {
                temp.append("file_type_" + [i + 1], "Image");
              } else if (lastThree == "pdf") {
                temp.append("file_type_" + [i + 1], "PDF");
              }
              temp.append("uploads_file_" + [i + 1], uphoto[i]);
            }
          }
        }
        assessmentfileupload(temp).then((res) => {
          if (res.status === true) {
            listsimilar(currentYear);
            uploadclose();
            toast.success(res.message);
          }
        });
      } else {
        setFError("Please Upload Files");
      }
    } else {
      var valid = "";
      if (filetype !== "") {
        const isValiderr = links.every(
          (row) => row.link !== "" && row.timage !== ""
        );
        if (!isValiderr) {
          const isValid = links.every((row) => row.link !== "");
          const isError = links.every((row) => row.timage !== "");
          if (!isValid && filetype === "URL") {
            valid = "Please Enter URL";
            setFError("Please Enter URL");
          }
          if (!isError && filetype === "Video") {
            valid = "Please Upload Video";
            setFError("Please Upload Video");
          }
          if (valid === "") {
            const temp = new FormData();
            temp.append("admin_id", localStorage.getItem("UID"));
            temp.append("user_id", id);
            temp.append("file_upload_type", imagetype);
            temp.append("file_count", links.length);

            if (links.length != 0) {
              for (let i = 0; i < links.length; i++) {
                if (filetype === "URL") {
                  temp.append("file_type_" + [i + 1], filetype);
                  temp.append("file_url_" + [i + 1], links[i].link);
                } else if (filetype === "Video") {
                  temp.append("file_type_" + [i + 1], filetype);
                  temp.append("uploads_file_" + [i + 1], links[i].timage);
                }
              }
            }
            assessmentfileupload(temp).then((res) => {
              if (res.status === true) {
                listsimilar(currentYear);
                uploadclose();
                toast.success(res.message);
              }
            });
          }
        } else {
          if (filetype === "URL") {
            setFError("Please Enter URL");
          } else if (filetype === "Video") {
            setFError("Please Upload Video");
          }
        }
      } else {
        setFError("Please Select File Type");
      }
    }
  }

  const [ushow, setUShow] = useState(false);
  const [udetail, setUDetail] = useState("");
  function udetshow(udet) {
    setUShow(true);
    setUDetail(udet);
  }

  function udetclose() {
    setUShow(false);
    setUDetail("");
  }

  function deleteres(rid, ddata) {
    Swal.fire({
      title: "Are you sure want to delete?",
      showCancelButton: true,
      confirmButtonColor: "#4ecc48",
      cancelButtonColor: "#ac0404",
      confirmButtonText: "Yes",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        dotracking(
          "delete icon in " +
          ddata +
          "(" +
          rid +
          ") $$ " +
          trackobj.playerlistheading
        );
        const temp = new FormData();
        temp.append("file_id", rid);
        deletefileinprofile(temp).then((response) => {
          if (response.status === true) {
            loadfiles();
            toast.success(response.message);
          }
        });
      }
    });
  }

  function loadfiles() {
    setACList([]);
    setCList([]);
    setMCList([]);
    setPList([]);
    setVList([]);
    setOFList([]);
    if (localStorage.getItem("Role") === "1") {
      viewprofile(id, tyear).then((response) => {
        if (response.status === true) {
          setUPath(response.data.player_files_path);
          setACList(response.data.athlete_contract_files);
          setCList(response.data.certificate_files);
          setMCList(response.data.media_coverage_files);
          setPList(response.data.photos_files);
          setVList(response.data.videos_files);
          setOFList(response.data.other_files_files);
        }
      });
    }
  }
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage] = useState(12);

  const totalRecordsToShow = currentPage * recordsPerPage;
  const currentRecords = aclist ? aclist.slice(0, totalRecordsToShow) : [];

  const loadMore = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const [certcurrentPage, setCertCurrentPage] = useState(1);
  const certRecordsToShow = certcurrentPage * recordsPerPage;
  const certcurrentRecords = clist ? clist.slice(0, certRecordsToShow) : [];

  const certloadMore = () => {
    setCertCurrentPage((prevPage) => prevPage + 1);
  };

  const [mediacurrentPage, setMediaCurrentPage] = useState(1);
  const mediaRecordsToShow = mediacurrentPage * recordsPerPage;
  const mediacurrentRecords = mclist ? mclist.slice(0, mediaRecordsToShow) : [];

  const medialoadMore = () => {
    setMediaCurrentPage((prevPage) => prevPage + 1);
  };

  const [photocurrentPage, setPhotoCurrentPage] = useState(1);
  const photoRecordsToShow = photocurrentPage * recordsPerPage;
  const photocurrentRecords = plist ? plist.slice(0, photoRecordsToShow) : [];

  const photoloadMore = () => {
    setPhotoCurrentPage((prevPage) => prevPage + 1);
  };

  const [videocurrentPage, setVideoCurrentPage] = useState(1);
  const videoRecordsToShow = videocurrentPage * recordsPerPage;
  const videocurrentRecords = vlist ? vlist.slice(0, videoRecordsToShow) : [];

  const videoloadMore = () => {
    setVideoCurrentPage((prevPage) => prevPage + 1);
  };

  const [othercurrentPage, setOtherCurrentPage] = useState(1);
  const otherRecordsToShow = othercurrentPage * recordsPerPage;
  const othercurrentRecords = oflist ? oflist.slice(0, otherRecordsToShow) : [];

  const otherloadMore = () => {
    setOtherCurrentPage((prevPage) => prevPage + 1);
  };

  function deletesport(sid, sdata) {
    Swal.fire({
      text: "Are you sure want to delete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ac0404",
      cancelButtonColor: "#6259ca",
      confirmButtonText: "Delete",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        dotracking(
          "delete icon in sports profile detail list for " +
          sdata.sports_name +
          " - sports , " +
          sdata.event_name +
          " - event , " +
          sdata.tournament_level +
          " - tournament level (" +
          sid +
          ") $$ " +
          trackobj.playerdetheading
        );
        const temp = new FormData();
        temp.append("id", sid);
        sportsprofiledetaildelete(temp).then((res) => {
          if (res.status === true) {
            toast.success(res.message);
            listsimilar(currentYear);
          } else {
            toast.error(res.message);
          }
        });
      }
    });
  }

  function deletetiming(sid, sdata) {
    Swal.fire({
      text: "Are you sure want to delete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ac0404",
      cancelButtonColor: "#6259ca",
      confirmButtonText: "Delete",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        dotracking(
          "delete icon in personal timings list for " +
          sdata.sports_name +
          " - sports , " +
          sdata.event_name +
          " - event , " +
          sdata.timing_timestamp +
          " - timing , " +
          sdata.record_date +
          " - record date (" +
          sid +
          ") $$ " +
          trackobj.playerdetheading
        );
        const temp = new FormData();
        temp.append("id", sid);
        personaltimingdelete(temp).then((res) => {
          if (res.status === true) {
            toast.success(res.message);
            listsimilar(currentYear);
          } else {
            toast.error(res.message);
          }
        });
      }
    });
  }

  function deletehealth(sid, sdata) {
    Swal.fire({
      text: "Are you sure want to delete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ac0404",
      cancelButtonColor: "#6259ca",
      confirmButtonText: "Delete",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        dotracking(
          "delete icon in physical health list for " +
          sdata.height +
          " - height , " +
          sdata.weight +
          " - weight , " +
          sdata.body_mass_index +
          " - body mass index , " +
          sdata.past_injuries +
          " - past injuires , " +
          sdata.diet_chart +
          " - diet chart " +
          sdata.known_health +
          " - health conditions (" +
          sid +
          ") $$ " +
          trackobj.playerdetheading
        );
        const temp = new FormData();
        temp.append("id", sid);
        physicalhealthdelete(temp).then((res) => {
          if (res.status === true) {
            toast.success(res.message);
            listsimilar(currentYear);
          } else {
            toast.error(res.message);
          }
        });
      }
    });
  }

  function deletebehave(sid, sdata) {
    Swal.fire({
      text: "Are you sure want to delete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ac0404",
      cancelButtonColor: "#6259ca",
      confirmButtonText: "Delete",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        dotracking(
          "delete icon in physicalogical behavioral list for " +
          sdata.personality_traits +
          " - personality traits , " +
          sdata.goals_short_term +
          " - goals short term , " +
          sdata.goals_long_term +
          " - goals long term , " +
          sdata.role_model +
          " - role model " +
          sdata.sports_psycholody_assessments +
          " - sports psychology assessments (" +
          sid +
          ") $$ " +
          trackobj.playerdetheading
        );
        const temp = new FormData();
        temp.append("id", sid);
        phychologydelete(temp).then((res) => {
          if (res.status === true) {
            toast.success(res.message);
            listsimilar(currentYear);
          } else {
            toast.error(res.message);
          }
        });
      }
    });
  }

  function deleteattendance(sid, sdata) {
    Swal.fire({
      text: "Are you sure want to delete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ac0404",
      cancelButtonColor: "#6259ca",
      confirmButtonText: "Delete",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        dotracking(
          "delete icon in attendance list for " +
          sdata.attendance_date +
          " - attendance date , " +
          sdata.present_or_absent +
          " - present or absent (" +
          sid +
          ") $$ " +
          trackobj.playerdetheading
        );
        const temp = new FormData();
        temp.append("id", sid);
        attendancedelete(temp).then((res) => {
          if (res.status === true) {
            toast.success(res.message);
            listsimilar(currentYear);
          } else {
            toast.error(res.message);
          }
        });
      }
    });
  }
  const [ptsport, setPTSport] = useState("");
  const [pevent, setPEvent] = useState(0);
  const [pelist, setPEList] = useState([]);
  const [sname, setSName] = useState("");
  const [stype, setSType] = useState("");
  const [elist, setEList] = useState([]);

  function personalsport(e, ptype) {
    setPTSport(e.target.value);
    setSName("");
    setPEvent("");
    setPEList([]);
    setSType(ptype);
    setPTData("");

    if (e.target.value !== null) {
      const data = slist.find((item) => item.sports_cat_uid == e.target.value);
      setSName(data.sports_category);

      eventsmasterlist().then((response) => {
        if (response.status === true) {
          if (response.data.length !== 0) {
            setEList(response.data);
            for (let i = 0; i < response.data.length; i++) {
              if (response.data[i].is_active === 1) {
                arr.push({
                  value: response.data[i].event_uid,
                  label: response.data[i].event_name,
                });
              }
            }
          }
          setPEList(arr);
        }
      });

      loadperson(e.target.value, 0, stype);
    }
  }

  function handleEvent(e) {
    setPTData("");
    if (e != null) {
      setPEvent(e);
      loadperson(ptsport, e, stype);
    } else {
      setPEvent("");
      loadperson(ptsport, 0, stype);
    }
  }

  // const convertToMinutes = (timeStr) => {
  //   const timeParts = timeStr.split(':');
  //   let totalSeconds = 0;

  //   // Handle different formats (HH:mm:ss or mm:ss)
  //   if (timeParts.length === 3) {
  //     // Format HH:mm:ss
  //     const hours = parseInt(timeParts[0], 10);
  //     const minutes = parseInt(timeParts[1], 10);
  //     const seconds = parseInt(timeParts[2], 10);
  //     totalSeconds = (hours * 3600) + (minutes * 60) + seconds;
  //   } else if (timeParts.length === 2) {
  //     // Format mm:ss
  //     const minutes = parseInt(timeParts[0], 10);
  //     const seconds = parseInt(timeParts[1], 10);
  //     totalSeconds = (minutes * 60) + seconds;
  //   }

  //   // Convert seconds to minutes (as a decimal value)
  //   return totalSeconds / 60;
  // };

  // function convertToMinutes(timeString) {
  //   const [minutes, seconds] = timeString.split(":");
  //   const [sec, hundredths] = seconds.split(".");
  //   return parseInt(minutes) + (parseInt(sec) / 60) + (parseInt(hundredths) / 6000);
  // }
  // function convertToMinutes(timeString) {
  //   const timeParts = timeString.split(":");

  //   let minutes = 0;
  //   let seconds = 0;

  //   if (timeParts.length === 2) {
  //     // Time format is mm:ss
  //     minutes = parseInt(timeParts[0], 10);
  //     const [sec, hundredths] = timeParts[1].split(".");
  //     // let hund = hundredths ? hundredths/60 : 0;
  //     seconds =
  //       parseInt(sec, 10) + (hundredths ? parseInt(hundredths, 10) / 60 : 0);

  //   } else if (timeParts.length === 3) {
  //     // Time format is hh:mm:ss
  //     const hours = parseInt(timeParts[0], 10);
  //     minutes = parseInt(timeParts[1], 10);
  //     const [sec, hundredths] = timeParts[2].split(".");
  //     seconds =
  //       parseInt(sec, 10) + (hundredths ? parseInt(hundredths, 10) / 100 : 0);
  //     minutes += hours * 60;
  //   }
  //   if (minutes > 0) {
  //     return minutes + (seconds / 60);
  //     // return minutes + "." + seconds;
  //   } else {
  //     return minutes + seconds;
  //   }

  //   // return minutes + (seconds / 60);
  // }

  //mm:ss.sss
  // function convertToMinutes(timeString) {
  //   const parts = timeString.split(":");

  //   let minutes = 0,
  //     seconds = 0,
  //     hundredths = 0;

  //   if (parts.length === 2) {
  //     // Format: mm:ss.hundredths
  //     minutes = parseInt(parts[0], 10);
  //     const [sec, hund] = parts[1].split(".");
  //     seconds = parseInt(sec, 10);
  //     hundredths = hund ? parseInt(hund, 10) : 0;
  //   } else if (parts.length === 3) {
  //     // Format: mm:ss:hundredths
  //     minutes = parseInt(parts[0], 10);
  //     seconds = parseInt(parts[1], 10);
  //     hundredths = parseInt(parts[2], 10);
  //   } else {
  //     console.log("Unsupported time format");
  //   }

  //   const totalSeconds = seconds + hundredths / 100;
  //   return minutes + totalSeconds / 60;
  // }
  function convertToMinutes(timeString) {
    // Remove trailing 's' if present (e.g., "10:04.58s" -> "10:04.58")
    const cleanedTime = timeString.replace(/s$/i, "");
    const parts = cleanedTime.split(":");

    let hours = 0,
      minutes = 0,
      seconds = 0,
      milliseconds = 0;

    if (parts.length === 3) {
      // Format: hh:mm:ss.sss
      hours = parseInt(parts[0], 10);
      minutes = parseInt(parts[1], 10);

      const secParts = parts[2].split(".");
      seconds = parseInt(secParts[0], 10);
      milliseconds = secParts[1] ? parseInt(secParts[1].padEnd(3, "0"), 10) : 0;
    } else if (parts.length === 2) {
      // Format: mm:ss.ss (e.g., "10:04.58")
      minutes = parseInt(parts[0], 10);

      const secParts = parts[1].split(".");
      seconds = parseInt(secParts[0], 10);
      milliseconds = secParts[1] ? parseInt(secParts[1].padEnd(3, "0"), 10) : 0;
    } else {
      return 0;
    }

    const totalSeconds =
      hours * 3600 + minutes * 60 + seconds + milliseconds / 1000;
    return totalSeconds / 60;
  }
  const targetImg = new Image();
  targetImg.src = "../../../../assets/images/target.png";
  const [copts, setCOpts] = useState({});

  const [ptdata, setPTData] = useState("");
  // function loadperson(sp, ev, tpe) {
  //   setSType(tpe);
  //   setPTData("");
  //   const etype = elist.find(
  //     (item) => item.event_uid === (ev != 0 ? ev.value : 0)
  //   );
  //   const eventTypeName = etype ? etype.event_type_name : null;
  //   const temp = new FormData();
  //   temp.append("sports_id", sp);
  //   temp.append("event_id", ev != 0 ? ev.value : 0);
  //   temp.append("user_id", id);
  //   temp.append("competition_training", tpe);
  //   viewpersonaltimingapi(temp).then((res) => {
  //     if (res.status === true) {
  //       if (res.data && res.data.physical_assessment_record_date.length > 0) {
  //         let normValueInMinutes = 0;
  //         let timingData = [];
  //         let targetData = [];
  //         if (sname.toUpperCase() === "ATHLETICS" && eventTypeName == "Track") {
  //           normValueInMinutes =
  //             res.data.norm_value !== 0
  //               ? convertToMinutes(res.data.norm_value)
  //               : 0;

  //           timingData = res.data.physical_assessment_record_date.map((item) =>
  //             convertToMinutes(item.timing_timestamp)
  //           );

  //           targetData = res.data.physical_assessment_record_date.map((item) =>
  //             convertToMinutes(item.target)
  //           );
  //         } else {
  //           normValueInMinutes = res.data.norm_value;
  //           timingData = res.data.physical_assessment_record_date.map(
  //             (item) => {
  //               const raw = item.timing_timestamp;
  //               return parseFloat(raw.replace(/[^\d.]/g, ""));
  //             }
  //           );
  //           targetData = res.data.physical_assessment_record_date.map(
  //             (item) => item.target
  //           );
  //         }
  //         const originalTimingData =
  //           res.data.physical_assessment_record_date.map(
  //             (item) => item.timing_timestamp
  //           );
  //         const originalTargetData =
  //           res.data.physical_assessment_record_date.map((item) => item.target);
  //         const labels = res.data.physical_assessment_record_date.map(
  //           (item) => moment(item.record_date).format("DD-MM-YYYY") || "Date"
  //         );
  //         const normData = new Array(
  //           res.data.physical_assessment_record_date.length
  //         ).fill(normValueInMinutes);

  //         const pdata = {
  //           labels,
  //           datasets: [
  //             {
  //               label: "Norms",
  //               data: normData,
  //               borderColor: "grey",
  //               backgroundColor: "rgba(128, 128, 128, 0.2)",
  //               fill: false,
  //               borderWidth: 2,
  //               tension: 0.1,
  //             },
  //             {
  //               label: "Timing",
  //               data: timingData,
  //               borderColor: "blue",
  //               backgroundColor: "rgba(0, 0, 255, 0.2)",
  //               fill: false,
  //               borderWidth: 2,
  //               tension: 0.1,
  //             },
  //             {
  //               label: "Target",
  //               data: targetData,
  //               showLine: false,
  //               pointRadius: 5,
  //               pointHoverRadius: 7,
  //               pointBackgroundColor: "red",
  //               pointBorderColor: "darkred",
  //               borderColor: "red",
  //               backgroundColor: "#ef94a3",
  //               fill: false,
  //               // borderWidth: 2,
  //               // tension: 0.1,
  //               // borderDash: [5, 5],
  //             },
  //             // {
  //             //   label: "Target",
  //             //   data: targetData,
  //             //   showLine: false,              // hide the line
  //             //   pointStyle: targetImg,        // use image as point
  //             //   pointRadius: 10,              // size of the image
  //             //   pointHoverRadius: 12,
  //             //   backgroundColor: 'transparent', // no background color
  //             //   borderColor: 'transparent',     // no border
  //             // },
  //           ],
  //         };

  //         setPTData(pdata);

  //         const chartOptions = {
  //           responsive: true,
  //           plugins: {
  //             tooltip: {
  //               callbacks: {
  //                 label: function (context) {
  //                   const datasetLabel = context.dataset.label || "";
  //                   const index = context.dataIndex;

  //                   if (datasetLabel === "Timing") {
  //                     return `Timing: ${originalTimingData[index]}`;
  //                   } else if (datasetLabel === "Target") {
  //                     return `Target: ${originalTargetData[index]}`;
  //                   } else if (datasetLabel === "Norms") {
  //                     return `Norm: ${res.data.norm_value}`;
  //                   }

  //                   return `${datasetLabel}: ${context.parsed.y}`;
  //                 },
  //               },
  //             },
  //           },
  //           scales: {
  //             y: {
  //               title: {
  //                 display: true,
  //                 text:
  //                   sname.toUpperCase() === "ATHLETICS" &&
  //                   eventTypeName === "Track"
  //                     ? "Time (minutes)"
  //                     : "Distance (meters)",
  //               },
  //             },
  //             x: {
  //               title: {
  //                 display: false,
  //                 text: "Date",
  //               },
  //             },
  //           },
  //         };

  //         if (window.innerWidth < 768) {
  //           chartOptions.maintainAspectRatio = false;
  //         } else {
  //           chartOptions.maintainAspectRatio = true;
  //         }

  //         setCOpts(chartOptions);
  //       }
  //     }
  //   });
  // }

  function loadperson(sp, ev, tpe) {
    setSType(tpe);
    setPTData("");
    const etype = elist.find(
      (item) => item.event_uid === (ev != 0 ? ev.value : 0)
    );
    const eventTypeName = etype ? etype.event_type_name : null;
    const temp = new FormData();
    temp.append("sports_id", sp);
    temp.append("event_id", ev != 0 ? ev.value : 0);
    temp.append("user_id", id);
    temp.append("competition_training", tpe);

    viewpersonaltimingapi(temp).then((res) => {
      if (res.status === true) {
        if (res.data && res.data.physical_assessment_record_date.length > 0) {
          let normValueInMinutes = 0;
          let timingData = [];
          let targetData = [];

          const originalTimingData =
            res.data.physical_assessment_record_date.map(
              (item) => item.timing_timestamp
            );
          const originalTargetData =
            res.data.physical_assessment_record_date.map((item) => item.target);

          const isTrack =
            sname.toUpperCase() === "ATHLETICS" && eventTypeName === "Track";

          // === Norms ===
          normValueInMinutes = isTrack
            ? res.data.norm_value !== 0
              ? convertToMinutes(res.data.norm_value)
              : 0
            : res.data.norm_value;

          // === Timing & Target with Jitter ===
          res.data.physical_assessment_record_date.forEach((item, idx) => {
            let timingVal, targetVal;

            if (isTrack) {
              timingVal = convertToMinutes(item.timing_timestamp);
              targetVal = convertToMinutes(item.target);
            } else {
              timingVal =
                parseFloat(item.timing_timestamp.replace(/[^\d.]/g, "")) || 0;
              targetVal = parseFloat(item.target) || 0;
            }

            // ✅ Apply small jitter if Timing and Target are identical
            if (timingVal === targetVal) {
              targetVal += 0.05; // Slight offset to avoid overlap
            }

            timingData.push(timingVal);
            targetData.push(targetVal);
          });

          const labels = res.data.physical_assessment_record_date.map(
            (item) => moment(item.record_date).format("DD-MM-YYYY") || "Date"
          );

          const normData = new Array(
            res.data.physical_assessment_record_date.length
          ).fill(normValueInMinutes);

          const pdata = {
            labels,
            datasets: [
              {
                label: "Norms",
                data: normData,
                borderColor: "grey",
                backgroundColor: "rgba(128, 128, 128, 0.2)",
                fill: false,
                borderWidth: 2,
                tension: 0.1,
                borderDash: [5, 5], // Dashed line for Norms
                pointRadius: 0,
              },
              {
                label: "Timing",
                data: timingData,
                borderColor: "blue",
                backgroundColor: "rgba(0, 0, 255, 0.2)",
                fill: false,
                borderWidth: 2,
                tension: 0.1,
                pointRadius: 4,
                pointHoverRadius: 6,
                pointBackgroundColor: "blue",
                pointBorderColor: "darkblue",
              },
              {
                label: "Target",
                data: targetData,
                showLine: false,
                pointRadius: 5,
                pointHoverRadius: 7,
                pointBackgroundColor: "red",
                pointBorderColor: "darkred",
                borderColor: "red",
                backgroundColor: "#ef94a3",
                fill: false,
              },
            ],
          };

          setPTData(pdata);

          // const chartOptions = {
          //   responsive: true,
          //   maintainAspectRatio: window.innerWidth >= 768,
          //   plugins: {
          //     tooltip: {
          //       callbacks: {
          //         label: function (context) {
          //           const datasetLabel = context.dataset.label || "";
          //           const index = context.dataIndex;

          //           if (datasetLabel === "Timing") {
          //             return `Timing: ${originalTimingData[index]}`;
          //           } else if (datasetLabel === "Target") {
          //             return `Target: ${originalTargetData[index]}`;
          //           } else if (datasetLabel === "Norms") {
          //             return `Norm: ${res.data.norm_value}`;
          //           }

          //           return `${datasetLabel}: ${context.parsed.y}`;
          //         },
          //       },
          //     },
          //     legend: {
          //       display: true,
          //       position: "top",
          //       labels: {
          //         usePointStyle: true,
          //       },
          //     },
          //   },
          //   scales: {
          //     y: {
          //       title: {
          //         display: true,
          //         text: isTrack ? "Time (minutes)" : "Distance (meters)",
          //       },
          //     },
          //     x: {
          //       title: {
          //         display: false,
          //         text: "Date",
          //       },
          //     },
          //   },
          // };
          const chartOptions = {
            responsive: true,
            maintainAspectRatio: window.innerWidth >= 768,
            plugins: {
              tooltip: {
                callbacks: {
                  label: function (context) {
                    const datasetLabel = context.dataset.label || "";
                    const index = context.dataIndex;

                    if (datasetLabel === "Timing") {
                      return `Timing: ${originalTimingData[index]}`;
                    } else if (datasetLabel === "Target") {
                      return `Target: ${originalTargetData[index]}`;
                    } else if (datasetLabel === "Norms") {
                      return `Norm: ${res.data.norm_value}`;
                    }

                    return `${datasetLabel}: ${context.parsed.y}`;
                  },
                },
              },
              legend: {
                display: true,
                position: "top",
                labels: {
                  usePointStyle: true,
                },
              },
              datalabels: {
                display: (context) => {
                  const datasetLabel = context.dataset.label;
                  return datasetLabel === "Timing" || datasetLabel === "Target";
                },
                color: (context) => {
                  return context.dataset.label === "Timing" ? 'blue' : 'red';
                },
                align: (context) => {
                  // Timing labels above, Target labels below to avoid overlap
                  return context.dataset.label === "Timing" ? 'top' : 'bottom';
                },
                anchor: (context) => {
                  return context.dataset.label === "Timing" ? 'end' : 'start';
                },
                offset: 6,
                font: {
                  weight: 'bold',
                  size: 9,
                },
                formatter: function (value, context) {
                  const datasetLabel = context.dataset.label;
                  const index = context.dataIndex;

                  if (datasetLabel === "Timing") {
                    return originalTimingData[index];
                  } else if (datasetLabel === "Target") {
                    return originalTargetData[index];
                  }

                  return null; // Don't display for "Norms"
                },
              },
            },
            scales: {
              y: {
                title: {
                  display: true,
                  text: isTrack ? "Time (minutes)" : "Distance (meters)",
                },
              },
              x: {
                title: {
                  display: false,
                },
              },
            },
          };




          setCOpts(chartOptions);
        }
      }
    });
  }

  return (
    <div className="side-app">
      <div className="page-header">
        <div className="breadcrumb">
          <h4 className="mb-0">Player Details</h4>
        </div>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Player</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Player Details
          </li>
        </ol>
      </div>
      {loading && (
        <div className="dashloader-wrapper">
          <div className="loader"></div>
          <h3>Loading...Please do not go back or close the window.</h3>
        </div>
      )}
      {!loading && (
        <div className="row">
          <div className="col-12">
            <form className="card mt-0">
              <div className="card-body">
                <div className="text-right">
                  {localStorage.getItem("Role") !== "8" && (
                    <>
                      <a
                        className="btn btn-success me-2 mt-1"
                        onClick={perflist}
                      >
                        Overall Performance
                      </a>
                      <a
                        className="btn btn-secondary me-2 mt-1"
                        onClick={perftourlist}
                      >
                        Tournament Wise Performance
                      </a>
                    </>
                  )}

                  <a className="btn btn-gray me-2 mt-1" onClick={backlist}>
                    Back
                  </a>
                </div>
                {urlhead !== "paymentdetail" &&
                  localStorage.getItem("Role") !== "8" && (
                    <>
                      <div className="row">
                        {sishow === "" && (
                          <h4>
                            Similar Profiles (Based on DOB,Gender and School)
                          </h4>
                        )}
                        {sishow !== "" && (
                          <h4 className="text-center text-danger">{sishow}</h4>
                        )}
                      </div>
                      {sishow === "" && (
                        <div className="table-responsive mt-2">
                          <Table bordered>
                            <thead>
                              <tr>
                                <th>Merge</th>
                                <th>Username</th>
                                <th>Fullname</th>
                                <th>Gender</th>
                                <th>D.O.B</th>
                                <th>Contact Number</th>
                                <th>Email</th>
                                <th>School</th>
                                <th>Reg Date</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {simlist.map((data, i) => {
                                return (
                                  <tr key={i}>
                                    {data.user_id !== id && (
                                      <>
                                        <td className="text-center">
                                          {data.mergedornot !== "" && (
                                            <>
                                              {data.merged_main_userid !==
                                                parseInt(id) && (
                                                  <>
                                                    {data.merged_main_userid ===
                                                      data.user_id && (
                                                        <span className="text-success">
                                                          Main Profile
                                                        </span>
                                                      )}
                                                    {data.merged_main_userid !==
                                                      data.user_id && (
                                                        <span className="text-danger">
                                                          Already merged to{" "}
                                                          {
                                                            data.merged_main_username
                                                          }
                                                        </span>
                                                      )}
                                                  </>
                                                )}
                                              {data.merged_main_userid ===
                                                parseInt(id) && (
                                                  <>
                                                    <span className="text-success me-2">
                                                      {data.mergedornot}
                                                    </span>
                                                    <a
                                                      className="btn btn-danger"
                                                      onClick={() =>
                                                        unmergerplayer(
                                                          data.user_id,
                                                          data.username,
                                                          data.first_name
                                                        )
                                                      }
                                                    >
                                                      <i className="fa fa-trash fa-lg"></i>
                                                    </a>
                                                  </>
                                                )}
                                            </>
                                          )}
                                          {data.mergedornot === "" && (
                                            <input
                                              type="radio"
                                              checked={data.check}
                                              onChange={(e) => mergecheck(e, i)}
                                            />
                                          )}
                                        </td>

                                        <td>{data.username}</td>
                                        <td>{data.first_name}</td>
                                        <td>{data.gender}</td>
                                        <td>
                                          {moment(data.date_of_birth).format(
                                            "DD-MM-yyyy"
                                          )}
                                        </td>
                                        <td>{data.mobile_no}</td>
                                        <td>{data.email_id}</td>
                                        <td>{data.school_name}</td>
                                        <td>
                                          {data.registerdate !== null && (
                                            <>
                                              {moment(data.registerdate).format(
                                                "DD-MM-yyyy"
                                              )}
                                            </>
                                          )}
                                        </td>
                                        <td className="text-center">
                                          <a
                                            className="btn-sm btn-info"
                                            onClick={() =>
                                              viewlist(
                                                data.user_id,
                                                data.first_name,
                                                data.username
                                              )
                                            }
                                            target="_blank"
                                          >
                                            <i className="fa fa-eye fa-lg"></i>
                                          </a>
                                        </td>
                                      </>
                                    )}
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                          {localStorage.getItem("Role") === "1" && (
                            <div className="text-right">
                              <a
                                className="btn btn-success"
                                onClick={mergedata}
                              >
                                Merge
                              </a>
                            </div>
                          )}
                        </div>
                      )}

                      <hr />
                    </>
                  )}

                <Modal show={mshow} size="xl">
                  <Modal.Header>
                    <h5>Merge Player Details</h5>
                    <i
                      className="fa fa-window-close fa-lg"
                      onClick={mergeClose}
                      aria-hidden="true"
                    ></i>
                  </Modal.Header>
                  <Modal.Body className="mod-body">
                    <div className="table-responsive mt-2">
                      <h5 className="text-success">
                        Select Username (UID) of main profile
                      </h5>
                      {/* <div  id="mergelist" className="row">
                        <div className="col-md-3">
                        <div className="card">
                             
                             <div className="">
                               <h2>
                                 <b>Player UID</b>
                               </h2>
                               <h2>
                                 <b>Class</b>
                               </h2>
                               <h2>
                                 <b>Section</b>
                               </h2>
                               <h2>
                                 <b>Gender</b>
                               </h2>
                               <h2>
                                 <b>DOB</b>
                               </h2>
                             </div>
                           </div>
                        </div>
                      </div> */}
                      <Table bordered>
                        <tbody>
                          <tr>
                            <th>
                              <b>Username (UID)</b>
                            </th>
                            {simlist.map((data, i) => {
                              return (
                                <>
                                  {data.check === true && (
                                    <td key={i}>
                                      {data.radiouser !== true && (
                                        <>
                                          <div
                                            style={{
                                              float: "left",
                                              width: "50%",
                                            }}
                                          >
                                            {data.username}
                                          </div>
                                          <div
                                            className="text-right"
                                            style={{
                                              float: "right",
                                              width: "50%",
                                            }}
                                          >
                                            <a
                                              className="btn btn-secondary"
                                              onClick={() =>
                                                mradiouser(i, data.username)
                                              }
                                            >
                                              Select if Main UID
                                            </a>
                                          </div>
                                        </>
                                      )}
                                      {data.radiouser === true && (
                                        <>
                                          <span className="font-weight-bold text-success">
                                            {data.username}
                                            <i className="fa fa-check ml-2"></i>
                                          </span>
                                        </>
                                      )}
                                    </td>
                                  )}
                                </>
                              );
                            })}
                          </tr>
                          <tr>
                            <th>
                              <b>Fullname</b>
                            </th>
                            {simlist.map((data, i) => {
                              return (
                                <>
                                  {data.check === true && (
                                    <td key={i}>
                                      {data.radiouser === true && (
                                        <span className="font-weight-bold text-success">
                                          {data.first_name}
                                        </span>
                                      )}
                                      {data.radiouser !== true && (
                                        <>
                                          <input
                                            type="radio"
                                            className="me-2"
                                            checked={data.radioname}
                                            onClick={() =>
                                              mradioname(i, data.radioname)
                                            }
                                          />
                                          {data.first_name}
                                        </>
                                      )}
                                    </td>
                                  )}
                                </>
                              );
                            })}
                          </tr>
                          <tr>
                            <th>
                              <b>Gender </b>
                            </th>
                            {simlist.map((data, i) => {
                              return (
                                <>
                                  {data.check === true && (
                                    <td key={i}>
                                      {data.radiouser === true && (
                                        <span className="font-weight-bold text-success">
                                          {data.gender}
                                        </span>
                                      )}
                                      {data.radiouser !== true && (
                                        <>
                                          <input
                                            type="radio"
                                            className="me-2"
                                            checked={data.radiogender}
                                            onClick={() =>
                                              mradiogender(i, data.radiogender)
                                            }
                                          />
                                          {data.gender}
                                        </>
                                      )}
                                    </td>
                                  )}
                                </>
                              );
                            })}
                          </tr>
                          <tr>
                            <th>
                              <b>DOB</b>
                            </th>
                            {simlist.map((data, i) => {
                              return (
                                <>
                                  {data.check === true && (
                                    <td key={i}>
                                      {data.radiouser === true && (
                                        <span className="font-weight-bold text-success">
                                          {moment(data.date_of_birth).format(
                                            "DD-MM-yyyy"
                                          )}
                                        </span>
                                      )}
                                      {data.radiouser !== true && (
                                        <>
                                          <input
                                            type="radio"
                                            className="me-2"
                                            checked={data.radiodob}
                                            onClick={() =>
                                              mradiodob(i, data.radiodob)
                                            }
                                          />
                                          {moment(data.date_of_birth).format(
                                            "DD-MM-yyyy"
                                          )}
                                        </>
                                      )}
                                    </td>
                                  )}
                                </>
                              );
                            })}
                          </tr>
                          <tr>
                            <th>
                              <b>Contact</b>
                            </th>
                            {simlist.map((data, i) => {
                              return (
                                <>
                                  {data.check === true && (
                                    <td key={i}>
                                      {data.radiouser === true && (
                                        <span className="font-weight-bold text-success">
                                          {data.mobile_no}
                                        </span>
                                      )}
                                      {data.radiouser !== true && (
                                        <>
                                          <input
                                            type="radio"
                                            className="me-2"
                                            checked={data.radiomob}
                                            onClick={() =>
                                              mradiomob(i, data.radiomob)
                                            }
                                          />
                                          {data.mobile_no}
                                        </>
                                      )}
                                    </td>
                                  )}
                                </>
                              );
                            })}
                          </tr>
                          <tr>
                            <th>
                              <b>Email</b>
                            </th>
                            {simlist.map((data, i) => {
                              return (
                                <>
                                  {data.check === true && (
                                    <td key={i}>
                                      {data.radiouser === true && (
                                        <span className="font-weight-bold text-success">
                                          {data.email_id}
                                        </span>
                                      )}
                                      {data.radiouser !== true && (
                                        <>
                                          <input
                                            type="radio"
                                            className="me-2"
                                            checked={data.radioemail}
                                            onClick={() =>
                                              mradioemail(i, data.radioemail)
                                            }
                                          />
                                          {data.email_id}
                                        </>
                                      )}
                                    </td>
                                  )}
                                </>
                              );
                            })}
                          </tr>
                          <tr>
                            <th>
                              <b>Class</b>
                            </th>
                            {simlist.map((data, i) => {
                              return (
                                <>
                                  {data.check === true && (
                                    <td key={i}>
                                      {data.radiouser === true && (
                                        <span className="font-weight-bold text-success">
                                          {data.class_name}
                                        </span>
                                      )}
                                      {data.radiouser !== true && (
                                        <>
                                          <input
                                            type="radio"
                                            className="me-2"
                                            checked={data.radiocls}
                                            onClick={() =>
                                              mradioclass(i, data.radiocls)
                                            }
                                          />
                                          {data.class_name}
                                        </>
                                      )}
                                    </td>
                                  )}
                                </>
                              );
                            })}
                          </tr>

                          <tr>
                            <th>
                              <b>Section</b>
                            </th>
                            {simlist.map((data, i) => {
                              return (
                                <>
                                  {data.check === true && (
                                    <td key={i}>
                                      {data.radiouser === true && (
                                        <span className="font-weight-bold text-success">
                                          {data.section}
                                        </span>
                                      )}
                                      {data.radiouser !== true && (
                                        <>
                                          <input
                                            type="radio"
                                            className="me-2"
                                            checked={data.radiosec}
                                            onClick={() =>
                                              mradiosection(i, data.radiosec)
                                            }
                                          />
                                          {data.section}
                                        </>
                                      )}
                                    </td>
                                  )}
                                </>
                              );
                            })}
                          </tr>
                        </tbody>
                      </Table>
                      {errorMsg !== "" && (
                        <span className="errortext">{errorMsg}</span>
                      )}
                    </div>
                  </Modal.Body>
                  <Modal.Footer>
                    <button className="btn btn-success" onClick={mergeplayer}>
                      Merge Player
                    </button>
                    <button onClick={mergeClose} className="btn btn-gray">
                      Cancel
                    </button>
                  </Modal.Footer>
                </Modal>

                <Modal show={fshow} size="large">
                  <Modal.Header>
                    <h5>Merge Profile Confirmation</h5>
                    <i
                      className="fa fa-window-close fa-lg"
                      onClick={mPClose}
                      aria-hidden="true"
                    ></i>
                  </Modal.Header>
                  <Modal.Body className="mod-body">
                    <div className="alignMe">
                      <h4 className="h4 mb-0 mt-3">
                        <b>Username (UID) </b>{" "}
                        <span className="font-weight-bold text-success">
                          {muname}
                        </span>
                      </h4>
                      <h4 className="h4 mb-0 mt-3">
                        <b>Fullname </b>{" "}
                        <span className="font-weight-bold text-success">
                          {mfname}
                        </span>
                      </h4>
                      <h4 className="h4 mb-0 mt-3">
                        <b>Gender </b>{" "}
                        <span className="font-weight-bold text-success">
                          {mgender}
                        </span>
                      </h4>
                      <h4 className="h4 mb-0 mt-3">
                        <b>DOB </b>{" "}
                        <span className="font-weight-bold text-success">
                          {moment(mdob).format("DD-MM-yyyy")}
                        </span>
                      </h4>
                      <h4 className="h4 mb-0 mt-3">
                        <b>Contact </b>{" "}
                        <span className="font-weight-bold text-success">
                          {mmob}
                        </span>
                      </h4>
                      <h4 className="h4 mb-0 mt-3">
                        <b>Email </b>{" "}
                        <span className="font-weight-bold text-success">
                          {memail}
                        </span>
                      </h4>
                      <h4 className="h4 mb-0 mt-3">
                        <b>Class </b>{" "}
                        <span className="font-weight-bold text-success">
                          {mclsname}
                        </span>
                      </h4>
                      <h4 className="h4 mb-0 mt-3">
                        <b>Section </b>{" "}
                        <span className="font-weight-bold text-success">
                          {msec}
                        </span>
                      </h4>
                    </div>

                    <br />
                  </Modal.Body>
                  <Modal.Footer>
                    <button
                      className="btn btn-secondary"
                      onClick={mergedprofiles}
                    >
                      Ok
                    </button>
                    <button onClick={mPClose} className="btn btn-gray">
                      Cancel
                    </button>
                  </Modal.Footer>
                </Modal>

                <h4>Personal Detail</h4>
                <div className="row tournamentitem">
                  <div className="col-md-6">
                    <div className="details-group">
                      <div className="row">
                        <div className="col-md-4">
                          <b className="text-inverse">Full Name</b>
                        </div>
                        <div className="col-md-8">
                          <span className="text-inverse">{fname}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-md-6">
                  <div className="details-group">
                    <div className="row">
                      <div className="col-md-4">
                        <b className="text-inverse">Last Name</b>
                      </div>
                      <div className="col-md-8">
                        <span className="text-inverse">{lname}</span>
                      </div>
                    </div>
                  </div>
                </div> */}

                  <div className="col-md-6">
                    <div className="details-group">
                      <div className="row">
                        <div className="col-md-4">
                          <b className="text-inverse">Gender</b>
                        </div>
                        <div className="col-md-8">
                          <span className="text-inverse">{gender}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="details-group">
                      <div className="row">
                        <div className="col-md-4">
                          <b className="text-inverse">Date of Birth</b>
                        </div>
                        <div className="col-md-8">
                          <span className="text-inverse">{dob}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="details-group">
                      <div className="row">
                        <div className="col-md-4">
                          <b className="text-inverse">Contact Number</b>
                        </div>
                        <div className="col-md-8">
                          <span className="text-inverse">{mobno}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="details-group">
                      <div className="row">
                        <div className="col-md-4">
                          <b className="text-inverse">Email Address</b>
                        </div>
                        <div className="col-md-8">
                          <span className="text-inverse">{email}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="details-group">
                      <div className="row">
                        <div className="col-md-4">
                          <b className="text-inverse">Father Name</b>
                        </div>
                        <div className="col-md-8">
                          <span className="text-inverse">{father}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="details-group">
                      <div className="row">
                        <div className="col-md-4">
                          <b className="text-inverse">Registered Date</b>
                        </div>
                        <div className="col-md-8">
                          <span className="text-inverse">{regdate}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {urlhead !== "paymentdetail" && (
                    <div className="col-md-6">
                      <div className="details-group">
                        <div className="row">
                          <div className="col-md-4">
                            <b className="text-inverse">Status</b>
                          </div>
                          <div className="col-md-8">
                            {status === 1 && (
                              <span
                                className="text-inverse"
                                style={{ color: "green", fontWeight: "700" }}
                              >
                                Approved
                              </span>
                            )}
                            {status === 4 && (
                              <span
                                className="text-inverse"
                                style={{ color: "red", fontWeight: "700" }}
                              >
                                Merged Player
                              </span>
                            )}
                            {status === 3 && (
                              <span
                                className="text-inverse"
                                style={{ color: "#d5a20a", fontWeight: "700" }}
                              >
                                Blocked
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="col-md-6">
                    <div className="details-group">
                      <div className="row">
                        <div className="col-md-4">
                          <b className="text-inverse">Active or Passive</b>
                        </div>
                        <div className="col-md-8">
                          <span className="text-inverse">
                            {pstatus == 1 ? "Active" : "Passive"}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="details-group">
                      <div className="row">
                        <div className="col-md-4">
                          <b className="text-inverse">Date of Joining</b>
                        </div>
                        <div className="col-md-8">
                          <span className="text-inverse">{doj}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="details-group">
                      <div className="row">
                        <div className="col-md-4">
                          <b className="text-inverse">Username (UID)</b>
                        </div>
                        <div className="col-md-8">
                          <span className="text-inverse">{uname}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {(localStorage.getItem("Role") == 1 ||
                    localStorage.getItem("Role") == 4) && (
                      <div className="col-md-6">
                        <div className="details-group">
                          <div className="row">
                            <div className="col-md-4">
                              <b className="text-inverse">Password</b>
                            </div>
                            <div className="col-md-8">
                              <span className="text-inverse">{pass}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                </div>

                <hr />
                <h4>School Detail</h4>
                <div className="row tournamentitem">
                  <div className="col-md-12">
                    <div className="details-group">
                      <div className="row">
                        <div className="col-lg-2 col-md-6">
                          <b className="text-inverse">School</b>
                        </div>
                        <div className="col-md-10 col-md-6">
                          <span className="text-inverse">{school}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="details-group">
                      <div className="row">
                        <div className="col-md-4">
                          <b className="text-inverse">CHID</b>
                        </div>
                        <div className="col-md-8">
                          <span className="text-inverse">-</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="details-group">
                      <div className="row">
                        <div className="col-md-4">
                          <b className="text-inverse">Class</b>
                        </div>
                        <div className="col-md-8">
                          <span className="text-inverse">{clsname}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="details-group">
                      <div className="row">
                        <div className="col-md-4">
                          <b className="text-inverse">Section</b>
                        </div>
                        <div className="col-md-8">
                          <span className="text-inverse">{secname}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <hr />
                <h4>Other Details</h4>
                <div className="row tournamentitem">
                  <div className="col-md-6">
                    <div className="details-group">
                      <div className="row">
                        <div className="col-md-4">
                          <b className="text-inverse">Age</b>
                        </div>
                        <div className="col-md-8">
                          <span className="text-inverse">{page}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="details-group">
                      <div className="row">
                        <div className="col-md-4">
                          <b className="text-inverse">Emergency Contact</b>
                        </div>
                        <div className="col-md-8">
                          <span className="text-inverse">{pemer}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="details-group">
                      <div className="row">
                        <div className="col-md-4">
                          <b className="text-inverse">Blood Group</b>
                        </div>
                        <div className="col-md-8">
                          <span className="text-inverse">{bgroup}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="details-group">
                      <div className="row">
                        <div className="col-md-4">
                          <b className="text-inverse">Address</b>
                        </div>
                        <div className="col-md-8">
                          <span className="text-inverse">{paddr}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="details-group">
                      <div className="row">
                        <div className="col-md-4">
                          <b className="text-inverse">ESID</b>
                        </div>
                        <div className="col-md-8">
                          <span className="text-inverse">{pesid}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="details-group">
                      <div className="row">
                        <div className="col-md-4">
                          <b className="text-inverse">Current Coach Name</b>
                        </div>
                        <div className="col-md-8">
                          <span className="text-inverse">{pcoach}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="details-group">
                      <div className="row">
                        <div className="col-md-4">
                          <b className="text-inverse">Past Coaches/ Mentors</b>
                        </div>
                        <div className="col-md-8">
                          <span className="text-inverse">{ppastcoach}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="details-group">
                      <div className="row">
                        <div className="col-md-4">
                          <b className="text-inverse">Kit Size</b>
                        </div>
                        <div className="col-md-8">
                          <span className="text-inverse">{ksize}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="details-group">
                      <div className="row">
                        <div className="col-md-4">
                          <b className="text-inverse">Shoe Size</b>
                        </div>
                        <div className="col-md-8">
                          <span className="text-inverse">{ssize}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="details-group">
                      <div className="row">
                        <div className="col-md-4">
                          <b className="text-inverse">SDC Center</b>
                        </div>
                        <div className="col-md-8">
                          <span className="text-inverse">{sdccenter}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <hr />
                {afile !== "" &&
                  <div className="row">
                    <div className="col-md-3">
                      <h4>Aadhar</h4>
                      <div className="form-group">
                        <img
                          className="profile_img mb-2"
                          src={afile}
                          height="160"
                          alt="Aadhar"
                          onError={(e) => errorhandle(e)}
                        />
                      </div>
                    </div>
                  </div>
                }

                <div className="row">
                  <div className="col-md-3">
                    <h4>Photograph</h4>
                    <div className="form-group">
                      <img
                        className="profile_img mb-2"
                        src={photo}
                        height="160"
                        alt="photo"
                        onError={(e) => errorhandle(e)}
                      />
                    </div>
                  </div>
                  {hlist.length > 0 && (
                    <div className="col-md-9">
                      <h4>Highest Level Represented</h4>
                      <div className="table-responsive">
                        <table className="sp-league-table sp-data-table">
                          <thead className="sp-table-header">
                            <tr role="row">
                              <th className="text-center">Sports</th>
                              <th className="text-center">Events</th>
                              <th className="text-center">Level</th>
                            </tr>
                          </thead>
                          <tbody>
                            {hlist.map((item, j) => {
                              const getRowColor = () => {
                                return j % 2 === 0 ? "even" : "odd";
                              };
                              return (
                                <tr
                                  className={`sp-row-no-0 ${getRowColor()}`}
                                  role="row"
                                  key={j}
                                >
                                  <td className="data-pct">
                                    {item.sports_type}
                                  </td>
                                  <td className="data-pct">{item.event}</td>
                                  <td className="data-pct">
                                    {item.meet_level}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </div>

                {filterProduct.length == 0 &&
                  localStorage.getItem("Role") !== "1" ? (
                  <></>
                ) : (
                  <>
                    <hr />
                    <h4>Achievement List</h4>
                    <div
                      className="ag-theme-alpine ag-style"
                      style={{
                        height: filterProduct.length < 10 ? "auto" : "600px",
                      }}
                    >
                      <AgGridReact
                        columnDefs={columnPDefs}
                        rowData={filterProduct}
                        pagination="true"
                        paginationPageSize="10"
                        sortingOrder={sorting}
                        suppressExcelExport={true}
                        suppressDragLeaveHidesColumns={true}
                        domLayout={
                          filterProduct.length < 10 ? "autoHeight" : "normal"
                        }
                      />
                    </div>
                  </>
                )}
                <hr />
                <h4>Medals vs Participation</h4>
                <div className="col-md-4">
                  <label className="form-label">
                    Levels <span className="errortext"></span>
                  </label>
                  <select
                    className="form-control"
                    value={selectedFilter}
                    onChange={(e) => setSelectedFilter(e.target.value)}
                  >
                    <option value="">Select Level</option>
                    <option value="International">International</option>
                    <option value="National">National</option>
                    <option value="State">State</option>
                    <option value="Zonal">Zonal</option>
                    <option value="District">District</option>
                    <option value="Inter_School">Inter School</option>
                    <option value="Intra_school">Intra School</option>
                  </select>
                </div>
                <div id="chart-container" className="col-md-12">
                  {gdata && <Bar data={gdata} options={opts} />}
                </div>
                <hr />

                {ptdet.length == 0 && localStorage.getItem("Role") !== "1" ? (
                  <></>
                ) : (
                  <>
                    <h4>Personal Timings</h4>
                    <div
                      className="ag-theme-alpine ag-style"
                      style={{ height: ptdet.length < 10 ? "auto" : "600px" }}
                    >
                      <AgGridReact
                        columnDefs={columnPtDefs}
                        rowData={ptdet}
                        pagination="true"
                        paginationPageSize="10"
                        sortingOrder={sorting}
                        suppressExcelExport={true}
                        suppressDragLeaveHidesColumns={true}
                        domLayout={ptdet.length < 10 ? "autoHeight" : "normal"}
                      />
                    </div>

                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label className="form-label">
                            Sports <span className="errortext"> *</span>
                          </label>
                          <select
                            className="form-control custom-select"
                            value={ptsport}
                            onChange={(e) => personalsport(e, stype)}
                          >
                            <option value="" defaultValue disabled>
                              --Select Sports--
                            </option>
                            {slist.map((item, index) => {
                              return (
                                <option key={index} value={item.sports_cat_uid}>
                                  {item.sports_category}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>
                      {sname.toUpperCase() === "ATHLETICS" && (
                        <div className="col-md-4">
                          <div className="form-group">
                            <label className="form-label">
                              Event <span className="errortext"> *</span>
                            </label>
                            <Select
                              className="dropdown"
                              placeholder="Select Event"
                              value={pevent}
                              options={pelist}
                              onChange={handleEvent}
                              isSearchable={true}
                              isClearable
                              hidden
                            />
                          </div>
                        </div>
                      )}

                      <div className="col-md-4">
                        <div className="form-group">
                          <label className="form-label">
                            Type of Event <span className="errortext"> *</span>
                          </label>
                          <select
                            className="form-control custom-select"
                            value={stype}
                            onChange={(e) =>
                              loadperson(ptsport, pevent, e.target.value)
                            }
                          >
                            <option value="" defaultValue disabled>
                              --Select Type of Event--
                            </option>
                            <option value="ALL">ALL</option>
                            <option value="COMPETITION">COMPETITION</option>
                            <option value="TRAINING">TRAINING</option>
                          </select>
                        </div>
                      </div>
                      {ptdata === "" && (
                        <div className="col-md-12">
                          <h4 className="text-danger" role="alert">
                            No data availabe for the above selection
                          </h4>
                        </div>
                      )}
                      {ptdata && (
                        <div id="chart-container" className="col-md-12">
                          <Line data={ptdata} options={copts} />
                          {/* options={copts} */}
                        </div>
                      )}
                    </div>
                  </>
                )}

                <hr />
                <div className="container">
                  <div className="ag_courses_head">
                    <div className="row">
                      <h4>Fitness Assessment</h4>
                    </div>
                  </div>
                  {fitList.length === 0 && skillList.length === 0 && (
                    <div className="row">
                      <div className="col-md-12">
                        <div className="card testimonial-card mt-2 mb-3 shadow">
                          <div className="card-body text-center">
                            <h3 className="errortext">
                              Assessment will be updated soon
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {fitList.length === 0 && skillList.length !== 0 && (
                    <div className="row">
                      <div className="col-md-12">
                        <div className="card testimonial-card mt-2 mb-3 shadow">
                          <div className="card-body text-center">
                            <h3 className="errortext">
                              Fitness Assessment will be updated soon
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {fitList.length !== 0 && (
                    <div className="row">
                      <div className="col-md-12">
                        <div className="card testimonial-card mt-2 mb-3 shadow">
                          <div className="card-body text-center">
                            <h3 className="text-success">
                              Assessment Date - {assdate}
                            </h3>

                            <h4>5 Point Grading System</h4>
                            <span className="errortext">
                              A - 5 Points (Excellent), B - 4 Points (Very Good), C - 3
                              Points (Good) , D - 2 Points (Average) , E - 1 Point
                              (Needs Improvement)
                            </span>
                            {fitList.map((item, j) => {
                              return (
                                <>
                                  <table
                                    className="table table-bordered table-hover mt-3"
                                    key={j}
                                  >
                                    <thead>
                                      <tr>
                                        <th>Parameters Mesured</th>
                                        <th>Grade</th>
                                        <th>Score</th>
                                        <th>Description</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {item.attributes.map((data, i) => {
                                        return (
                                          <tr key={i}>
                                            <td>{data.fst_theme_name}</td>
                                            <td>{data.grade}</td>
                                            <td>{data.score}</td>
                                            <td>{data.name}</td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                    <thead>
                                      <tr>
                                        <th>FQ</th>
                                        <th></th>
                                        <th></th>
                                        <th>{item.fq}</th>
                                      </tr>
                                      <tr>
                                        <th>SQ</th>
                                        <th></th>
                                        <th></th>
                                        <th>{item.sq}</th>
                                      </tr>
                                      <tr>
                                        <th>TQ</th>
                                        <th></th>
                                        <th></th>
                                        <th>{item.tq}</th>
                                      </tr>
                                    </thead>
                                  </table>
                                  <hr />
                                </>
                              );
                            })}
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="ag_courses_head ">
                          <h4>Remedial Actions</h4>
                        </div>

                        {fitList.map((item, j) => {
                          return (
                            <>
                              <div className="row" key={j}>
                                {item.attributes.map((data, i) => {
                                  return (
                                    <div className="col-md-4" key={i}>
                                      <div className="our_solution_category">
                                        <div className="solution_cards_box">
                                          <div className="solution_card">
                                            <div className="hover_color_bubble"></div>
                                            <div className="so_top_icon">
                                              {data.fst_theme_name.includes(
                                                "Anaerobic"
                                              ) && (
                                                  <img
                                                    src={require("../../../../assets/images/Anaerobic.png")}
                                                    alt="fitness"
                                                  />
                                                )}
                                              {data.fst_theme_name.includes(
                                                "Aerobic"
                                              ) && (
                                                  <img
                                                    src={require("../../../../assets/images/Aerobic.png")}
                                                    alt="fitness"
                                                  />
                                                )}
                                              {data.fst_theme_name.includes(
                                                "Flexibility"
                                              ) && (
                                                  <img
                                                    src={require("../../../../assets/images/Fitness.png")}
                                                    alt="fitness"
                                                  />
                                                )}
                                              {data.fst_theme_name.includes(
                                                "Abdominal"
                                              ) && (
                                                  <img
                                                    src={require("../../../../assets/images/Abdominal.png")}
                                                    alt="fitness"
                                                  />
                                                )}
                                              {(data.fst_theme_name.includes("Lower") ||
                                                data.fst_theme_name.includes("LB")) && (
                                                  <img
                                                    src={require("../../../../assets/images/Lower.png")}
                                                    alt="fitness"
                                                  />
                                                )}
                                              {(data.fst_theme_name.includes("Upper") ||
                                                data.fst_theme_name.includes("UB")) && (
                                                  <img
                                                    src={require("../../../../assets/images/Upper.png")}
                                                    alt="fitness"
                                                  />
                                                )}
                                            </div>
                                            <div className="solu_title">
                                              <h3>{data.fst_theme_name}</h3>
                                            </div>
                                            <div className="solu_description">
                                              <div
                                                dangerouslySetInnerHTML={{
                                                  __html: data.student_fdbk,
                                                }}
                                                title={data.student_fdbk}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                              <hr />
                            </>
                          );
                        })}
                      </div>
                    </div>
                  )}

                  {skillList.length === 0 && fitList.length !== 0 && (
                    <div className="row">
                      <div className="ag_courses_head">
                        <h4>Skill Assessment</h4>
                      </div>
                      <div className="col-md-12">
                        <div className="card testimonial-card mt-2 mb-3 shadow">
                          <div className="card-body text-center">
                            <h3 className="errortext">
                              Skill Assessment will be updated soon
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {skillList.length !== 0 && (
                    <div className="row">
                      <div className="ag_courses_head">
                        <h4>Skill Assessment</h4>
                      </div>
                      <div className="col-md-12">
                        <div className="card testimonial-card mt-2 mb-3 shadow">
                          <div className="card-body text-center">
                            {assdate === "" && (
                              <h3 className="text-success">
                                Assessment Date - {skildate}
                              </h3>
                            )}
                            <h4>5 Point Grading System</h4>
                            <span className="errortext">
                              A - 5 Points (Very Good), B - 4 Points (Good), C - 3
                              Points (Average) , D - 2 Points (Developing) , E - 1 Point
                              (Needs Improvement)
                            </span>
                            {skillList.map((item, j) => {
                              return (
                                <>
                                  <table
                                    className="table table-bordered table-hover mt-3"
                                    key={j}
                                  >
                                    <thead>
                                      <tr>
                                        <th>Skills Mesured</th>
                                        <th>Grade</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {item.attributes.map((data, i) => {
                                        return (
                                          <tr key={i}>
                                            <td>{data.name}</td>
                                            <td>{data.grade}</td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                    <thead>
                                      <tr>
                                        <th>Overall Grade</th>
                                        <th>{item.overall_grade}</th>
                                      </tr>
                                    </thead>
                                  </table>
                                  <hr />
                                </>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <hr />
                <h4>Sports Assessment</h4>

                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label className="form-label">
                        Sports <span className="errortext"> *</span>
                      </label>
                      <select
                        className="form-control custom-select"
                        value={usport}
                        onChange={(e) => loadsport(e)}
                      >
                        <option value="" defaultValue disabled>
                          --Select Sports--
                        </option>
                        {slist.map((item, index) => {
                          return (
                            <option key={index} value={item.sports_cat_uid}>
                              {item.sports_category}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label className="form-label">
                        Parameter Type <span className="errortext"> *</span>
                      </label>
                      <select
                        className="form-control custom-select"
                        value={asstype}
                        onChange={(e) => {
                          if (localStorage.getItem("Role") === "4" || localStorage.getItem("Role") === "7" || localStorage.getItem("Role") === "8") {
                            handleParameterTypeChange(e);
                          } else {
                            loadgraph(usport, e);
                          }
                        }}
                      >
                        <option value="" defaultValue disabled>
                          --Select Parameter Type--
                        </option>
                        {(localStorage.getItem("Role") === "4" || localStorage.getItem("Role") === "7" || localStorage.getItem("Role") === "8") && (
                          <option value="all">All</option>
                        )}
                        {tlist.map((item, index) => {
                          return (
                            <option key={index} value={item.id}>
                              {item.parameter_type}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </div>

                {/* For Roles 4, 7, and 8: Display based on selection (All or specific) */}
                {(localStorage.getItem("Role") === "4" || localStorage.getItem("Role") === "7" || localStorage.getItem("Role") === "8") && asstype === "all" ? (
                  allParameterData.length > 0 ? (
                    <>
                      {allParameterData.map((paramData, index) => {
                        const processedData = processParameterData(paramData);
                        if (!processedData) return null;

                        return (
                          <div key={index} style={{ marginBottom: '40px' }}>
                            <hr />
                            <h5 className="text-primary">
                              Parameter Type: {paramData.parameterType.parameter_type}
                            </h5>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "flex-start",
                              }}
                            >
                              <div id={`chart-container-${index}`} style={{ flex: 1 }}>
                                {processedData.radarData && processedData.radarData.labels && processedData.radarData.datasets && processedData.radarOptions && typeof processedData.radarOptions === 'object' ? (
                                  <Radar data={processedData.radarData} options={processedData.radarOptions} />
                                ) : (
                                  <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
                                    No data available for this parameter type
                                  </div>
                                )}
                              </div>

                              <div style={{ width: "300px", marginLeft: "20px" }}>
                                <h4>Parameter Descriptions</h4>
                                <ul style={{ listStyle: "none", padding: 0 }}>
                                  {processedData.parameterInfo
                                    .filter(
                                      (param) => param.desc && param.desc.trim() !== ""
                                    )
                                    .map((param, idx) => (
                                      <li key={idx} style={{ marginBottom: "10px" }}>
                                        <strong>{param.name}</strong> -{" "}
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: param.desc,
                                          }}
                                        />
                                      </li>
                                    ))}
                                </ul>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </>
                  ) : (
                    <h4 className="text-danger">No Graph Data Available</h4>
                  )
                ) : (localStorage.getItem("Role") === "4" || localStorage.getItem("Role") === "7" || localStorage.getItem("Role") === "8") && asstype !== "all" && asstype !== "" ? (
                  <>
                    {glist.length == 0 && (
                      <h4 className="text-danger">No Graph Data Available</h4>
                    )}
                    {glist.length !== 0 && (
                      <>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "flex-start",
                          }}
                        >
                          {/* Radar chart on the left */}
                          <div id="chart-container">
                            {grdata && grdata.labels && grdata.datasets && ropts && typeof ropts === 'object' ? (
                              <Radar data={grdata} options={ropts} />
                            ) : (
                              <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
                                {usport ? 'Loading assessment data...' : 'Please select a sport and parameter type to view the radar chart'}
                              </div>
                            )}
                          </div>

                          {/* Parameter name + description on the right */}
                          <div style={{ width: "300px", marginLeft: "20px" }}>
                            <h4>Parameter Descriptions</h4>
                            <ul style={{ listStyle: "none", padding: 0 }}>
                              {paramList
                                .filter(
                                  (param) => param.desc && param.desc.trim() !== ""
                                )
                                .map((param, index) => (
                                  <li key={index} style={{ marginBottom: "10px" }}>
                                    <strong>{param.name}</strong> -{" "}
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: param.desc,
                                      }}
                                    />
                                  </li>
                                ))}
                            </ul>
                          </div>
                        </div>
                      </>
                    )}
                  </>
                ) : !(localStorage.getItem("Role") === "4" || localStorage.getItem("Role") === "7" || localStorage.getItem("Role") === "8") ? (
                  <>
                    {glist.length == 0 && (
                      <h4 className="text-danger">No Graph Data Available</h4>
                    )}
                    {glist.length !== 0 && (
                  <>
                    {/* <div className="table-responsive">
                      <table className="sp-league-table sp-data-table">
                        <thead className="sp-table-header">
                          <tr role="row">
                            <th className="text-center">Date</th>
                            <th className="text-center">Parameter</th>
                            <th className="text-center">Value</th>
                          </tr>
                        </thead>
                        <tbody>
                          {glist.map((item, j) => {
                            const getRowColor = () => {
                              return j % 2 === 0 ? "even" : "odd";
                            };
                            return (
                              <>
                                <tr
                                  className={`sp-row-no-0 ${getRowColor()}`}
                                  role="row"
                                  key={j}
                                >
                                  <td className="data-pct">
                                    {moment(item.record_date).format("DD-MM-yyyy")}
                                  </td>
                                  <td className="data-pct">
                                  {item.assessments.map((assessment, idx) => (
                                    <span key={idx}>
                                      {assessment.parameter_name}
                                    </span>
                                  ))}
                                  </td>
                                  <td className="data-pct">
                                  {item.assessments.map((assessment, idx) => (
                                    <span key={idx}>
                                      {assessment.parameter_value}
                                    </span>
                                  ))}
                                  </td>
                                </tr>
                              </>
                            );
                          })}
                        </tbody>
                      </table>
                    </div> */}
                    {/* <div id="chart-container">
                      <Radar data={grdata} options={ropts} />
                    </div> */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "flex-start",
                      }}
                    >
                      {/* Radar chart on the left */}
                      <div id="chart-container">
                        {grdata && grdata.labels && grdata.datasets && ropts && typeof ropts === 'object' ? (
                          <Radar data={grdata} options={ropts} />
                        ) : (
                          <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
                            {usport ? 'Loading assessment data...' : 'Please select a sport and parameter type to view the radar chart'}
                          </div>
                        )}
                      </div>


                      {/* Parameter name + description on the right */}
                      <div style={{ width: "300px", marginLeft: "20px" }}>
                        <h4>Parameter Descriptions</h4>
                        <ul style={{ listStyle: "none", padding: 0 }}>
                          {paramList
                            .filter(
                              (param) => param.desc && param.desc.trim() !== ""
                            ) // Only include if desc is non-empty
                            .map((param, index) => (
                              <li key={index} style={{ marginBottom: "10px" }}>
                                <strong>{param.name}</strong> -{" "}
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: param.desc,
                                  }}
                                />
                                {/* <span style={{ color: "#555" }}>
                                  {param.desc}
                                </span> */}
                              </li>
                            ))}
                        </ul>
                      </div>
                    </div>
                  </>
                )}
                  </>
                ) : null}

                {attdet.length == 0 && localStorage.getItem("Role") !== "1" ? (
                  <></>
                ) : (
                  <>
                    <hr />
                    <h4>Attendance Record</h4>
                    <div className="row mb-2">
                      <div className="col-md-4">
                        <label className="form-label">Financial Year</label>

                        <select
                          className="form-control"
                          value={tyear}
                          onChange={(e) => listsimilar(e.target.value)}
                        >
                          {/* <option value={0}>All</option> */}
                          <option value={currentYear}>Current Year</option>
                          <option value={lastYear}>Last Year</option>
                        </select>
                      </div>
                    </div>
                    {localStorage.getItem("Role") == "1" &&
                      localStorage.getItem("Subrole") == "1" && (
                        <>
                          <div
                            className="ag-theme-alpine ag-style"
                            style={{
                              height: attdet.length < 10 ? "auto" : "600px",
                            }}
                          >
                            <AgGridReact
                              columnDefs={columnAtDefs}
                              rowData={attdet}
                              pagination="true"
                              paginationPageSize="10"
                              sortingOrder={sorting}
                              suppressExcelExport={true}
                              suppressDragLeaveHidesColumns={true}
                              domLayout={
                                attdet.length < 10 ? "autoHeight" : "normal"
                              }
                            />
                          </div>
                        </>
                      )}

                    {gattdet && (
                      <div id="chart-container">
                        {gattdet && gattdet.labels && gattdet.datasets && (
                          <Bar data={gattdet} options={aopts} />
                        )}
                      </div>
                    )}
                  </>
                )}
                {phdet.length == 0 && localStorage.getItem("Role") !== "1" ? (
                  <></>
                ) : (
                  <>
                    <hr />
                    <h4>Physical and Health Data</h4>
                    <div
                      className="ag-theme-alpine ag-style"
                      style={{ height: phdet.length < 10 ? "auto" : "600px" }}
                    >
                      <AgGridReact
                        columnDefs={columnPhDefs}
                        rowData={phdet}
                        pagination="true"
                        paginationPageSize="10"
                        sortingOrder={sorting}
                        suppressExcelExport={true}
                        suppressDragLeaveHidesColumns={true}
                        domLayout={phdet.length < 10 ? "autoHeight" : "normal"}
                      />
                    </div>
                  </>
                )}
                {phdet.length == 0 && localStorage.getItem("Role") !== "1" ? (
                  <></>
                ) : (
                  <>
                    <hr />
                    <h4>Psychological & Behavioral Profile</h4>

                    <div className="table-responsive">
                      <table className="sp-league-table sp-data-table">
                        <thead className="sp-table-header">
                          <tr role="row">
                            {localStorage.getItem("Role") == "1" && (
                              <th className="text-center">Action</th>
                            )}
                            <th className="text-center">Personality Traits</th>
                            <th className="text-center">Goals - Short Term</th>
                            <th className="text-center">Goals - Long Term</th>
                            <th className="text-center">
                              Role Models / Inspirations
                            </th>
                            {/* <th className="text-center">
                              Sports Psychology Assessments
                            </th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {pbdet.length > 0 ? (
                            pbdet.map((item, j) => {
                              const getRowColor = () => {
                                return j % 2 === 0 ? "even" : "odd";
                              };
                              return (
                                <>
                                  <tr
                                    className={`sp-row-no-0 ${getRowColor()}`}
                                    role="row"
                                    key={j}
                                  >
                                    {localStorage.getItem("Role") == "1" && (
                                      <td className="data-pct">
                                        <a
                                          className="btn btn-sm btn-danger"
                                          onClick={() =>
                                            deletebehave(item.id, item)
                                          }
                                        >
                                          <i className="fa fa-trash"></i>
                                        </a>
                                      </td>
                                    )}
                                    <td className="data-pct">
                                      {item.personality_traits}
                                    </td>
                                    <td className="data-pct">
                                      {item.goals_short_term}
                                    </td>
                                    <td className="data-pct">
                                      {item.goals_long_term}
                                    </td>
                                    <td className="data-pct">
                                      {item.role_model}
                                    </td>
                                    {/* <td className="data-pct">
                                      {item.sports_psycholody_assessments}
                                    </td> */}
                                  </tr>
                                </>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan="6" className="text-center">
                                No data available
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}
                {aclist.length > 0 && (
                  <>
                    <hr />

                    <div className="row">
                      <div className="col-md-10">
                        <h4>Athlete Contract</h4>
                      </div>
                      <div className="col-md-2">
                        <a
                          className="btn btn-success mb-2"
                          onClick={(e) => handleupload("Athlete Contract")}
                        >
                          <i className="fa fa-plus"></i> Add Files
                        </a>
                      </div>
                      {aclist && aclist.length == 0 && (
                        <div className="col-md-12">
                          <h4 className="text-danger">
                            No Athlete Contract Uploaded
                          </h4>
                        </div>
                      )}
                      {currentRecords.map((item, index) => {
                        return (
                          <div className="col-md-2" key={index}>
                            {localStorage.getItem("Role") == "1" && (
                              <a
                                className="photogal-mark"
                                onClick={() =>
                                  deleteres(item.id, item.file_upload_type)
                                }
                              >
                                <i className="fa fa-trash fa-lg"></i>
                              </a>
                            )}
                            <div
                              className="form-group"
                              onClick={() => udetshow(item)}
                            >
                              {item.file_type !== "PDF" && (
                                <img
                                  className="profile_img mb-2"
                                  src={upath + item.filename_or_url}
                                  height="160"
                                  width="160"
                                  alt="Athlete Contract"
                                  onError={(e) => errorhandle(e)}
                                />
                              )}
                              {item.file_type === "PDF" && (
                                <img
                                  className="profile_img mb-2"
                                  src={require("../../../../assets/images/pdf.png")}
                                  height="160"
                                  width="160"
                                  alt="Athlete Contract"
                                />
                              )}
                            </div>
                          </div>
                        );
                      })}

                      {totalRecordsToShow < aclist.length && (
                        <div className="form-group text-center mt-2">
                          <a onClick={loadMore} className="btn btn-secondary">
                            Load More
                          </a>
                        </div>
                      )}
                    </div>
                  </>
                )}
                {clist.length > 0 && (
                  <>
                    <hr />

                    <div className="row">
                      <div className="col-md-10">
                        <h4>Certificates</h4>
                      </div>
                      <div className="col-md-2">
                        <a
                          className="btn btn-success mb-2"
                          onClick={(e) => handleupload("Certificates")}
                        >
                          <i className="fa fa-plus"></i> Add Files
                        </a>
                      </div>
                      {clist.length == 0 && (
                        <div className="col-md-12">
                          <h4 className="text-danger">
                            No Certificates Uploaded
                          </h4>
                        </div>
                      )}
                      {certcurrentRecords.map((item, index) => {
                        return (
                          <div className="col-md-2" key={index}>
                            {localStorage.getItem("Role") == "1" && (
                              <a
                                className="photogal-mark"
                                onClick={() =>
                                  deleteres(item.id, item.file_upload_type)
                                }
                              >
                                <i className="fa fa-trash fa-lg"></i>
                              </a>
                            )}
                            <div
                              className="form-group"
                              onClick={() => udetshow(item)}
                            >
                              {item.file_type !== "PDF" && (
                                <img
                                  className="profile_img mb-2"
                                  src={upath + item.filename_or_url}
                                  height="160"
                                  width="160"
                                  alt="Certificates"
                                  onError={(e) => errorhandle(e)}
                                />
                              )}
                              {item.file_type === "PDF" && (
                                <img
                                  className="profile_img mb-2"
                                  src={require("../../../../assets/images/pdf.png")}
                                  height="160"
                                  width="160"
                                  alt="Certificates"
                                />
                              )}
                            </div>
                          </div>
                        );
                      })}

                      {certRecordsToShow < clist.length && (
                        <div className="form-group text-center mt-2">
                          <a
                            onClick={certloadMore}
                            className="btn btn-secondary"
                          >
                            Load More
                          </a>
                        </div>
                      )}
                    </div>
                  </>
                )}
                {mclist.length > 0 && (
                  <>
                    <hr />

                    <div className="row">
                      <div className="col-md-10">
                        <h4>Media Coverage</h4>
                      </div>
                      <div className="col-md-2">
                        <a
                          className="btn btn-success mb-2"
                          onClick={(e) => handleupload("Media Coverage")}
                        >
                          <i className="fa fa-plus"></i> Add Files
                        </a>
                      </div>
                      {mclist.length == 0 && (
                        <div className="col-md-12">
                          <h4 className="text-danger">
                            No Media Coverage Uploaded
                          </h4>
                        </div>
                      )}
                      {mediacurrentRecords.map((item, index) => {
                        return (
                          <div className="col-md-2" key={index}>
                            {localStorage.getItem("Role") == "1" && (
                              <a
                                className="photogal-mark"
                                onClick={() =>
                                  deleteres(item.id, item.file_upload_type)
                                }
                              >
                                <i className="fa fa-trash fa-lg"></i>
                              </a>
                            )}
                            <div
                              className="form-group"
                              onClick={() => udetshow(item)}
                            >
                              {item.file_type !== "PDF" && (
                                <img
                                  className="profile_img mb-2"
                                  src={upath + item.filename_or_url}
                                  height="160"
                                  width="160"
                                  alt="Media coverage"
                                  onError={(e) => errorhandle(e)}
                                />
                              )}
                              {item.file_type === "PDF" && (
                                <img
                                  className="profile_img mb-2"
                                  src={require("../../../../assets/images/pdf.png")}
                                  height="160"
                                  width="160"
                                  alt="Media coverage"
                                />
                              )}
                            </div>
                          </div>
                        );
                      })}
                      {mediaRecordsToShow < mclist.length && (
                        <div className="form-group text-center mt-2">
                          <a
                            onClick={medialoadMore}
                            className="btn btn-secondary"
                          >
                            Load More
                          </a>
                        </div>
                      )}
                    </div>
                  </>
                )}
                {plist.length > 0 && (
                  <>
                    <hr />
                    <div className="row">
                      <div className="col-md-10">
                        <h4>Photos</h4>
                      </div>
                      <div className="col-md-2">
                        <a
                          className="btn btn-success mb-2"
                          onClick={(e) => handleupload("Photos")}
                        >
                          <i className="fa fa-plus"></i> Add Files
                        </a>
                      </div>
                      {plist.length == 0 && (
                        <div className="col-md-12">
                          <h4 className="text-danger">No Photos Uploaded</h4>
                        </div>
                      )}
                      {photocurrentRecords.map((item, index) => {
                        return (
                          <div className="col-md-2" key={index}>
                            {localStorage.getItem("Role") == "1" && (
                              <a
                                className="photogal-mark"
                                onClick={() =>
                                  deleteres(item.id, item.file_upload_type)
                                }
                              >
                                <i className="fa fa-trash fa-lg"></i>
                              </a>
                            )}
                            <div
                              className="form-group"
                              onClick={() => udetshow(item)}
                            >
                              {item.file_type !== "PDF" && (
                                <img
                                  className="profile_img mb-2"
                                  src={upath + item.filename_or_url}
                                  height="160"
                                  width="160"
                                  alt="Photos"
                                  onError={(e) => errorhandle(e)}
                                />
                              )}
                              {item.file_type === "PDF" && (
                                <img
                                  className="profile_img mb-2"
                                  src={require("../../../../assets/images/pdf.png")}
                                  height="160"
                                  width="160"
                                  alt="Photos"
                                />
                              )}
                            </div>
                          </div>
                        );
                      })}

                      {photoRecordsToShow < plist.length && (
                        <div className="form-group text-center mt-2">
                          <a
                            onClick={photoloadMore}
                            className="btn btn-secondary"
                          >
                            Load More
                          </a>
                        </div>
                      )}
                    </div>
                  </>
                )}
                {vlist.length > 0 && (
                  <>
                    <hr />
                    <div className="row">
                      <div className="col-md-10">
                        <h4>Videos</h4>
                      </div>
                      <div className="col-md-2">
                        <a
                          className="btn btn-success mb-2"
                          onClick={(e) => handleupload("Videos")}
                        >
                          <i className="fa fa-plus"></i> Add Files
                        </a>
                      </div>
                      {vlist.length == 0 && (
                        <div className="col-md-12">
                          <h4 className="text-danger">No Videos Uploaded</h4>
                        </div>
                      )}
                      {videocurrentRecords.map((item, index) => {
                        return (
                          <div className="col-md-2" key={index}>
                            {localStorage.getItem("Role") == "1" && (
                              <a
                                className="photogal-mark"
                                onClick={() =>
                                  deleteres(item.id, item.file_upload_type)
                                }
                              >
                                <i className="fa fa-trash fa-lg"></i>
                              </a>
                            )}
                            <div
                              className="form-group"
                              onClick={() => udetshow(item)}
                            >
                              <img
                                className="profile_img mb-2"
                                src={require("../../../../assets/images/video.png")}
                                height="160"
                                width="160"
                                alt="Videos"
                              />
                            </div>
                          </div>
                        );
                      })}
                      {videoRecordsToShow < vlist.length && (
                        <div className="form-group text-center mt-2">
                          <a
                            onClick={videoloadMore}
                            className="btn btn-secondary"
                          >
                            Load More
                          </a>
                        </div>
                      )}
                    </div>
                  </>
                )}
                {oflist.length > 0 && (
                  <>
                    <hr />
                    <div className="row">
                      <div className="col-md-10">
                        <h4>Other Files</h4>
                      </div>
                      <div className="col-md-2">
                        <a
                          className="btn btn-success mb-2"
                          onClick={(e) => handleupload("Other Files")}
                        >
                          <i className="fa fa-plus"></i> Add Files
                        </a>
                      </div>
                      {oflist.length == 0 && (
                        <div className="col-md-12">
                          <h4 className="text-danger">
                            No Other Files Uploaded
                          </h4>
                        </div>
                      )}
                      {othercurrentRecords.map((item, index) => {
                        return (
                          <div className="col-md-2" key={index}>
                            {localStorage.getItem("Role") == "1" && (
                              <a
                                className="photogal-mark"
                                onClick={() =>
                                  deleteres(item.id, item.file_upload_type)
                                }
                              >
                                <i className="fa fa-trash fa-lg"></i>
                              </a>
                            )}
                            <div
                              className="form-group"
                              onClick={() => udetshow(item)}
                            >
                              {item.file_type !== "PDF" && (
                                <img
                                  className="profile_img mb-2"
                                  src={upath + item.filename_or_url}
                                  height="160"
                                  width="160"
                                  alt="Athlete Contract"
                                  onError={(e) => errorhandle(e)}
                                />
                              )}
                              {item.file_type === "PDF" && (
                                <img
                                  className="profile_img mb-2"
                                  src={require("../../../../assets/images/pdf.png")}
                                  height="160"
                                  width="160"
                                  alt="Athlete Contract"
                                />
                              )}
                            </div>
                          </div>
                        );
                      })}

                      {otherRecordsToShow < oflist.length && (
                        <div className="form-group text-center mt-2">
                          <a
                            onClick={otherloadMore}
                            className="btn btn-secondary"
                          >
                            Load More
                          </a>
                        </div>
                      )}
                    </div>
                  </>
                )}

                {aclist.length == 0 && (
                  <>
                    <hr />

                    <div className="row">
                      <div className="col-md-10">
                        <h4>Athlete Contract</h4>
                      </div>
                      <div className="col-md-2">
                        <a
                          className="btn btn-success mb-2"
                          onClick={(e) => handleupload("Athlete Contract")}
                        >
                          <i className="fa fa-plus"></i> Add Files
                        </a>
                      </div>
                      {aclist && aclist.length == 0 && (
                        <div className="col-md-12">
                          <h4 className="text-danger">
                            No Athlete Contract Uploaded
                          </h4>
                        </div>
                      )}
                    </div>
                  </>
                )}
                {clist.length == 0 && (
                  <>
                    <hr />

                    <div className="row">
                      <div className="col-md-10">
                        <h4>Certificates</h4>
                      </div>
                      <div className="col-md-2">
                        <a
                          className="btn btn-success mb-2"
                          onClick={(e) => handleupload("Certificates")}
                        >
                          <i className="fa fa-plus"></i> Add Files
                        </a>
                      </div>
                      {clist.length == 0 && (
                        <div className="col-md-12">
                          <h4 className="text-danger">
                            No Certificates Uploaded
                          </h4>
                        </div>
                      )}
                    </div>
                  </>
                )}
                {mclist.length == 0 && (
                  <>
                    <hr />

                    <div className="row">
                      <div className="col-md-10">
                        <h4>Media Coverage</h4>
                      </div>
                      <div className="col-md-2">
                        <a
                          className="btn btn-success mb-2"
                          onClick={(e) => handleupload("Media Coverage")}
                        >
                          <i className="fa fa-plus"></i> Add Files
                        </a>
                      </div>
                      {mclist.length == 0 && (
                        <div className="col-md-12">
                          <h4 className="text-danger">
                            No Media Coverage Uploaded
                          </h4>
                        </div>
                      )}
                    </div>
                  </>
                )}
                {plist.length == 0 && (
                  <>
                    <hr />
                    <div className="row">
                      <div className="col-md-10">
                        <h4>Photos</h4>
                      </div>
                      <div className="col-md-2">
                        <a
                          className="btn btn-success mb-2"
                          onClick={(e) => handleupload("Photos")}
                        >
                          <i className="fa fa-plus"></i> Add Files
                        </a>
                      </div>
                      {plist.length == 0 && (
                        <div className="col-md-12">
                          <h4 className="text-danger">No Photos Uploaded</h4>
                        </div>
                      )}
                    </div>
                  </>
                )}
                {vlist.length == 0 && (
                  <>
                    <hr />
                    <div className="row">
                      <div className="col-md-10">
                        <h4>Videos</h4>
                      </div>
                      <div className="col-md-2">
                        <a
                          className="btn btn-success mb-2"
                          onClick={(e) => handleupload("Videos")}
                        >
                          <i className="fa fa-plus"></i> Add Files
                        </a>
                      </div>
                      {vlist.length == 0 && (
                        <div className="col-md-12">
                          <h4 className="text-danger">No Videos Uploaded</h4>
                        </div>
                      )}
                    </div>
                  </>
                )}
                {oflist.length == 0 && (
                  <>
                    <hr />
                    <div className="row">
                      <div className="col-md-10">
                        <h4>Other Files</h4>
                      </div>
                      <div className="col-md-2">
                        <a
                          className="btn btn-success mb-2"
                          onClick={(e) => handleupload("Other Files")}
                        >
                          <i className="fa fa-plus"></i> Add Files
                        </a>
                      </div>
                      {oflist.length == 0 && (
                        <div className="col-md-12">
                          <h4 className="text-danger">
                            No Other Files Uploaded
                          </h4>
                        </div>
                      )}
                    </div>
                  </>
                )}

                <Modal show={fushow} size="small">
                  <Modal.Header>
                    <h5>File Uploads for {imagetype} </h5>
                    <i
                      className="fa fa-window-close fa-lg"
                      onClick={uploadclose}
                      aria-hidden="true"
                    ></i>
                  </Modal.Header>
                  <Modal.Body className="mod-body">
                    {imagetype !== "Videos" && (
                      <>
                        <div className="form-group">
                          <label className="mb-2">
                            {imagetype} <span className="errortext"> *</span>
                          </label>
                          <input
                            type="file"
                            className="form-control"
                            multiple
                            onChange={photofile}
                            accept=".jpg,.jpeg,.png,.pdf"
                          />
                        </div>

                        {uphoto.map((data, i) => {
                          return (
                            <div className="col-md-6" key={i}>
                              <p>{data.name}</p>
                            </div>
                          );
                        })}
                        {perrorMsg.map((data, i) => {
                          return (
                            <span className="errortext" key={i}>
                              {data}
                            </span>
                          );
                        })}
                      </>
                    )}
                    {imagetype === "Videos" && (
                      <>
                        <div className="form-group">
                          <label className="mb-2">
                            File Type <span className="errortext"> *</span>
                          </label>
                          <select
                            className="form-control custom-select"
                            value={filetype}
                            onChange={(e) => setFileType(e.target.value)}
                          >
                            <option value="" defaultValue disabled>
                              --Select File Type--
                            </option>
                            <option value="URL">URL</option>
                            <option value="Video">Video</option>
                          </select>
                        </div>
                        {filetype !== "" && (
                          <div className="text-right">
                            <a
                              onClick={handleAddLink}
                              className="btn btn-success"
                            >
                              Add {filetype}
                            </a>
                          </div>
                        )}

                        {links.map((link, index) => (
                          <Row className="row-sm mx-0" key={index}>
                            <Col lg={11} md={11}>
                              {filetype === "URL" && (
                                <div className="form-group">
                                  <label className="mb-2">
                                    Enter URL{" "}
                                    <span className="errortext"> *</span>
                                  </label>
                                  <input
                                    type="text"
                                    placeholder="Enter URL"
                                    className="form-control"
                                    value={link.link}
                                    onChange={(e) =>
                                      handleLinkChange(
                                        index,
                                        "link",
                                        e.target.value
                                      )
                                    }
                                  ></input>
                                </div>
                              )}
                              {filetype === "Video" && (
                                <div className="form-group">
                                  <label className="mb-2">
                                    Upload Video{" "}
                                    <span className="errortext"> *</span>
                                  </label>
                                  <input
                                    type="file"
                                    className="form-control"
                                    accept=".mp3,.mp4,.wav,.mkv"
                                    onChange={(e) => thumbfile(e, index)}
                                  />
                                  {link.timageerr !== "" && (
                                    <span className="errortext">
                                      {link.timageerr}
                                    </span>
                                  )}
                                </div>
                              )}
                            </Col>

                            {index !== 0 && (
                              <Col lg={1} md={1}>
                                <div className="form-group mt-6">
                                  <a
                                    className="btn btn-danger"
                                    onClick={() => handleDeleteLink(index)}
                                  >
                                    <i className="fa fa-trash"></i>
                                  </a>
                                </div>
                              </Col>
                            )}
                          </Row>
                        ))}
                      </>
                    )}

                    {ferror !== "" && (
                      <span className="errortext">{ferror}</span>
                    )}
                  </Modal.Body>
                  <Modal.Footer>
                    <button className="btn btn-success" onClick={submitfiles}>
                      Submit
                    </button>
                    <button onClick={uploadclose} className="btn btn-gray">
                      Cancel
                    </button>
                  </Modal.Footer>
                </Modal>

                <Modal show={ushow} size="xl" onHide={udetclose}>
                  <Modal.Header>
                    <h4> {udetail.file_upload_type}</h4>
                  </Modal.Header>
                  <Modal.Body>
                    <Row className="row-sm mx-0">
                      <Col lg={12} md={12}>
                        <div className="form-group">
                          {udetail.file_type === "URL" && (
                            <iframe
                              width="100%"
                              height="300"
                              src={udetail.filename_or_url}
                              frameBorder="0"
                              allowFullScreen
                              title="Embedded youtube"
                            />
                          )}

                          {udetail.file_type === "Video" && (
                            <video controls width="100%" height="300">
                              <source
                                src={upath + udetail.filename_or_url}
                                type="video/mp4"
                              />
                            </video>
                          )}

                          {udetail.file_type === "PDF" && (
                            <iframe
                              width="100%"
                              height="400"
                              src={upath + udetail.filename_or_url}
                              allowFullScreen
                            />
                          )}

                          {udetail.file_type === "Image" && (
                            <img
                              src={upath + udetail.filename_or_url}
                              alt="Photo"
                              width="100%"
                            />
                          )}
                        </div>
                      </Col>
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <a
                      className="btn btn-success me-2"
                      href={upath + udetail.filename_or_url}
                      download={upath + udetail.filename_or_url}
                      target="_blank"
                    >
                      Download
                    </a>
                    <a className="btn btn-danger" onClick={udetclose}>
                      Close
                    </a>
                  </Modal.Footer>
                </Modal>

                {urlhead !== "paymentdetail" &&
                  localStorage.getItem("Role") !== "8" && (
                    <>
                      {/* {maplist.length !== 0 && (
                        <>
                          <hr />
                          <h4>Mapped Detail</h4>
                          <div className="table-responsive">
                            <Table bordered>
                              <thead>
                                <tr>
                                  <th>Tournament</th>
                                  <th>Date and Time</th>
                                </tr>
                              </thead>
                              <tbody>
                                {maplist.map((data, i) => {
                                  return (
                                    <tr key={i}>
                                      <td>{data.meet_name} </td>
                                      <td>
                                        {moment(data.created_at).format(
                                          "DD-MM-yyyy h:mm:ss A"
                                        )}{" "}
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </Table>
                          </div>
                        </>
                      )} */}
                      {/* <hr />

                      <h4>Tournament List</h4>
                      <div className="ag-theme-alpine ag-style">
                        <AgGridReact
                          columnDefs={columnDefs}
                          rowData={filterProduct}
                          pagination="true"
                          paginationPageSize="10"
                          sortingOrder={sorting}
                          suppressExcelExport={true}
                          suppressDragLeaveHidesColumns={true}
                        />
                      </div> */}
                    </>
                  )}

                {urlhead === "paymentdetail" && (
                  <>
                    <hr />
                    <h4>Payment Details</h4>

                    <div className="row tournamentitem">
                      <div className="col-md-12">
                        <div className="details-group">
                          <div className="row">
                            <div className="col-lg-2 col-md-6">
                              <b className="text-inverse">Tournament Name</b>
                            </div>
                            <div className="col-lg-10 col-md-6">
                              <span className="text-inverse">{tname}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="details-group">
                          <div className="row">
                            <div className="col-md-4">
                              <b className="text-inverse">Order ID</b>
                            </div>
                            <div className="col-md-8">
                              <span className="text-inverse">{ordid}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="details-group">
                          <div className="row">
                            <div className="col-md-4">
                              <b className="text-inverse">Payment ID</b>
                            </div>
                            <div className="col-md-8">
                              <span className="text-inverse">{payid}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="details-group">
                          <div className="row">
                            <div className="col-md-4">
                              <b className="text-inverse">Payment Date</b>
                            </div>
                            <div className="col-md-8">
                              <span className="text-inverse">{paydate}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="details-group">
                          <div className="row">
                            <div className="col-md-4">
                              <b className="text-inverse">Payment Status</b>
                            </div>
                            <div className="col-md-8">
                              <span className="text-inverse">{payst}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="details-group">
                          <div className="row">
                            <div className="col-md-4">
                              <b className="text-inverse">Amount</b>
                            </div>
                            <div className="col-md-8">
                              <span className="text-inverse">{payamt}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {spclist.length !== 0 && (
                  <>
                    <h4>Sports Category Details</h4>
                    <div className="details-group refereebox deletereferee">
                      <div className="row">
                        {spclist.map((data, i) => {
                          return (
                            <div className="col-md-3 align-self-center" key={i}>
                              <div className="form-group">
                                <h4 className="mb-1">{data.sports_category}</h4>
                                <h4 className="text-gray mb-0">
                                  {data.age_category_name}
                                </h4>
                                <h5 className="text-success mb-0">
                                  {data.sub_category_name}
                                </h5>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                    <hr />
                  </>
                )}
                {flist.length !== 0 && (
                  <>
                    <h4>Registration Form Details</h4>
                    <div className="row">
                      {flist.map((item, index) => {
                        return (
                          <div className="col-lg-3 col-md-6" key={index}>
                            <div className="services-three__card">
                              <a
                                className="services-three__card__image"
                                onClick={() =>
                                  handlepop(
                                    item.form_name,
                                    item.form_description,
                                    item.form_file
                                  )
                                }
                              >
                                <img
                                  src={fpath + item.form_file}
                                  width="150px"
                                  height="150px"
                                  alt="business loan"
                                />
                                <img
                                  src={fpath + item.form_file}
                                  width="150px"
                                  height="150px"
                                  alt="business loan"
                                />
                                <span className="services-three__card__overlay"></span>
                              </a>

                              <div className="services-one__card__content">
                                <h4 className="text-success">
                                  {item.form_name}
                                </h4>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </>
                )}

                {urlhead !== "tournamentplayer" && (
                  <div className="card-footer text-right border-top">
                    {status === 1 && localStorage.getItem("Role") === "1" && (
                      <a
                        className="btn btn-danger me-2"
                        title="Block Player"
                        onClick={blockShow}
                      >
                        Block
                      </a>
                    )}
                    {status === 3 && localStorage.getItem("Role") === "1" && (
                      <a
                        className="btn btn-success me-2"
                        title="UnBlock Player"
                        onClick={unblockShow}
                      >
                        Un Block
                      </a>
                    )}
                    {localStorage.getItem("Role") === "1" &&
                      urlhead !== "paymentdetail" && (
                        <a
                          onClick={() => editlist(1)}
                          title="Edit Player"
                          className="btn btn-secondary me-2"
                        >
                          Edit
                        </a>
                      )}
                    {(localStorage.getItem("Role") === "3" || localStorage.getItem("Role") === "4" || localStorage.getItem("Role") === "7") && (
                      <a
                        onClick={() => editlist(1)}
                        title="Edit Player"
                        className="btn btn-secondary me-2"
                      >
                        Edit
                      </a>
                    )}

                  </div>
                )}

                {urlhead === "tournamentplayer" && (
                  <div className="card-footer text-right border-top">
                    {localStorage.getItem("Role") === "1" && (
                      <a
                        onClick={() => editlist(2)}
                        title="Edit Player"
                        className="btn btn-secondary me-2"
                      >
                        Edit
                      </a>
                    )}
                  </div>
                )}

                <Modal show={bshow} size="large">
                  <Modal.Header>
                    <h5>Block Player Profile</h5>
                    <i
                      className="fa fa-window-close fa-lg"
                      onClick={blockClose}
                      aria-hidden="true"
                    ></i>
                  </Modal.Header>
                  <Modal.Body className="mod-body">
                    <div>
                      <div className="rep__container">
                        <div className="col-lg">
                          <p>Reason</p>
                          <select
                            className="form-control"
                            value={rreason}
                            onChange={(e) => setRReason(e.target.value)}
                          >
                            <option value="" disabled>
                              Select Reason
                            </option>
                            {realist.map((data, i) => {
                              return (
                                <option value={data.id} key={i}>
                                  {data.reason_name}
                                </option>
                              );
                            })}
                          </select>
                          {/*<p>Remarks</p>
                         <Form.Control
                          as="textarea"
                          rows={3}
                          placeholder="Enter the remarks"
                          onChange={(e) => {
                            setRemarks(e.target.value);
                          }}
                        ></Form.Control> */}
                        </div>
                      </div>
                    </div>
                    <br />
                  </Modal.Body>
                  <Modal.Footer>
                    <button className="btn btn-danger" onClick={blockathlete}>
                      Block
                    </button>
                    <button onClick={blockClose} className="btn btn-gray">
                      Cancel
                    </button>
                  </Modal.Footer>
                </Modal>

                <Modal show={ubshow} size="large">
                  <Modal.Header>
                    <h6 className="rep-head">UnBlock Player Profile</h6>
                    <i
                      className="fa fa-window-close fa-lg"
                      onClick={unblockClose}
                      aria-hidden="true"
                    ></i>
                  </Modal.Header>
                  <Modal.Body className="mod-body">
                    <div>
                      <div className="rep__container">
                        <div className="col-lg">
                          <p>Reason</p>
                          <select
                            value={rreason}
                            onChange={(e) => setRReason(e.target.value)}
                          >
                            <option value="" disabled>
                              Select Reason
                            </option>
                            {realist.map((data, i) => {
                              return (
                                <option value={data.id} key={i}>
                                  {data.reason_name}
                                </option>
                              );
                            })}
                          </select>
                          {/* <p>Remarks</p>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          placeholder="Enter the remarks"
                          onChange={(e) => {
                            setRemarks(e.target.value);
                          }}
                        ></Form.Control> */}
                        </div>
                      </div>
                    </div>
                    <br />
                  </Modal.Body>
                  <Modal.Footer>
                    <button className="btn btn-danger" onClick={unblockathlete}>
                      UnBlock
                    </button>
                    <button onClick={unblockClose} className="btn btn-gray">
                      Cancel
                    </button>
                  </Modal.Footer>
                </Modal>

                <Modal show={show} size="lg">
                  <Modal.Header>
                    <h4> Registration Form</h4>
                  </Modal.Header>
                  <Modal.Body>
                    <Row className="row-sm mx-0">
                      <Col lg={12} md={12}>
                        <div className="form-group">
                          <img src={rfile} alt="Photo" width="100%" />
                        </div>
                      </Col>

                      <Col lg={12} md={12}>
                        <div className="form-group">
                          <h4>{rname}</h4>
                        </div>
                      </Col>
                      <Col lg={12} md={12}>
                        <div className="form-group">
                          <p>{rdesc}</p>
                        </div>
                      </Col>
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <a className="btn btn-danger" onClick={imageclose}>
                      Close
                    </a>
                  </Modal.Footer>
                </Modal>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

{
  /* <Modal show={mshow} size="xl">
                <Modal.Header>
                  <h5>Merge Player Details</h5>
                  <i
                    className="fa fa-window-close fa-lg"
                    onClick={mergeClose}
                    aria-hidden="true"
                  ></i>
                </Modal.Header>
                <Modal.Body className="mod-body">
                  <div className="table-responsive mt-2">
                    <Table bordered>
                      <tbody>
                        <tr>
                          <th>
                            <b>Username</b>
                            <br />
                            <span className="font-weight-bold text-muted">
                              {uname}
                            </span>
                          </th>
                          {simlist.map((data, i) => {
                            return (
                              <>
                                {data.check === true && (
                                  <td key={i}>
                                    <input
                                      type="radio"
                                      className="me-2"
                                      checked={data.radiouser}
                                      onClick={() =>
                                        mradiouser(i, data.username)
                                      }
                                    />
                                    {data.username}
                                  </td>
                                )}
                              </>
                            );
                          })}
                        </tr>
                        <tr>
                          <th>
                            <b>Fullname</b>
                            <br />
                            <span className="font-weight-bold text-muted">
                              {fname}
                            </span>
                          </th>
                          {simlist.map((data, i) => {
                            return (
                              <>
                                {data.check === true && (
                                  <td key={i}>
                                    <input
                                      type="radio"
                                      className="me-2"
                                      checked={data.radioname}
                                      onClick={() =>
                                        mradioname(i, data.first_name)
                                      }
                                    />
                                    {data.first_name}
                                  </td>
                                )}
                              </>
                            );
                          })}
                        </tr>
                        <tr>
                          <th>
                            <b>Gender </b>
                            <br />
                            <span className="font-weight-bold text-muted">
                              {gender}
                            </span>
                          </th>
                          {simlist.map((data, i) => {
                            return (
                              <>
                                {data.check === true && (
                                  <td key={i}>
                                    <input
                                      type="radio"
                                      className="me-2"
                                      checked={data.radiogender}
                                      onClick={() =>
                                        mradiogender(i, data.gender)
                                      }
                                    />
                                    {data.gender}
                                  </td>
                                )}
                              </>
                            );
                          })}
                        </tr>
                        <tr>
                          <th>
                            <b>DOB</b>
                            <br />
                            <span className="font-weight-bold text-muted">
                              {dob}
                            </span>
                          </th>
                          {simlist.map((data, i) => {
                            return (
                              <>
                                {data.check === true && (
                                  <td key={i}>
                                    <input
                                      type="radio"
                                      className="me-2"
                                      checked={data.radiodob}
                                      onClick={() =>
                                        mradiodob(i, data.date_of_birth)
                                      }
                                    />
                                    {moment(data.date_of_birth).format(
                                      "DD-MM-yyyy"
                                    )}
                                  </td>
                                )}
                              </>
                            );
                          })}
                        </tr>
                        <tr>
                          <th>
                            <b>Contact</b>
                            <br />
                            <span className="font-weight-bold text-muted">
                              {mobno}
                            </span>
                          </th>
                          {simlist.map((data, i) => {
                            return (
                              <>
                                {data.check === true && (
                                  <td key={i}>
                                    <input
                                      type="radio"
                                      className="me-2"
                                      checked={data.radiomob}
                                      onClick={() =>
                                        mradiomob(i, data.mobile_no)
                                      }
                                    />
                                    {data.mobile_no}
                                  </td>
                                )}
                              </>
                            );
                          })}
                        </tr>
                        <tr>
                          <th>
                            <b>Email</b>
                            <br />
                            <span className="font-weight-bold text-muted">
                              {email}
                            </span>
                          </th>
                          {simlist.map((data, i) => {
                            return (
                              <>
                                {data.check === true && (
                                  <td key={i}>
                                    <input
                                      type="radio"
                                      className="me-2"
                                      checked={data.radioemail}
                                      onClick={() =>
                                        mradioemail(i, data.email_id)
                                      }
                                    />
                                    {data.email_id}
                                  </td>
                                )}
                              </>
                            );
                          })}
                        </tr>
                        <tr>
                          <th>
                            <b>School</b>
                            <br />{" "}
                            <span className="font-weight-bold text-muted">
                              {school}
                            </span>
                          </th>
                          {simlist.map((data, i) => {
                            return (
                              <>
                                {data.check === true && (
                                  <td key={i}>
                                    <input
                                      type="radio"
                                      className="me-2"
                                      checked={data.radiosch}
                                      onClick={() =>
                                        mradiosch(i, data.school_name)
                                      }
                                    />
                                    {data.school_name}
                                  </td>
                                )}
                              </>
                            );
                          })}
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <button className="btn btn-success" onClick={mergeplayer}>
                    Merge Player
                  </button>
                  <button onClick={mergeClose} className="btn btn-gray">
                    Cancel
                  </button>
                </Modal.Footer>
              </Modal> */
}

// if (muname !== "") {
//   if (simlist.length !== 0) {
//     for (let i = 0; i < simlist.length; i++) {
//       if (i === index) {
//         setMGender(ume);
//         simlist[i].radiogender = true;
//         setSimList([...simlist]);
//       } else {
//         simlist[i].radiogender = false;
//         setSimList([...simlist]);
//       }
//     }
//   }
// } else {
//   setErrorMsg("Please select Username (UID) of Main Player");
// }
// }
